(function () {
/**
 * Basis tool voor het afhandelen van async communicatie. Hier is eventueel nog een standaard error afhandeling tussen te hangen.
 */ /**
 * Fetches data from the given URL using a GET request.
 * 
 * @async
 * @function getUrl
 * @param {string} url - The URL to fetch data from.
 * @returns {Promise<{status: number, data: any}>} The response status and data.
 */ const $80b8792c09f43040$var$getUrl = async (url)=>{
    const options = {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8"
        }
    };
    let response = await fetch(url, options);
    let status = response.status;
    let data = await response.json();
    return {
        status: status,
        data: data
    };
};
/**
 * Sends data to the given URL using a POST request.
 * 
 * @async
 * @function postUrl
 * @param {string} url - The URL to send data to.
 * @param {Object} postData - The data to send in the body of the POST request.
 * @returns {Promise<{status: number, data: any}>} The response status and data.
 */ const $80b8792c09f43040$var$postUrl = async (url, postData)=>{
    const options = {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8"
        },
        body: JSON.stringify(postData)
    };
    let response = await fetch(url, options);
    let status = response.status;
    let data = null;
    try {
        data = await response?.json();
    } catch (error) {}
    return {
        status: status,
        data: data
    };
};
const $80b8792c09f43040$export$f8a0a232efd61230 = ()=>{
    return {
        getUrl: $80b8792c09f43040$var$getUrl,
        postUrl: $80b8792c09f43040$var$postUrl
    };
};


const $87dd73750fb93037$var$asyncHelper = (0, $80b8792c09f43040$export$f8a0a232efd61230)();
const $87dd73750fb93037$export$72faef17ae298338 = async (config)=>{
    const { data: initialData } = await $87dd73750fb93037$var$asyncHelper.getUrl(config.getApiUrl());
    let { filters: filters, results: results } = $87dd73750fb93037$var$getRelevantSearchData(initialData);
    return {
        filters: filters,
        results: results
    };
};
const $87dd73750fb93037$export$cfcc0908d6dfb8a6 = async (config, userFormData = {})=>{
    const productType = window.ortus.productType ?? "electricity";
    const baseFormData = {
        productType: productType,
        resultsOnly: false,
        pageSize: 10,
        page: 1,
        benchmark: 1
    };
    const formData = {
        ...baseFormData,
        ...userFormData
    };
    const { data: searchData } = await $87dd73750fb93037$var$asyncHelper.postUrl(`${config.getApiUrl()}calculator/energy`, formData);
    return $87dd73750fb93037$var$getRelevantSearchData(searchData);
};
const $87dd73750fb93037$var$getRelevantSearchData = (apiData)=>{
    const filters = apiData?.filters;
    const results = apiData?.offers;
    const benchmarkTariff = apiData?.benchmarkTariff;
    return {
        filters: filters,
        results: results,
        benchmarkTariff: benchmarkTariff
    };
};
const $87dd73750fb93037$export$cfce4cb39c87df1c = async (packageUrl)=>{
    const packageDetails = await $87dd73750fb93037$var$asyncHelper.getUrl(packageUrl);
    return packageDetails;
};


const $e9824b957d40652f$export$adf416f00cca6418 = (module, apiUrl = null)=>{
    const getApiUrl = ()=>{
        if (!apiUrl) throw new Error("No API URL provided");
        return apiUrl;
    };
    const getLsKey = ()=>{
        return `${module}-filters`;
    };
    return {
        getLsKey: getLsKey,
        getApiUrl: getApiUrl
    };
};


// Shared state for the postal code change flag
let $5844f3601c6aa971$var$isPostalCodeChanged = false;
const $5844f3601c6aa971$export$fd899442b799a682 = (value)=>{
    $5844f3601c6aa971$var$isPostalCodeChanged = value;
};
const $5844f3601c6aa971$export$60d251412f427c30 = ()=>{
    return $5844f3601c6aa971$var$isPostalCodeChanged;
};


let $3fd9eea943d721cb$var$filterData = null;
let $3fd9eea943d721cb$var$searchResults = null;
let $3fd9eea943d721cb$var$config;
let $3fd9eea943d721cb$var$filterForm;
let $3fd9eea943d721cb$var$updateFunction;
let $3fd9eea943d721cb$var$storedPagingButton = "";
let $3fd9eea943d721cb$var$settings = {
    filterForm: null
};
const $3fd9eea943d721cb$export$be042cd8f6323421 = async ({ apiUrl: apiUrl, filterForm: filterForm, pagingButton: pagingButton })=>{
    $3fd9eea943d721cb$var$config = (0, $e9824b957d40652f$export$adf416f00cca6418)("wj", apiUrl);
    $3fd9eea943d721cb$var$settings.filterForm = filterForm;
    $3fd9eea943d721cb$var$storedPagingButton = pagingButton;
    let formData = $3fd9eea943d721cb$var$getFilterFormData();
    let { filters: filters, results: results, benchmarkTariff: benchmarkTariff } = await (0, $87dd73750fb93037$export$cfcc0908d6dfb8a6)($3fd9eea943d721cb$var$config, formData);
    const pageInput = filterForm.querySelector('input[name="page"]');
    setTimeout(()=>{
        pageInput.value = 1;
        $3fd9eea943d721cb$var$setFormInputWatcher(pageInput);
    }, 200);
    pagingButton.removeAttribute("hidden");
    if (!pagingButton.dataset.vxPagingBound) {
        pagingButton.addEventListener("click", $3fd9eea943d721cb$var$handlePagingButtonClick);
        pagingButton.dataset.vxPagingBound = "true";
    }
    return {
        comparisonData: {
            filters: filters,
            results: results,
            benchmarkTariff: benchmarkTariff,
            formData: formData
        },
        tooling: {
            onResultsUpdated: $3fd9eea943d721cb$var$onResultsUpdated
        }
    };
};
const $3fd9eea943d721cb$var$handlePagingButtonClick = async ()=>{
    const pageInput = $3fd9eea943d721cb$var$settings.filterForm.querySelector('input[name="page"]');
    const currentPage = parseInt(pageInput.value) || 1;
    pageInput.value = currentPage + 1;
    $3fd9eea943d721cb$var$onFiltersChanged({
        skipTimeout: true
    });
};
const $3fd9eea943d721cb$var$setFormInputWatcher = (pageInput)=>{
    const inputs = $3fd9eea943d721cb$var$settings.filterForm.querySelectorAll("input, select");
    Array.from(inputs).filter((i)=>{
        return i.dataset.skipSubmit !== "true";
    }).filter((i)=>{
        return i.dataset.ignore !== "true";
    }).forEach((input)=>{
        input.addEventListener("change", ()=>{
            pageInput.value = 1;
            $3fd9eea943d721cb$var$onFiltersChanged({
                skipTimeout: false
            });
        });
    });
    const priceDisplayInput = $3fd9eea943d721cb$var$settings.filterForm.querySelector("[name=priceDisplay]");
    $3fd9eea943d721cb$var$setPriceDisplayChangeHandler(priceDisplayInput);
};
const $3fd9eea943d721cb$var$setPriceDisplayChangeHandler = (priceDisplayInput)=>{
    priceDisplayInput.addEventListener("change", ()=>{
        const selectedPriceDisplay = priceDisplayInput.value;
        const wjPackageElements = document.querySelectorAll("wj-package");
        Array.from(wjPackageElements).forEach((element)=>{
            element.dataset.priceDisplay = selectedPriceDisplay;
        });
    });
};
const $3fd9eea943d721cb$var$getFilterFormData = ()=>{
    const inputsArr = Array.from($3fd9eea943d721cb$var$settings.filterForm.querySelectorAll("input, select"));
    const formProps = $3fd9eea943d721cb$var$getUniqueFormProps(inputsArr);
    const filterFormData = {};
    inputsArr.filter((i)=>!i.dataset.formProp).forEach((input)=>{
        let { value: value, checked: checked, name: name, type: type } = input;
        if (type == "radio") {
            if (checked) {
                if (value === "true") value = true;
                else if (value === "false") value = false;
                filterFormData[name] = value;
            }
        } else if (type == "checkbox") filterFormData[name] = checked;
        else filterFormData[name] = value;
    });
    // Reset benchmark to -1 ONLY if postal code has changed
    if ((0, $5844f3601c6aa971$export$60d251412f427c30)()) {
        filterFormData.benchmark = "-1"; // Reset benchmark
        filterFormData[""] = false;
    }
    formProps.forEach((formProp)=>{
        let myValue = [];
        myValue = inputsArr.filter((i)=>i.dataset.formProp === formProp && i.checked).map((input)=>{
            let { value: value } = input;
            return value;
        });
        filterFormData[formProp] = myValue.join(",");
    });
    return filterFormData;
};
const $3fd9eea943d721cb$var$getUniqueFormProps = (inputsArr)=>{
    // TODO  check if needed
    const formProps = [];
    inputsArr.map((i)=>{
        const formProp = i.dataset.formProp;
        if (formProp && formProps.indexOf(formProp) === -1) formProps.push(formProp);
    });
    return formProps;
};
let $3fd9eea943d721cb$var$searchTimeout = 1;
const $3fd9eea943d721cb$var$resultsWrapper = document.getElementById("packageResults");
const $3fd9eea943d721cb$var$savingsWrapper = document.querySelector(".js-saving-banner");
const $3fd9eea943d721cb$var$onFiltersChanged = async ({ skipTimeout: skipTimeout = false })=>{
    if ($3fd9eea943d721cb$var$searchTimeout) {
        clearTimeout($3fd9eea943d721cb$var$searchTimeout);
        $3fd9eea943d721cb$var$searchTimeout = null;
    }
    $3fd9eea943d721cb$var$resultsWrapper.style.filter = "blur(5px)";
    $3fd9eea943d721cb$var$savingsWrapper.style.filter = "blur(5px)";
    const timeoutDuration = skipTimeout ? 0 : 800;
    $3fd9eea943d721cb$var$searchTimeout = setTimeout(async ()=>{
        $3fd9eea943d721cb$var$storedPagingButton.setAttribute("disabled", "disabled");
        let formValidation = $3fd9eea943d721cb$var$formIsValid($3fd9eea943d721cb$var$settings.filterForm);
        if (formValidation.isValid) await $3fd9eea943d721cb$var$executeSearch();
        else console.log(formValidation.errors);
        $3fd9eea943d721cb$var$storedPagingButton.removeAttribute("disabled");
        $3fd9eea943d721cb$var$resultsWrapper.style.filter = "";
        $3fd9eea943d721cb$var$savingsWrapper.style.filter = "";
    }, timeoutDuration);
};
const $3fd9eea943d721cb$var$formIsValid = (form)=>{
    let isValid = true;
    let errors = [];
    const hiddenLocationInput = form.querySelector("#hiddenLocationInput").value;
    if (hiddenLocationInput == "") {
        errors.push("Kein addresse gefunden. Bitte versuchen Sie es erneut.");
        isValid = false;
    }
    return {
        isValid: isValid,
        errors: errors
    };
};
const $3fd9eea943d721cb$var$executeSearch = async (appendingData)=>{
    // only execute the search if the postal code has not changed
    if (!(0, $5844f3601c6aa971$export$60d251412f427c30)()) {
        let searchData = $3fd9eea943d721cb$var$getFilterFormData();
        searchData.resultsOnly = true;
        let formData = {
            ...searchData,
            ...appendingData
        };
        let { filters: filters, results: results, benchmarkTariff: benchmarkTariff } = await (0, $87dd73750fb93037$export$cfcc0908d6dfb8a6)($3fd9eea943d721cb$var$config, searchData);
        $3fd9eea943d721cb$var$updateFunction({
            filters: filters,
            results: results,
            benchmarkTariff: benchmarkTariff,
            formData: formData
        });
        (0, $5844f3601c6aa971$export$fd899442b799a682)(false); // Reset the flag
    }
};
const $3fd9eea943d721cb$var$onResultsUpdated = (updateData)=>{
    $3fd9eea943d721cb$var$updateFunction = updateData;
};


const $6a437dcba1085657$var$renderPackages = (searchResultsData)=>{
    const priceDisplay = searchResultsData.formData.priceDisplay;
    searchResultsData.data.forEach((element)=>{
        let myElement = document.createElement("wj-package");
        myElement.dataset.packageElement = JSON.stringify(element);
        myElement.dataset.priceDisplay = priceDisplay;
        searchResultsData.target.appendChild(myElement);
    });
};
var $6a437dcba1085657$export$2e2bcd8739ae039 = $6a437dcba1085657$var$renderPackages;



const $6be05c95c886a85c$var$asyncHelper = (0, $80b8792c09f43040$export$f8a0a232efd61230)();
const $6be05c95c886a85c$export$9f208cdfec86ac41 = ()=>{
    const ortusApi = window.ortus.api;
    /**
   * @method getForm
   * @async
   * @param {string} tariffId - The ID of the tariff.
   * @returns {Promise<Object>} The status and data of the form.
   */ const getForm = async (tariffId)=>{
        const url = `${ortusApi}signupform?tariffId=${tariffId}`;
        try {
            const { status: status, data: data } = await $6be05c95c886a85c$var$asyncHelper.getUrl(url);
            return {
                status: status,
                data: data
            };
        } catch (e) {
            console.log(e);
        }
    };
    /**
   * @method getTariffData
   * @async
   * @param {string} tariffId - The ID of the tariff.
   * @param {string} energyType - The type of energy.
   * @param {string} query - The query string.
   * @returns {Promise<Object>} The status and data of the tariff.
   */ const getTariffData = async (tariffId, energyType, query)=>{
        const detailUrl = `https://www.verivox.de/servicehook/offers/${energyType}/info/${query}/${tariffId}?partnerId=2624`;
        const proxyUrl = `${ortusApi}package/detail`;
        const { status: status, data: data } = await $6be05c95c886a85c$var$asyncHelper.postUrl(proxyUrl, {
            packageDetailsUri: detailUrl
        });
        return {
            status: status,
            data: data
        };
    };
    /**
   * @method getStreetsForPostCode
   * @async
   * @param {string} postCode - The postal code.
   * @param {string} city - The city name.
   * @returns {Promise<Array<string>>} A list of street names.
   */ const getStreetsForPostCode = async (postCode, city)=>{
        city = decodeURIComponent(city).split(" / ")[0].replace(/\//g, "-").trim();
        let url = `${ortusApi}signupform/streets?postCode=${postCode}&cityName=${city}`;
        const data = await fetch(url).then((response)=>response.json());
        const streets = data.map((s)=>s.Name);
        return streets;
    };
    /**
   * @method getCityDistricts
   * @async
   * @param {string} postCode - The postal code.
   * @param {string} [energyType='electricity'] - The type of energy.
   * @returns {Promise<Object>} The status and data of the city parts.
   */ // TODO: use alternative endpoint for getting cities without specifying a producttype
    const getCityDistricts = async (postCode, energyType = "electricity")=>{
        const url = `${ortusApi}location/${postCode}/${energyType}`;
        const { status: status, data: data } = await (0, $80b8792c09f43040$export$f8a0a232efd61230)().getUrl(url);
        return {
            status: status,
            data: data
        };
    };
    /**
   * @method getIsValidIBAN
   * @async
   * @param {string} iban - The IBAN to validate.
   * @returns {Promise<Object>} The status and data of the IBAN validation.
   */ const getIsValidIBAN = async (iban)=>{
        const url = `${ortusApi}signupform/iban?iBan=${iban}`;
        // Test for success: DE91500105174885792721
        // Test to fail: GT47195126765214373483528657
        return await $6be05c95c886a85c$var$asyncHelper.getUrl(url);
    };
    /**
   * @method getBenchmark
   * @async
   * @param {string} [product='Electricity'] - The product type.
   * @param {string} [profile='h0'] - The profile type.
   * @param {string} [postCode='20095'] - The postal code.
   * @param {string} [locationId='23232'] - The location ID.
   * @param {number} [totalUsage=2500] - The total usage.
   * @param {number} [heatingPower=0] - The heating power.
   * @returns {Promise<Object>} The status and data of the benchmark.
   */ const getBenchmark = async (product = "Electricity", profile = "h0", postCode = "20095", locationId = "23232", totalUsage = 2500, heatingPower = 0)=>{
        const url = `${ortusApi}benchmarks?product=${product}&profile=${profile}&postCode=${postCode}&locationId=${locationId}&totalUsage=${totalUsage}&heatingPower=${heatingPower}`;
        return await $6be05c95c886a85c$var$asyncHelper.getUrl(url);
    };
    /**
   * @method getBenchmarkSuppliers
   * @async
   * @param {string} [product='Electricity'] - The product type.
   * @param {string} [profile='h0'] - The profile type.
   * @param {string} [postCode='20095'] - The postal code.
   * @param {string} [locationId='23232'] - The location ID.
   * @param {number} [totalUsage=2500] - The total usage.
   * @param {number} [heatingPower=0] - The heating power.
   * @returns {Promise<Array<Object>>} A list of suppliers.
   */ const getBenchmarkSuppliers = async (product = "Electricity", profile = "h0", postCode = "20095", locationId = "23232", totalUsage = 2500, heatingPower = 0)=>{
        const { data: data, status: status } = await getBenchmark(product, profile, postCode, locationId, totalUsage, heatingPower);
        if (status !== 200) throw new Error("Could not fetch suppliers");
        const providers = data.providers.map((p)=>{
            return {
                name: p.content.text,
                label: p.content.text,
                id: p.id,
                tariffs: p.products
            };
        });
        return providers;
    };
    /**
   * @method getSuppliers
   * @async
   * @param {string} productType - electricity or gas 
   * @returns {Promise<Array<Object>>}  The status and data of the list of suppliers
   */ const getSuppliers = async (productType = "Electricity")=>{
        const url = `${ortusApi}providers/${productType}`;
        const apiResult = await $6be05c95c886a85c$var$asyncHelper.getUrl(url);
        const providers = apiResult.data.map((p)=>{
            return {
                name: p.name,
                label: p.name,
                id: p.id
            };
        });
        return providers;
    };
    /**
   * @method storeData
   * @async
   * @param {Object} postData - The data to post.
   * @param {string} productType - The type of product.
   * @param {string} tariffId - The ID of the tariff.
   * @returns {Promise<Object>} The status and data of the stored data.
   */ const storeData = async (postData, productType, tariffId)=>{
        postData.connectionData.currentProvider = postData.connectionData.currentProvider?.name ?? postData.connectionData.currentProvider;
        if (postData.connectionData.currentProvider === "Andere") postData.connectionData.currentProvider = postData.connectionData.otherProvider;
        const url = `${ortusApi}signuprequest/${productType}/${tariffId}`;
        const { status: status, data: data } = await $6be05c95c886a85c$var$asyncHelper.postUrl(url, postData);
        return {
            status: status,
            data: data
        };
    };
    /**
   * @method previewPdf
   * @async
   * @param {Object} postData - The data to post.
   * @param {string} productType - The type of product.
   * @param {string} tariffId - The ID of the tariff.
   * @returns {Promise<Object>} The status and data of the PDF preview.
   */ const previewPdf = async (postData, productType, tariffId)=>{
        const url = `${ortusApi}contractPreview/${tariffId}`;
        const { data: data, status: status } = await $6be05c95c886a85c$var$asyncHelper.postUrl(url, postData);
        return {
            status: status,
            data: data
        };
    };
    return {
        getCityDistricts: getCityDistricts,
        getBenchmarkSuppliers: getBenchmarkSuppliers,
        getSuppliers: getSuppliers,
        getStreetsForPostCode: getStreetsForPostCode,
        getBenchmark: getBenchmark,
        getForm: getForm,
        getTariffData: getTariffData,
        getIsValidIBAN: getIsValidIBAN,
        storeData: storeData,
        previewPdf: previewPdf
    };
};


const $9ad4a19502edd57e$export$394e73e0cf9f022a = async ()=>{
    const ortusApi = window.ortus.api;
    const wrapper = document.querySelector(".js-comparison-wrapper");
    const filterForm1 = document.getElementById("filterForm");
    const pagingButton = document.getElementById("pagingButton");
    if (!filterForm1) {
        console.info("No form supplied. Cancelling initialisation");
        return;
    }
    const { postCode: postCode, city: city, location: location1 } = $9ad4a19502edd57e$var$getUrlParameters();
    if (filterForm1.querySelector("#hiddenLocationInput").value === "") filterForm1.querySelector("#hiddenLocationInput").value = location1;
    const searchTool = await (0, $3fd9eea943d721cb$export$be042cd8f6323421)({
        apiUrl: ortusApi,
        filterForm: filterForm1,
        pagingButton: pagingButton
    });
    searchTool.tooling.onResultsUpdated($9ad4a19502edd57e$var$handleNewData);
    $9ad4a19502edd57e$var$setSupplierAndTariffSelects(searchTool.comparisonData.benchmarkTariff);
    setTimeout(()=>{
        $9ad4a19502edd57e$var$handleNewData(searchTool.comparisonData);
        wrapper.querySelector("bc-loading-icon")?.remove();
    }, 1);
};
const $9ad4a19502edd57e$var$setSupplierAndTariffSelects = async (benchmarkTariff)=>{
    let productType = filterForm.querySelector("#hiddenProductType").value;
    let locationId = filterForm.querySelector("#hiddenLocationInput").value;
    let postCode = filterForm.querySelector("#postalCode").value;
    let usage = filterForm.querySelector("#hiddenUsageInput").value;
    const suppliers = await (0, $6be05c95c886a85c$export$9f208cdfec86ac41)().getBenchmarkSuppliers(productType, undefined, postCode, locationId, usage);
    let benchmarkSupplierId = null;
    let benchmarkTariffId = null;
    if (benchmarkTariff) {
        benchmarkSupplierId = benchmarkTariff.provider?.id;
        benchmarkTariffId = benchmarkTariff.id;
    }
    let supplierSelect = document.getElementById("previousSupplier");
    let tariffSelect = document.getElementById("previousTariff");
    supplierSelect.innerHTML = "";
    supplierSelect.innerHTML += `<option value="">Bitte wahle dein Anbieter aus</option>`;
    suppliers.forEach((supplier)=>{
        let isSelected = supplier.id == benchmarkSupplierId ? "selected" : "";
        supplierSelect.innerHTML += `<option ${isSelected} value="${supplier.id}" data-tariffs='${JSON.stringify(supplier.tariffs)}' value="${supplier.name}">${supplier.name}</option>`;
    });
    supplierSelect.addEventListener("change", (e)=>{
        let selectedSupplierId = e.target.value;
        if (selectedSupplierId) {
            let selectedSupplier = suppliers.find((s)=>s.id === selectedSupplierId);
            tariffSelect.innerHTML = "";
            tariffSelect.innerHTML += `<option value="-1">Bitte wahle dein Tarif aus</option>`;
            selectedSupplier.tariffs.forEach((tariff)=>{
                let isSelected = tariff.id == benchmarkTariffId ? "selected" : "";
                tariffSelect.innerHTML += `<option ${isSelected} value="${tariff.id}">${tariff.content.text}</option>`;
            });
        }
    });
    if (benchmarkSupplierId) supplierSelect.dispatchEvent(new Event("change", {
        bubbles: true
    }));
};
const $9ad4a19502edd57e$var$getUrlParameters = ()=>{
    const params = Object.fromEntries(new URLSearchParams(location.search));
    return params;
};
const $9ad4a19502edd57e$var$euroDisplay = (amount)=>{
    if (isNaN(amount) && typeof amount === "string" && amount.indexOf(",") > -1) amount = amount.replace(/\,/g, ".");
    return parseFloat(amount).toFixed(2).replace(".", ",") + "&nbsp;&euro;";
};
const $9ad4a19502edd57e$var$handleNewData = (searchData)=>{
    let results, benchmarkTariff, formData;
    if (searchData) ({ results: results, benchmarkTariff: benchmarkTariff, formData: formData } = searchData);
    if (!results) return;
    const resultsContainer = document.getElementById("packageResults");
    if (benchmarkTariff) {
        const savingAmount = results[0]?.cost.savings.amount;
        const savingAmountRounded = Math.round(savingAmount);
        if (savingAmount > 20) {
            document.querySelector(".js-saving-banner__saving-amount").innerHTML = savingAmountRounded.toString() + "&nbsp;&euro;";
            document.querySelector(".js-saving-banner__benchmark-amount").innerHTML = $9ad4a19502edd57e$var$euroDisplay(benchmarkTariff.totalCostInEuro);
            document.querySelector(".js-saving-banner__benchmark-provider").innerHTML = benchmarkTariff.providerName.content.text;
            document.querySelector(".js-saving-banner__benchmark-location").innerHTML = benchmarkTariff.tariff?.content.text;
            document.querySelector(".js-saving-banner__saving-header").removeAttribute("hidden");
            document.querySelector(".js-saving-banner__saving-subtext").removeAttribute("hidden");
            document.querySelector(".js-saving-banner__low-saving-message").setAttribute("hidden", true);
        } else {
            document.querySelector(".js-saving-banner__saving-header").setAttribute("hidden", true);
            document.querySelector(".js-saving-banner__saving-subtext").setAttribute("hidden", true);
            document.querySelector(".js-saving-banner__low-saving-message").removeAttribute("hidden");
        }
        document.querySelector(".js-saving-banner").removeAttribute("hidden");
        if (!benchmarkTariff.providerName.content.text) {
            document.querySelector(".js-meta-data--default-supplier").setAttribute("hidden", true);
            document.querySelector(".js-meta-data--heatingelectricity-default-provider").setAttribute("hidden", true);
        } else document.querySelector(".js-meta-data--default-supplier").removeAttribute("hidden");
        document.querySelector(".js-meta-data--supplier").innerHTML = benchmarkTariff.providerName.content.text;
        document.querySelector(".js-meta-data--tariff").innerHTML = benchmarkTariff.tariffName.content.text;
    }
    if (window.ortus.preselectedValues?.city) document.querySelector(".js-meta-data--city").innerHTML = window.ortus.preselectedValues.city;
    if (window.ortus.preselectedValues?.energyArea) {
        let energyArea = window.ortus.preselectedValues.energyArea;
        if (energyArea === "heating") ;
        else if (energyArea === "green") document.querySelector('input[name="isGreenElectricity"][value="true"]').checked = true;
    }
    const page = parseInt(formData.page);
    const pageSize = parseInt(formData.pageSize);
    if (page == 1) resultsContainer.innerHTML = "";
    let searchResultsData = {
        data: results,
        target: resultsContainer,
        formData: formData
    };
    Array.from(document.querySelectorAll("bc-loading-icon"))?.forEach((icon)=>icon.remove());
    (0, $6a437dcba1085657$export$2e2bcd8739ae039)(searchResultsData);
};


/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $2ebca2d23ae8704c$var$t = globalThis, $2ebca2d23ae8704c$export$b4d10f6001c083c2 = $2ebca2d23ae8704c$var$t.ShadowRoot && (void 0 === $2ebca2d23ae8704c$var$t.ShadyCSS || $2ebca2d23ae8704c$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $2ebca2d23ae8704c$var$s = Symbol(), $2ebca2d23ae8704c$var$o = new WeakMap;
class $2ebca2d23ae8704c$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $2ebca2d23ae8704c$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($2ebca2d23ae8704c$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $2ebca2d23ae8704c$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $2ebca2d23ae8704c$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $2ebca2d23ae8704c$export$8d80f9cac07cdb3 = (t)=>new $2ebca2d23ae8704c$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $2ebca2d23ae8704c$var$s), $2ebca2d23ae8704c$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $2ebca2d23ae8704c$export$505d1e8739bad805(o, t, $2ebca2d23ae8704c$var$s);
}, $2ebca2d23ae8704c$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($2ebca2d23ae8704c$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $2ebca2d23ae8704c$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $2ebca2d23ae8704c$export$ee69dfd951e24778 = $2ebca2d23ae8704c$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $2ebca2d23ae8704c$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $85ef972dd7b092e7$var$i, defineProperty: $85ef972dd7b092e7$var$e, getOwnPropertyDescriptor: $85ef972dd7b092e7$var$r, getOwnPropertyNames: $85ef972dd7b092e7$var$h, getOwnPropertySymbols: $85ef972dd7b092e7$var$o, getPrototypeOf: $85ef972dd7b092e7$var$n } = Object, $85ef972dd7b092e7$var$a = globalThis, $85ef972dd7b092e7$var$c = $85ef972dd7b092e7$var$a.trustedTypes, $85ef972dd7b092e7$var$l = $85ef972dd7b092e7$var$c ? $85ef972dd7b092e7$var$c.emptyScript : "", $85ef972dd7b092e7$var$p = $85ef972dd7b092e7$var$a.reactiveElementPolyfillSupport, $85ef972dd7b092e7$var$d = (t, s)=>t, $85ef972dd7b092e7$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $85ef972dd7b092e7$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $85ef972dd7b092e7$export$53a6892c50694894 = (t, s)=>!$85ef972dd7b092e7$var$i(t, s), $85ef972dd7b092e7$var$y = {
    attribute: !0,
    type: String,
    converter: $85ef972dd7b092e7$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $85ef972dd7b092e7$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $85ef972dd7b092e7$var$a.litPropertyMetadata ??= new WeakMap;
class $85ef972dd7b092e7$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $85ef972dd7b092e7$var$y) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), r = this.getPropertyDescriptor(t, i, s);
            void 0 !== r && $85ef972dd7b092e7$var$e(this.prototype, t, r);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: h } = $85ef972dd7b092e7$var$r(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get () {
                return e?.call(this);
            },
            set (s) {
                const r = e?.call(this);
                h.call(this, s), this.requestUpdate(t, r, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $85ef972dd7b092e7$var$y;
    }
    static _$Ei() {
        if (this.hasOwnProperty($85ef972dd7b092e7$var$d("elementProperties"))) return;
        const t = $85ef972dd7b092e7$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($85ef972dd7b092e7$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($85ef972dd7b092e7$var$d("properties"))) {
            const t = this.properties, s = [
                ...$85ef972dd7b092e7$var$h(t),
                ...$85ef972dd7b092e7$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $2ebca2d23ae8704c$export$ee69dfd951e24778)(s));
        } else void 0 !== s && i.push((0, $2ebca2d23ae8704c$export$ee69dfd951e24778)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $2ebca2d23ae8704c$export$2ca4a66ec4cecb90)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$EC(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const r = (void 0 !== i.converter?.toAttribute ? i.converter : $85ef972dd7b092e7$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == r ? this.removeAttribute(e) : this.setAttribute(e, r), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), r = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $85ef972dd7b092e7$export$7312b35fbf521afb;
            this._$Em = e, this[e] = r.fromAttribute(s, t.type), this._$Em = null;
        }
    }
    requestUpdate(t, s, i) {
        if (void 0 !== t) {
            if (i ??= this.constructor.getPropertyOptions(t), !(i.hasChanged ?? $85ef972dd7b092e7$export$53a6892c50694894)(this[t], s)) return;
            this.P(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$ET());
    }
    P(t, s, i) {
        this._$AL.has(t) || this._$AL.set(t, s), !0 === i.reflect && this._$Em !== t && (this._$Ej ??= new Set).add(t);
    }
    async _$ET() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t)!0 !== i.wrapped || this._$AL.has(s) || void 0 === this[s] || this.P(s, this[s], i);
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EU();
        } catch (s) {
            throw t = !1, this._$EU(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EU() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Ej &&= this._$Ej.forEach((t)=>this._$EC(t, this[t])), this._$EU();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$85ef972dd7b092e7$export$c7c07a37856565d.elementStyles = [], $85ef972dd7b092e7$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $85ef972dd7b092e7$export$c7c07a37856565d[$85ef972dd7b092e7$var$d("elementProperties")] = new Map, $85ef972dd7b092e7$export$c7c07a37856565d[$85ef972dd7b092e7$var$d("finalized")] = new Map, $85ef972dd7b092e7$var$p?.({
    ReactiveElement: $85ef972dd7b092e7$export$c7c07a37856565d
}), ($85ef972dd7b092e7$var$a.reactiveElementVersions ??= []).push("2.0.4");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $bd6886d5707a45a8$var$n = globalThis, $bd6886d5707a45a8$var$c = $bd6886d5707a45a8$var$n.trustedTypes, $bd6886d5707a45a8$var$h = $bd6886d5707a45a8$var$c ? $bd6886d5707a45a8$var$c.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $bd6886d5707a45a8$var$f = "$lit$", $bd6886d5707a45a8$var$v = `lit$${Math.random().toFixed(9).slice(2)}$`, $bd6886d5707a45a8$var$m = "?" + $bd6886d5707a45a8$var$v, $bd6886d5707a45a8$var$_ = `<${$bd6886d5707a45a8$var$m}>`, $bd6886d5707a45a8$var$w = document, $bd6886d5707a45a8$var$lt = ()=>$bd6886d5707a45a8$var$w.createComment(""), $bd6886d5707a45a8$var$st = (t)=>null === t || "object" != typeof t && "function" != typeof t, $bd6886d5707a45a8$var$g = Array.isArray, $bd6886d5707a45a8$var$$ = (t)=>$bd6886d5707a45a8$var$g(t) || "function" == typeof t?.[Symbol.iterator], $bd6886d5707a45a8$var$x = "[ 	\n\f\r]", $bd6886d5707a45a8$var$T = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $bd6886d5707a45a8$var$E = /-->/g, $bd6886d5707a45a8$var$k = />/g, $bd6886d5707a45a8$var$O = RegExp(`>|${$bd6886d5707a45a8$var$x}(?:([^\\s"'>=/]+)(${$bd6886d5707a45a8$var$x}*=${$bd6886d5707a45a8$var$x}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $bd6886d5707a45a8$var$S = /'/g, $bd6886d5707a45a8$var$j = /"/g, $bd6886d5707a45a8$var$M = /^(?:script|style|textarea|title)$/i, $bd6886d5707a45a8$var$P = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $bd6886d5707a45a8$export$c0bb0b647f701bb5 = $bd6886d5707a45a8$var$P(1), $bd6886d5707a45a8$export$7ed1367e7fa1ad68 = $bd6886d5707a45a8$var$P(2), $bd6886d5707a45a8$export$47d5b44d225be5b4 = $bd6886d5707a45a8$var$P(3), $bd6886d5707a45a8$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $bd6886d5707a45a8$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $bd6886d5707a45a8$var$V = new WeakMap, $bd6886d5707a45a8$var$I = $bd6886d5707a45a8$var$w.createTreeWalker($bd6886d5707a45a8$var$w, 129);
function $bd6886d5707a45a8$var$N(t, i) {
    if (!$bd6886d5707a45a8$var$g(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $bd6886d5707a45a8$var$h ? $bd6886d5707a45a8$var$h.createHTML(i) : i;
}
const $bd6886d5707a45a8$var$U = (t, i)=>{
    const s = t.length - 1, e = [];
    let h, o = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", n = $bd6886d5707a45a8$var$T;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let r, l, c = -1, a = 0;
        for(; a < s.length && (n.lastIndex = a, l = n.exec(s), null !== l);)a = n.lastIndex, n === $bd6886d5707a45a8$var$T ? "!--" === l[1] ? n = $bd6886d5707a45a8$var$E : void 0 !== l[1] ? n = $bd6886d5707a45a8$var$k : void 0 !== l[2] ? ($bd6886d5707a45a8$var$M.test(l[2]) && (h = RegExp("</" + l[2], "g")), n = $bd6886d5707a45a8$var$O) : void 0 !== l[3] && (n = $bd6886d5707a45a8$var$O) : n === $bd6886d5707a45a8$var$O ? ">" === l[0] ? (n = h ?? $bd6886d5707a45a8$var$T, c = -1) : void 0 === l[1] ? c = -2 : (c = n.lastIndex - l[2].length, r = l[1], n = void 0 === l[3] ? $bd6886d5707a45a8$var$O : '"' === l[3] ? $bd6886d5707a45a8$var$j : $bd6886d5707a45a8$var$S) : n === $bd6886d5707a45a8$var$j || n === $bd6886d5707a45a8$var$S ? n = $bd6886d5707a45a8$var$O : n === $bd6886d5707a45a8$var$E || n === $bd6886d5707a45a8$var$k ? n = $bd6886d5707a45a8$var$T : (n = $bd6886d5707a45a8$var$O, h = void 0);
        const u = n === $bd6886d5707a45a8$var$O && t[i + 1].startsWith("/>") ? " " : "";
        o += n === $bd6886d5707a45a8$var$T ? s + $bd6886d5707a45a8$var$_ : c >= 0 ? (e.push(r), s.slice(0, c) + $bd6886d5707a45a8$var$f + s.slice(c) + $bd6886d5707a45a8$var$v + u) : s + $bd6886d5707a45a8$var$v + (-2 === c ? i : u);
    }
    return [
        $bd6886d5707a45a8$var$N(t, o + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        e
    ];
};
class $bd6886d5707a45a8$var$B {
    constructor({ strings: t, _$litType$: i }, s){
        let e;
        this.parts = [];
        let h = 0, o = 0;
        const n = t.length - 1, r = this.parts, [l, a] = $bd6886d5707a45a8$var$U(t, i);
        if (this.el = $bd6886d5707a45a8$var$B.createElement(l, s), $bd6886d5707a45a8$var$I.currentNode = this.el.content, 2 === i || 3 === i) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (e = $bd6886d5707a45a8$var$I.nextNode()) && r.length < n;){
            if (1 === e.nodeType) {
                if (e.hasAttributes()) for (const t of e.getAttributeNames())if (t.endsWith($bd6886d5707a45a8$var$f)) {
                    const i = a[o++], s = e.getAttribute(t).split($bd6886d5707a45a8$var$v), n = /([.?@])?(.*)/.exec(i);
                    r.push({
                        type: 1,
                        index: h,
                        name: n[2],
                        strings: s,
                        ctor: "." === n[1] ? $bd6886d5707a45a8$var$Y : "?" === n[1] ? $bd6886d5707a45a8$var$Z : "@" === n[1] ? $bd6886d5707a45a8$var$q : $bd6886d5707a45a8$var$G
                    }), e.removeAttribute(t);
                } else t.startsWith($bd6886d5707a45a8$var$v) && (r.push({
                    type: 6,
                    index: h
                }), e.removeAttribute(t));
                if ($bd6886d5707a45a8$var$M.test(e.tagName)) {
                    const t = e.textContent.split($bd6886d5707a45a8$var$v), i = t.length - 1;
                    if (i > 0) {
                        e.textContent = $bd6886d5707a45a8$var$c ? $bd6886d5707a45a8$var$c.emptyScript : "";
                        for(let s = 0; s < i; s++)e.append(t[s], $bd6886d5707a45a8$var$lt()), $bd6886d5707a45a8$var$I.nextNode(), r.push({
                            type: 2,
                            index: ++h
                        });
                        e.append(t[i], $bd6886d5707a45a8$var$lt());
                    }
                }
            } else if (8 === e.nodeType) {
                if (e.data === $bd6886d5707a45a8$var$m) r.push({
                    type: 2,
                    index: h
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = e.data.indexOf($bd6886d5707a45a8$var$v, t + 1));)r.push({
                        type: 7,
                        index: h
                    }), t += $bd6886d5707a45a8$var$v.length - 1;
                }
            }
            h++;
        }
    }
    static createElement(t, i) {
        const s = $bd6886d5707a45a8$var$w.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $bd6886d5707a45a8$var$z(t, i, s = t, e) {
    if (i === $bd6886d5707a45a8$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s.o?.[e] : s.l;
    const o = $bd6886d5707a45a8$var$st(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s.o ??= [])[e] = h : s.l = h), void 0 !== h && (i = $bd6886d5707a45a8$var$z(t, h._$AS(t, i.values), h, e)), i;
}
class $bd6886d5707a45a8$var$F {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $bd6886d5707a45a8$var$w).importNode(i, !0);
        $bd6886d5707a45a8$var$I.currentNode = e;
        let h = $bd6886d5707a45a8$var$I.nextNode(), o = 0, n = 0, r = s[0];
        for(; void 0 !== r;){
            if (o === r.index) {
                let i;
                2 === r.type ? i = new $bd6886d5707a45a8$var$et(h, h.nextSibling, this, t) : 1 === r.type ? i = new r.ctor(h, r.name, r.strings, this, t) : 6 === r.type && (i = new $bd6886d5707a45a8$var$K(h, this, t)), this._$AV.push(i), r = s[++n];
            }
            o !== r?.index && (h = $bd6886d5707a45a8$var$I.nextNode(), o++);
        }
        return $bd6886d5707a45a8$var$I.currentNode = $bd6886d5707a45a8$var$w, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $bd6886d5707a45a8$var$et {
    get _$AU() {
        return this._$AM?._$AU ?? this.v;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $bd6886d5707a45a8$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this.v = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $bd6886d5707a45a8$var$z(this, t, i), $bd6886d5707a45a8$var$st(t) ? t === $bd6886d5707a45a8$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $bd6886d5707a45a8$export$45b790e32b2810ee && this._$AR(), this._$AH = $bd6886d5707a45a8$export$45b790e32b2810ee) : t !== this._$AH && t !== $bd6886d5707a45a8$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $bd6886d5707a45a8$var$$(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $bd6886d5707a45a8$export$45b790e32b2810ee && $bd6886d5707a45a8$var$st(this._$AH) ? this._$AA.nextSibling.data = t : this.T($bd6886d5707a45a8$var$w.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $bd6886d5707a45a8$var$B.createElement($bd6886d5707a45a8$var$N(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $bd6886d5707a45a8$var$F(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $bd6886d5707a45a8$var$V.get(t.strings);
        return void 0 === i && $bd6886d5707a45a8$var$V.set(t.strings, i = new $bd6886d5707a45a8$var$B(t)), i;
    }
    k(t) {
        $bd6886d5707a45a8$var$g(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $bd6886d5707a45a8$var$et(this.O($bd6886d5707a45a8$var$lt()), this.O($bd6886d5707a45a8$var$lt()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this.v = t, this._$AP?.(t));
    }
}
class $bd6886d5707a45a8$var$G {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $bd6886d5707a45a8$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $bd6886d5707a45a8$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $bd6886d5707a45a8$var$z(this, t, i, 0), o = !$bd6886d5707a45a8$var$st(t) || t !== this._$AH && t !== $bd6886d5707a45a8$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $bd6886d5707a45a8$var$z(this, e[s + n], i, n), r === $bd6886d5707a45a8$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$bd6886d5707a45a8$var$st(r) || r !== this._$AH[n], r === $bd6886d5707a45a8$export$45b790e32b2810ee ? t = $bd6886d5707a45a8$export$45b790e32b2810ee : t !== $bd6886d5707a45a8$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $bd6886d5707a45a8$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $bd6886d5707a45a8$var$Y extends $bd6886d5707a45a8$var$G {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $bd6886d5707a45a8$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $bd6886d5707a45a8$var$Z extends $bd6886d5707a45a8$var$G {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $bd6886d5707a45a8$export$45b790e32b2810ee);
    }
}
class $bd6886d5707a45a8$var$q extends $bd6886d5707a45a8$var$G {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $bd6886d5707a45a8$var$z(this, t, i, 0) ?? $bd6886d5707a45a8$export$45b790e32b2810ee) === $bd6886d5707a45a8$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $bd6886d5707a45a8$export$45b790e32b2810ee && s !== $bd6886d5707a45a8$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $bd6886d5707a45a8$export$45b790e32b2810ee && (s === $bd6886d5707a45a8$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $bd6886d5707a45a8$var$K {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $bd6886d5707a45a8$var$z(this, t);
    }
}
const $bd6886d5707a45a8$export$8613d1ca9052b22e = {
    M: $bd6886d5707a45a8$var$f,
    P: $bd6886d5707a45a8$var$v,
    A: $bd6886d5707a45a8$var$m,
    C: 1,
    L: $bd6886d5707a45a8$var$U,
    R: $bd6886d5707a45a8$var$F,
    D: $bd6886d5707a45a8$var$$,
    V: $bd6886d5707a45a8$var$z,
    I: $bd6886d5707a45a8$var$et,
    H: $bd6886d5707a45a8$var$G,
    N: $bd6886d5707a45a8$var$Z,
    U: $bd6886d5707a45a8$var$q,
    B: $bd6886d5707a45a8$var$Y,
    F: $bd6886d5707a45a8$var$K
}, $bd6886d5707a45a8$var$Re = $bd6886d5707a45a8$var$n.litHtmlPolyfillSupport;
$bd6886d5707a45a8$var$Re?.($bd6886d5707a45a8$var$B, $bd6886d5707a45a8$var$et), ($bd6886d5707a45a8$var$n.litHtmlVersions ??= []).push("3.2.0");
const $bd6886d5707a45a8$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $bd6886d5707a45a8$var$et(i.insertBefore($bd6886d5707a45a8$var$lt(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $baeea1393dcde116$export$3f2f9f5909897157 extends (0, $85ef972dd7b092e7$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this.o = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const e = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this.o = (0, $bd6886d5707a45a8$export$b3890eb0ae9dca99)(e, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this.o?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this.o?.setConnected(!1);
    }
    render() {
        return 0, $bd6886d5707a45a8$export$9c068ae9cc5db4e8;
    }
}
$baeea1393dcde116$export$3f2f9f5909897157._$litElement$ = !0, $baeea1393dcde116$export$3f2f9f5909897157["finalized"] = !0, globalThis.litElementHydrateSupport?.({
    LitElement: $baeea1393dcde116$export$3f2f9f5909897157
});
const $baeea1393dcde116$var$f = globalThis.litElementPolyfillSupport;
$baeea1393dcde116$var$f?.({
    LitElement: $baeea1393dcde116$export$3f2f9f5909897157
});
const $baeea1393dcde116$export$f5c524615a7708d6 = {
    _$AK: (t, e, s)=>{
        t._$AK(e, s);
    },
    _$AL: (t)=>t._$AL
};
(globalThis.litElementVersions ??= []).push("4.1.0");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $b9804ca6181681c9$export$6acf61af03e62db = !1;





const $6b1247e44a1879ac$export$d9c27373510793c5 = (0, $2ebca2d23ae8704c$export$dbf350e5966cf602)`:root {
  --duration-fast: .3s;
  --duration-medium: .75s;
  --duration-slow: 1.2s;
  --swift-ease-out-timing-function: cubic-bezier(.25, .8, .25, 1);
  --swift-ease-out: all var(--duration-fast) var(--swift-ease-out-timing-function);
  --swift-ease-in-timing-function: cubic-bezier(.55, 0, .55, .2);
  --swift-ease-in: all var(--duration-fast) var(--swift-ease-in-timing-function);
  --swift-ease-in-out-timing-function: cubic-bezier(.35, 0, .25, 1);
  --swift-ease-in-out: all var(--duration-fast) var(--swift-ease-in-out-timing-function);
  --border-radius-none: 0;
  --border-radius-xs: 4px;
  --border-radius-s: 8px;
  --border-radius: 16px;
  --border-radius-m: 16px;
  --border-radius-l: 32px;
  --border-radius-xl: 999em;
  --color-white: #fff;
  --color-white--base: #fff;
  --color-grey: #757575;
  --color-grey--base: #757575;
  --color-grey--dark: #3d3d3d;
  --color-grey--light: #d4d4d4;
  --color-grey--x-light: #f7f7f7;
  --color-black: #000;
  --color-black--base: #000;
  --color-brand: #aa183f;
  --color-brand--base: #aa183f;
  --color-brand--accent: #1470d2;
  --color-brand--support: #00496b;
  --color-status--green: #008500;
  --color-status--orange: #ff9500;
  --color-status--yellow: #fc0;
  --color-status--red: red;
  --color-status--marked: #ffec99;
  --color-nav: #308271;
  --color-nav--base: #308271;
  --color-nav--hover: #297064;
  --color-gradient1--from: #4db380;
  --color-gradient1--to: #508a95;
  --color-gradient2--from: #62a38d;
  --color-gradient2--to: #5a908e;
  --color-gradient3--from: #e7efec;
  --color-gradient3--to: #e8eeec;
  --spacing-1: 0;
  --spacing0: 0;
  --spacing-2: .313rem;
  --spacing--: .313rem;
  --spacing-3: .625rem;
  --spacing-: .625rem;
  --spacing-4: 1.25rem;
  --spacing: 1.25rem;
  --spacing-5: 2.5rem;
  --spacing\\+: 2.5rem;
  --spacing-6: 5rem;
  --spacing\\+\\+: 5rem;
  --color-tag-green--dark: #008500;
  --color-tag-green--light: #eefcee;
  --color-tag-cyan--dark: #558891;
  --color-tag-cyan--light: #e9f0f2;
  --color-tag-purple--dark: #4e5eb1;
  --color-tag-purple--light: #e8ebfd;
  --color-tag-orange--dark: #ff9500;
  --color-tag-orange--light: #fffbf5;
  --color-tag-blue--dark: #00496b;
  --color-tag-blue--light: #deedfc;
  --color-tag-white--dark: #fff;
  --color-tag-white--light: #ffffff26;
  --brand-face: "Source Sans 3 VF", sans-serif;
  --spec-face: "Oxygen", sans-serif;
  --font-weight-semibold: 500;
  --font-weight-bold: bold;
  --font-size-button: 18px;
  --line-height-button: 20px;
  --font-size-xl: 1.4375rem;
  --line-height-xl: 30px;
  --font-size-l: 1.25rem;
  --line-height-l: 30px;
  --font-size-m: 1rem;
  --line-height-m: 1.2;
  --font-size-s: .875rem;
  --line-height-s: 20px;
  --font-size-xs: .75rem;
  --line-height-xs: 16px;
  --font-size-h1: 3rem;
  --line-height-h1: 50px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h1: 32px;
    --line-height-h1: 35px;
  }
}

:root {
  --font-size-h2: 2rem;
  --line-height-h2: 35px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h2: 28px;
    --line-height-h2: 28px;
  }
}

:root {
  --font-size-h3: 1.75rem;
  --line-height-h3: 28px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h3: 23px;
    --line-height-h3: 30px;
  }
}

:root {
  --font-size-h4: 1.4375rem;
  --line-height-h4: 30px;
  --font-size-h5: 1.25rem;
  --line-height-h5: 30px;
  --font-size-h6: .875rem;
  --line-height-h6: 20px;
}

[role="button"], [type="submit"], [type="reset"], [type="button"], button {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

[type="submit"], [type="reset"], [type="button"], button {
  color: inherit;
  font: inherit;
  line-height: inherit;
  -webkit-appearance: button;
  appearance: button;
  -webkit-user-select: none;
  user-select: none;
  background: none;
  border: 0;
  margin: 0;
  padding: 0;
  overflow: visible;
}

input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

button::-moz-focus-inner {
  border: 0;
  padding: 0;
}

[role="button"] {
  color: inherit;
  cursor: default;
  text-align: center;
  white-space: pre;
  -webkit-user-select: none;
  user-select: none;
  text-decoration: none;
  display: inline-block;
}

*, :before, :after {
  box-sizing: border-box;
}

html {
  -webkit-text-size-adjust: 100%;
  tab-size: 4;
  font-family: system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji;
  line-height: 1.15;
}

body {
  margin: 0;
}

b, strong {
  font-weight: bolder;
}

code, kbd, samp, pre {
  font-family: ui-monospace, SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace;
  font-size: 1em;
}

small {
  font-size: 80%;
}

sub, sup {
  vertical-align: baseline;
  font-size: 75%;
  line-height: 0;
  position: relative;
}

sub {
  bottom: -.25em;
}

sup {
  top: -.5em;
}

table {
  border-color: currentColor;
}

button, input, optgroup, select, textarea {
  outline: none;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
}

button, [type="button"], [type="reset"], [type="submit"] {
  -webkit-appearance: button;
}

legend {
  padding: 0;
}

progress {
  vertical-align: baseline;
}

::-webkit-inner-spin-button {
  height: auto;
}

::-webkit-outer-spin-button {
  height: auto;
}

[type="search"] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}

summary {
  display: list-item;
}

:root {
  line-height: 1.5;
}

h1, h2, h3, h4, h5, figure, p, ol, ul {
  margin: 0;
}

ol[role="list"], ul[role="list"] {
  padding-inline: 0;
  list-style: none;
}

h1, h2, h3, h4, h5 {
  font-size: inherit;
  font-weight: inherit;
}

img {
  max-inline-size: 100%;
  display: block;
}

button {
  text-align: inherit;
  cursor: pointer;
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

label {
  cursor: pointer;
  display: block;
}

p a, h1 a, h2 a, h3 a, h4 a, h5 a, h6 a {
  color: inherit;
}

input[type="text"], input[type="email"], input[type="password"], input[type="search"]:not(.vs__search), input[type="color"], input[type="date"], input[type="datetime-local"], input[type="month"], input[type="number"], input[type="tel"], input[type="time"], input[type="url"], input[type="week"], input[list], select, textarea {
  -webkit-appearance: none;
  appearance: none;
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
  background-color: var(--color-white);
  border-radius: var(--border-radius-m);
  border: 1px solid var(--color-grey--light);
  color: var(--color-grey--dark);
  width: 100%;
  padding: 14px 15px;
}

@media screen and (width <= 46.9375em) {
  input[type="text"], input[type="email"], input[type="password"], input[type="search"]:not(.vs__search), input[type="color"], input[type="date"], input[type="datetime-local"], input[type="month"], input[type="number"], input[type="tel"], input[type="time"], input[type="url"], input[type="week"], input[list], select, textarea {
    font-size: var(--font-size-m);
    line-height: var(--line-height-s);
  }
}

input[type="date"], input[type="datetime-local"] {
  min-height: 50px;
}

input[type="text"]:read-only, input[type="email"]:read-only, input[type="password"]:read-only, input[type="search"]:read-only, input[type="color"]:read-only, input[type="date"]:read-only, input[type="datetime-local"]:read-only, input[type="month"]:read-only, input[type="number"]:read-only, input[type="tel"]:read-only, input[type="time"]:read-only, input[type="url"]:read-only, input[type="week"]:read-only, input[list]:read-only {
  background-color: var(--color-grey--x-light);
  box-shadow: none !important;
}

input[name*="postcode"], input[name*="Postal"], input[name*="postal"] {
  text-transform: uppercase;
}

::placeholder {
  color: var(--color-grey);
}

html {
  background-color: var(--color-white);
  font-size: var(--font-size-m);
  line-height: var(--line-height-m);
  color: var(--color-grey--dark);
  -webkit-font-smoothing: antialiased;
  scrollbar-gutter: stable;
  overflow-y: scroll;
}

hr {
  border: 0;
  border-bottom: 1px solid var(--color-grey--light);
}

p {
  margin: 0 0 20px;
}

ol, ul {
  padding-left: 20px;
}

summary {
  cursor: pointer;
}

abbr[title] {
  text-decoration: none;
}

img {
  max-width: 100%;
}

@media screen and (width <= 46.9375em) {
  img[data-lazyload-src][style*="height"], img[data-lazyload-src][height], img[src][style*="height"], img[src][height] {
    max-width: 100% !important;
    height: auto !important;
  }
}

table {
  width: 100%;
}

table td {
  vertical-align: top;
  padding: 0;
}

body {
  font-family: var(--brand-face);
}

h1, h2, h3 {
  font-style: italic;
}

h1, h2, h3, h4, h5, h6 {
  font-weight: bold;
}

h1 {
  font-size: var(--font-size-h1);
  line-height: var(--line-height-h1);
}

h2 {
  font-size: var(--font-size-h2);
  line-height: var(--line-height-h2);
}

h3 {
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
}

h4 {
  font-size: var(--font-size-h4);
  line-height: var(--line-height-h4);
}

h5 {
  font-size: var(--font-size-h5);
  line-height: var(--line-height-h5);
}

h6 {
  font-size: var(--font-size-h6);
  line-height: var(--line-height-h6);
  margin: 0;
}

strong, b {
  font-weight: bold;
}

small {
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
}

button, a {
  text-decoration: none;
}

button:hover, a:hover, p a {
  text-decoration: underline;
}

p a:hover {
  text-decoration: none;
}

:has( + bc-tooltip:not([data-trigger-style])) {
  color: var(--color-status--red);
  position: relative;
}

:has( + bc-tooltip:not([data-trigger-style])):before {
  content: "Missing attribute 'data-trigger-style'";
  white-space: nowrap;
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
  color: var(--color-white);
  background-color: var(--color-status--orange);
  z-index: 40;
  border-radius: 5px;
  width: 200px;
  padding: 3px 10px;
  position: absolute;
  top: 20px;
}

:has( + bc-tooltip[data-trigger-style="dashed"]) {
  text-underline-offset: .2rem;
  text-decoration: underline from-font dashed;
}

:has( + bc-tooltip[data-trigger-style="info-icon"]):after, :has( + bc-tooltip[data-trigger-style="info-icon-border"]):after {
  content: "";
  background-image: url("https://cdn.wechseljetzt.de/assets/wj/img/icons/info.svg");
  background-position: center;
  background-repeat: no-repeat;
  width: 5px;
  height: 11px;
  margin-left: 5px;
  display: inline-block;
}

:has( + bc-tooltip[data-trigger-style="info-icon-border"]):after {
  content: "";
  border: 1px solid var(--color-grey);
  border-radius: var(--border-radius-xl);
  margin-bottom: -3px;
  padding: 9px 10px 10px;
}

.c-button {
  --button-background-color: var(--color-brand);
  --button-text-color: var(--color-white);
  font-size: var(--font-size-button);
  line-height: var(--line-height-button);
  text-align: center;
  white-space: nowrap;
  cursor: pointer;
  color: var(--button-text-color);
  background-color: var(--button-background-color);
  border-radius: var(--border-radius-m);
  transition-property: opacity, transform, background-color, color;
  transition-duration: var(--duration-fast);
  transition-timing-function: var(--swift-ease-in-timing-function);
  border: none;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  display: inline-flex;
  position: relative;
  overflow: hidden;
  transform: translateZ(0);
}

.c-button:not(.c-icon-button) {
  padding: calc(1.5 * var(--spacing-)) var(--spacing);
}

.c-button:hover {
  text-decoration: none;
}

.c-button[hidden] {
  display: none;
}

.c-button:before {
  content: "";
  z-index: -1;
  background: var(--color-black);
  opacity: 0;
  transform-origin: 50%;
  transition-property: opacity, transform, background-color, color;
  transition-duration: var(--duration-fast);
  transition-timing-function: var(--swift-ease-in-timing-function);
  border-radius: var(--button-border-radius);
  position: absolute;
  inset: 0;
  transform: scale(.5);
}

.c-button:hover:before, .c-button:active:before {
  opacity: .15;
  transform: scale(1.2);
}

.c-button--small {
  font-size: var(--font-size-m);
  line-height: var(--line-height-s);
  border-radius: var(--border-radius-s);
  padding-top: var(--spacing--) !important;
  padding-bottom: var(--spacing--) !important;
}

.c-button--large {
  padding-top: var(--spacing) !important;
  padding-bottom: var(--spacing) !important;
}

.c-button--support {
  --button-background-color: var(--color-brand--support);
  --button-text-color: var(--color-white);
}

.c-button--accent {
  --button-background-color: var(--color-brand--accent);
  --button-text-color: var(--color-white);
}

.c-button--grey {
  --button-background-color: var(--color-grey--light);
  --button-text-color: var(--color-grey--dark);
}

.c-button--white {
  --button-background-color: var(--color-white);
  --button-text-color: var(--color-grey--dark);
  fill: var(--color-grey--dark);
}

.c-button--white:before {
  background-color: #0000;
}

.c-button--white:hover {
  background-color: hsl(from var(--color-white) h s l / .9);
}

.c-button--ghost {
  --button-background-color: transparent;
  border-style: solid;
  border-width: 1px;
  border-color: inherit;
}

.c-button--ghost:before {
  background-color: var(--color-white);
}

.c-button--disabled, .c-button[disabled] {
  cursor: default;
  --button-background-color: var(--color-grey--light);
}

.c-button--disabled:before, .c-button[disabled]:before {
  display: none;
}

.c-button--fullwidth {
  width: 100%;
}

.c-tag {
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
  border-radius: var(--border-radius-xs);
  gap: 3px;
  margin-right: 5px;
  padding: 2px 10px;
}

@media screen and (width >= 47em), print {
  .c-tag {
    display: inline-flex;
  }
}

.c-tag--border {
  border: 1px solid;
}

.c-tag--small {
  white-space: nowrap;
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
  margin-top: 2px;
  padding: 0 7px 1px;
}

.c-tag--hover {
  position: relative;
  overflow: hidden;
}

.c-tag--hover:before {
  content: "";
  opacity: 0;
  box-shadow: 0 0 7px inset hsl(from var(--color-grey) h s l / .5);
  transition: opacity .15s;
  position: absolute;
  inset: 0;
}

.c-tag--hover:hover {
  text-decoration: none;
}

.c-tag--hover:hover:before {
  opacity: .5;
}

.c-tag--hover:active:before {
  opacity: 1;
}

.c-tag--green {
  color: var(--color-tag-green--dark);
  background-color: var(--color-tag-green--light);
}

.c-tag--green-bg {
  color: var(--color-tag-green--light);
  background-color: var(--color-tag-green--dark);
}

.c-tag--cyan {
  color: var(--color-tag-cyan--dark);
  background-color: var(--color-tag-cyan--light);
}

.c-tag--cyan-bg {
  color: var(--color-tag-cyan--light);
  background-color: var(--color-tag-cyan--dark);
}

.c-tag--purple {
  color: var(--color-tag-purple--dark);
  background-color: var(--color-tag-purple--light);
}

.c-tag--purple-bg {
  color: var(--color-tag-purple--light);
  background-color: var(--color-tag-purple--dark);
}

.c-tag--orange {
  color: var(--color-tag-orange--dark);
  background-color: var(--color-tag-orange--light);
  font-weight: 500;
}

.c-tag--orange-bg {
  color: var(--color-tag-orange--light);
  background-color: var(--color-tag-orange--dark);
  font-weight: 500;
}

.c-tag--blue {
  color: var(--color-tag-blue--dark);
  background-color: var(--color-tag-blue--light);
  font-weight: 500;
}

.c-tag--blue-bg {
  color: var(--color-tag-blue--light);
  background-color: var(--color-tag-blue--dark);
  font-weight: 500;
}

.c-tag--white {
  color: var(--color-tag-white--dark);
  background-color: var(--color-tag-white--light);
}

.c-tag--white-bg {
  color: var(--color-tag-white--light);
  background-color: var(--color-tag-white--dark);
}

.c-tag--strikethrough {
  background: linear-gradient(-45deg, var(--color-grey--x-light) 17.5%, var(--color-white) 17.5%, var(--color-white) 32.5%, var(--color-grey--x-light) 32.5%, var(--color-grey--x-light) 67.5%, var(--color-white) 67.5%, var(--color-white) 82.5%, var(--color-grey--x-light) 82.5%);
  color: var(--color-grey);
  background-size: 10px 10px;
}

.m0 {
  margin: 0 !important;
}

.mt0 {
  margin-top: 0 !important;
}

.mr0 {
  margin-right: 0 !important;
}

.mb0 {
  margin-bottom: 0 !important;
}

.ml0 {
  margin-left: 0 !important;
}

.mv0 {
  margin-block: 0 !important;
}

.mh0 {
  margin-inline: 0 !important;
}

.m-- {
  margin: .313rem !important;
}

.mt-- {
  margin-top: .313rem !important;
}

.mr-- {
  margin-right: .313rem !important;
}

.mb-- {
  margin-bottom: .313rem !important;
}

.ml-- {
  margin-left: .313rem !important;
}

.mv-- {
  margin-block: .313rem !important;
}

.mh-- {
  margin-inline: .313rem !important;
}

.m- {
  margin: .625rem !important;
}

.mt- {
  margin-top: .625rem !important;
}

.mr- {
  margin-right: .625rem !important;
}

.mb- {
  margin-bottom: .625rem !important;
}

.ml- {
  margin-left: .625rem !important;
}

.mv- {
  margin-block: .625rem !important;
}

.mh- {
  margin-inline: .625rem !important;
}

.m {
  margin: 1.25rem !important;
}

.mt {
  margin-top: 1.25rem !important;
}

.mr {
  margin-right: 1.25rem !important;
}

.mb {
  margin-bottom: 1.25rem !important;
}

.ml {
  margin-left: 1.25rem !important;
}

.mv {
  margin-block: 1.25rem !important;
}

.mh {
  margin-inline: 1.25rem !important;
}

.m\\+ {
  margin: 2.5rem !important;
}

.mt\\+ {
  margin-top: 2.5rem !important;
}

.mr\\+ {
  margin-right: 2.5rem !important;
}

.mb\\+ {
  margin-bottom: 2.5rem !important;
}

.ml\\+ {
  margin-left: 2.5rem !important;
}

.mv\\+ {
  margin-block: 2.5rem !important;
}

.mh\\+ {
  margin-inline: 2.5rem !important;
}

.m\\+\\+ {
  margin: 5rem !important;
}

.mt\\+\\+ {
  margin-top: 5rem !important;
}

.mr\\+\\+ {
  margin-right: 5rem !important;
}

.mb\\+\\+ {
  margin-bottom: 5rem !important;
}

.ml\\+\\+ {
  margin-left: 5rem !important;
}

.mv\\+\\+ {
  margin-block: 5rem !important;
}

.mh\\+\\+ {
  margin-inline: 5rem !important;
}

.p0 {
  padding: 0 !important;
}

.pt0 {
  padding-top: 0 !important;
}

.pr0 {
  padding-right: 0 !important;
}

.pb0 {
  padding-bottom: 0 !important;
}

.pl0 {
  padding-left: 0 !important;
}

.pv0 {
  padding-block: 0 !important;
}

.ph0 {
  padding-inline: 0 !important;
}

.p-- {
  padding: .313rem !important;
}

.pt-- {
  padding-top: .313rem !important;
}

.pr-- {
  padding-right: .313rem !important;
}

.pb-- {
  padding-bottom: .313rem !important;
}

.pl-- {
  padding-left: .313rem !important;
}

.pv-- {
  padding-block: .313rem !important;
}

.ph-- {
  padding-inline: .313rem !important;
}

.p- {
  padding: .625rem !important;
}

.pt- {
  padding-top: .625rem !important;
}

.pr- {
  padding-right: .625rem !important;
}

.pb- {
  padding-bottom: .625rem !important;
}

.pl- {
  padding-left: .625rem !important;
}

.pv- {
  padding-block: .625rem !important;
}

.ph- {
  padding-inline: .625rem !important;
}

.p {
  padding: 1.25rem !important;
}

.pt {
  padding-top: 1.25rem !important;
}

.pr {
  padding-right: 1.25rem !important;
}

.pb {
  padding-bottom: 1.25rem !important;
}

.pl {
  padding-left: 1.25rem !important;
}

.pv {
  padding-block: 1.25rem !important;
}

.ph {
  padding-inline: 1.25rem !important;
}

.p\\+ {
  padding: 2.5rem !important;
}

.pt\\+ {
  padding-top: 2.5rem !important;
}

.pr\\+ {
  padding-right: 2.5rem !important;
}

.pb\\+ {
  padding-bottom: 2.5rem !important;
}

.pl\\+ {
  padding-left: 2.5rem !important;
}

.pv\\+ {
  padding-block: 2.5rem !important;
}

.ph\\+ {
  padding-inline: 2.5rem !important;
}

.p\\+\\+ {
  padding: 5rem !important;
}

.pt\\+\\+ {
  padding-top: 5rem !important;
}

.pr\\+\\+ {
  padding-right: 5rem !important;
}

.pb\\+\\+ {
  padding-bottom: 5rem !important;
}

.pl\\+\\+ {
  padding-left: 5rem !important;
}

.pv\\+\\+ {
  padding-block: 5rem !important;
}

.ph\\+\\+ {
  padding-inline: 5rem !important;
}

@media screen and (width <= 46.9375em) {
  .m0\\(s\\) {
    margin: 0 !important;
  }

  .mt0\\(s\\) {
    margin-top: 0 !important;
  }

  .mr0\\(s\\) {
    margin-right: 0 !important;
  }

  .mb0\\(s\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(s\\) {
    margin-left: 0 !important;
  }

  .mv0\\(s\\) {
    margin-block: 0 !important;
  }

  .mh0\\(s\\) {
    margin-inline: 0 !important;
  }

  .m--\\(s\\) {
    margin: .313rem !important;
  }

  .mt--\\(s\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(s\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(s\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(s\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(s\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(s\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(s\\) {
    margin: .625rem !important;
  }

  .mt-\\(s\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(s\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(s\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(s\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(s\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(s\\) {
    margin-inline: .625rem !important;
  }

  .m\\(s\\) {
    margin: 1.25rem !important;
  }

  .mt\\(s\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(s\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(s\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(s\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(s\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(s\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(s\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(s\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(s\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(s\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(s\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(s\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(s\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(s\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(s\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(s\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(s\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(s\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(s\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(s\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(s\\) {
    padding: 0 !important;
  }

  .pt0\\(s\\) {
    padding-top: 0 !important;
  }

  .pr0\\(s\\) {
    padding-right: 0 !important;
  }

  .pb0\\(s\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(s\\) {
    padding-left: 0 !important;
  }

  .pv0\\(s\\) {
    padding-block: 0 !important;
  }

  .ph0\\(s\\) {
    padding-inline: 0 !important;
  }

  .p--\\(s\\) {
    padding: .313rem !important;
  }

  .pt--\\(s\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(s\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(s\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(s\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(s\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(s\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(s\\) {
    padding: .625rem !important;
  }

  .pt-\\(s\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(s\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(s\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(s\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(s\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(s\\) {
    padding-inline: .625rem !important;
  }

  .p\\(s\\) {
    padding: 1.25rem !important;
  }

  .pt\\(s\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(s\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(s\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(s\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(s\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(s\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(s\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(s\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(s\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(s\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(s\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(s\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(s\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(s\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(s\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(s\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(s\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(s\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(s\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(s\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .m0\\(m\\) {
    margin: 0 !important;
  }

  .mt0\\(m\\) {
    margin-top: 0 !important;
  }

  .mr0\\(m\\) {
    margin-right: 0 !important;
  }

  .mb0\\(m\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(m\\) {
    margin-left: 0 !important;
  }

  .mv0\\(m\\) {
    margin-block: 0 !important;
  }

  .mh0\\(m\\) {
    margin-inline: 0 !important;
  }

  .m--\\(m\\) {
    margin: .313rem !important;
  }

  .mt--\\(m\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(m\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(m\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(m\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(m\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(m\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(m\\) {
    margin: .625rem !important;
  }

  .mt-\\(m\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(m\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(m\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(m\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(m\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(m\\) {
    margin-inline: .625rem !important;
  }

  .m\\(m\\) {
    margin: 1.25rem !important;
  }

  .mt\\(m\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(m\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(m\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(m\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(m\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(m\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(m\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(m\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(m\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(m\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(m\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(m\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(m\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(m\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(m\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(m\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(m\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(m\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(m\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(m\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(m\\) {
    padding: 0 !important;
  }

  .pt0\\(m\\) {
    padding-top: 0 !important;
  }

  .pr0\\(m\\) {
    padding-right: 0 !important;
  }

  .pb0\\(m\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(m\\) {
    padding-left: 0 !important;
  }

  .pv0\\(m\\) {
    padding-block: 0 !important;
  }

  .ph0\\(m\\) {
    padding-inline: 0 !important;
  }

  .p--\\(m\\) {
    padding: .313rem !important;
  }

  .pt--\\(m\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(m\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(m\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(m\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(m\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(m\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(m\\) {
    padding: .625rem !important;
  }

  .pt-\\(m\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(m\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(m\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(m\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(m\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(m\\) {
    padding-inline: .625rem !important;
  }

  .p\\(m\\) {
    padding: 1.25rem !important;
  }

  .pt\\(m\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(m\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(m\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(m\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(m\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(m\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(m\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(m\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(m\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(m\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(m\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(m\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(m\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(m\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(m\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(m\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(m\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(m\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(m\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(m\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 47em), print {
  .m0\\(\\!s\\) {
    margin: 0 !important;
  }

  .mt0\\(\\!s\\) {
    margin-top: 0 !important;
  }

  .mr0\\(\\!s\\) {
    margin-right: 0 !important;
  }

  .mb0\\(\\!s\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(\\!s\\) {
    margin-left: 0 !important;
  }

  .mv0\\(\\!s\\) {
    margin-block: 0 !important;
  }

  .mh0\\(\\!s\\) {
    margin-inline: 0 !important;
  }

  .m--\\(\\!s\\) {
    margin: .313rem !important;
  }

  .mt--\\(\\!s\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(\\!s\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(\\!s\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(\\!s\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(\\!s\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(\\!s\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(\\!s\\) {
    margin: .625rem !important;
  }

  .mt-\\(\\!s\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(\\!s\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(\\!s\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(\\!s\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(\\!s\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(\\!s\\) {
    margin-inline: .625rem !important;
  }

  .m\\(\\!s\\) {
    margin: 1.25rem !important;
  }

  .mt\\(\\!s\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(\\!s\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(\\!s\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(\\!s\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(\\!s\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(\\!s\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(\\!s\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(\\!s\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(\\!s\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(\\!s\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(\\!s\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(\\!s\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(\\!s\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(\\!s\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(\\!s\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(\\!s\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(\\!s\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(\\!s\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(\\!s\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(\\!s\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(\\!s\\) {
    padding: 0 !important;
  }

  .pt0\\(\\!s\\) {
    padding-top: 0 !important;
  }

  .pr0\\(\\!s\\) {
    padding-right: 0 !important;
  }

  .pb0\\(\\!s\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(\\!s\\) {
    padding-left: 0 !important;
  }

  .pv0\\(\\!s\\) {
    padding-block: 0 !important;
  }

  .ph0\\(\\!s\\) {
    padding-inline: 0 !important;
  }

  .p--\\(\\!s\\) {
    padding: .313rem !important;
  }

  .pt--\\(\\!s\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(\\!s\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(\\!s\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(\\!s\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(\\!s\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(\\!s\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(\\!s\\) {
    padding: .625rem !important;
  }

  .pt-\\(\\!s\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(\\!s\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(\\!s\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(\\!s\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(\\!s\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(\\!s\\) {
    padding-inline: .625rem !important;
  }

  .p\\(\\!s\\) {
    padding: 1.25rem !important;
  }

  .pt\\(\\!s\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(\\!s\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(\\!s\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(\\!s\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(\\!s\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(\\!s\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(\\!s\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(\\!s\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(\\!s\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(\\!s\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(\\!s\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(\\!s\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(\\!s\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(\\!s\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(\\!s\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(\\!s\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(\\!s\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(\\!s\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(\\!s\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(\\!s\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width <= 74.9375em) {
  .m0\\(\\!l\\) {
    margin: 0 !important;
  }

  .mt0\\(\\!l\\) {
    margin-top: 0 !important;
  }

  .mr0\\(\\!l\\) {
    margin-right: 0 !important;
  }

  .mb0\\(\\!l\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(\\!l\\) {
    margin-left: 0 !important;
  }

  .mv0\\(\\!l\\) {
    margin-block: 0 !important;
  }

  .mh0\\(\\!l\\) {
    margin-inline: 0 !important;
  }

  .m--\\(\\!l\\) {
    margin: .313rem !important;
  }

  .mt--\\(\\!l\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(\\!l\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(\\!l\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(\\!l\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(\\!l\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(\\!l\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(\\!l\\) {
    margin: .625rem !important;
  }

  .mt-\\(\\!l\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(\\!l\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(\\!l\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(\\!l\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(\\!l\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(\\!l\\) {
    margin-inline: .625rem !important;
  }

  .m\\(\\!l\\) {
    margin: 1.25rem !important;
  }

  .mt\\(\\!l\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(\\!l\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(\\!l\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(\\!l\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(\\!l\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(\\!l\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(\\!l\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(\\!l\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(\\!l\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(\\!l\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(\\!l\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(\\!l\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(\\!l\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(\\!l\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(\\!l\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(\\!l\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(\\!l\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(\\!l\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(\\!l\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(\\!l\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(\\!l\\) {
    padding: 0 !important;
  }

  .pt0\\(\\!l\\) {
    padding-top: 0 !important;
  }

  .pr0\\(\\!l\\) {
    padding-right: 0 !important;
  }

  .pb0\\(\\!l\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(\\!l\\) {
    padding-left: 0 !important;
  }

  .pv0\\(\\!l\\) {
    padding-block: 0 !important;
  }

  .ph0\\(\\!l\\) {
    padding-inline: 0 !important;
  }

  .p--\\(\\!l\\) {
    padding: .313rem !important;
  }

  .pt--\\(\\!l\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(\\!l\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(\\!l\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(\\!l\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(\\!l\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(\\!l\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(\\!l\\) {
    padding: .625rem !important;
  }

  .pt-\\(\\!l\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(\\!l\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(\\!l\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(\\!l\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(\\!l\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(\\!l\\) {
    padding-inline: .625rem !important;
  }

  .p\\(\\!l\\) {
    padding: 1.25rem !important;
  }

  .pt\\(\\!l\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(\\!l\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(\\!l\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(\\!l\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(\\!l\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(\\!l\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(\\!l\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(\\!l\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(\\!l\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(\\!l\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(\\!l\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(\\!l\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(\\!l\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(\\!l\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(\\!l\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(\\!l\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(\\!l\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(\\!l\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(\\!l\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(\\!l\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 75em), print {
  .m0\\(l\\) {
    margin: 0 !important;
  }

  .mt0\\(l\\) {
    margin-top: 0 !important;
  }

  .mr0\\(l\\) {
    margin-right: 0 !important;
  }

  .mb0\\(l\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(l\\) {
    margin-left: 0 !important;
  }

  .mv0\\(l\\) {
    margin-block: 0 !important;
  }

  .mh0\\(l\\) {
    margin-inline: 0 !important;
  }

  .m--\\(l\\) {
    margin: .313rem !important;
  }

  .mt--\\(l\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(l\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(l\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(l\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(l\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(l\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(l\\) {
    margin: .625rem !important;
  }

  .mt-\\(l\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(l\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(l\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(l\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(l\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(l\\) {
    margin-inline: .625rem !important;
  }

  .m\\(l\\) {
    margin: 1.25rem !important;
  }

  .mt\\(l\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(l\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(l\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(l\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(l\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(l\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(l\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(l\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(l\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(l\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(l\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(l\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(l\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(l\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(l\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(l\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(l\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(l\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(l\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(l\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(l\\) {
    padding: 0 !important;
  }

  .pt0\\(l\\) {
    padding-top: 0 !important;
  }

  .pr0\\(l\\) {
    padding-right: 0 !important;
  }

  .pb0\\(l\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(l\\) {
    padding-left: 0 !important;
  }

  .pv0\\(l\\) {
    padding-block: 0 !important;
  }

  .ph0\\(l\\) {
    padding-inline: 0 !important;
  }

  .p--\\(l\\) {
    padding: .313rem !important;
  }

  .pt--\\(l\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(l\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(l\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(l\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(l\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(l\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(l\\) {
    padding: .625rem !important;
  }

  .pt-\\(l\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(l\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(l\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(l\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(l\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(l\\) {
    padding-inline: .625rem !important;
  }

  .p\\(l\\) {
    padding: 1.25rem !important;
  }

  .pt\\(l\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(l\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(l\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(l\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(l\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(l\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(l\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(l\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(l\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(l\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(l\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(l\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(l\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(l\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(l\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(l\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(l\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(l\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(l\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(l\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 90.0625em) {
  .m0\\(xl\\) {
    margin: 0 !important;
  }

  .mt0\\(xl\\) {
    margin-top: 0 !important;
  }

  .mr0\\(xl\\) {
    margin-right: 0 !important;
  }

  .mb0\\(xl\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(xl\\) {
    margin-left: 0 !important;
  }

  .mv0\\(xl\\) {
    margin-block: 0 !important;
  }

  .mh0\\(xl\\) {
    margin-inline: 0 !important;
  }

  .m--\\(xl\\) {
    margin: .313rem !important;
  }

  .mt--\\(xl\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(xl\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(xl\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(xl\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(xl\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(xl\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(xl\\) {
    margin: .625rem !important;
  }

  .mt-\\(xl\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(xl\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(xl\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(xl\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(xl\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(xl\\) {
    margin-inline: .625rem !important;
  }

  .m\\(xl\\) {
    margin: 1.25rem !important;
  }

  .mt\\(xl\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(xl\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(xl\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(xl\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(xl\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(xl\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(xl\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(xl\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(xl\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(xl\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(xl\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(xl\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(xl\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(xl\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(xl\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(xl\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(xl\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(xl\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(xl\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(xl\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(xl\\) {
    padding: 0 !important;
  }

  .pt0\\(xl\\) {
    padding-top: 0 !important;
  }

  .pr0\\(xl\\) {
    padding-right: 0 !important;
  }

  .pb0\\(xl\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(xl\\) {
    padding-left: 0 !important;
  }

  .pv0\\(xl\\) {
    padding-block: 0 !important;
  }

  .ph0\\(xl\\) {
    padding-inline: 0 !important;
  }

  .p--\\(xl\\) {
    padding: .313rem !important;
  }

  .pt--\\(xl\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(xl\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(xl\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(xl\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(xl\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(xl\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(xl\\) {
    padding: .625rem !important;
  }

  .pt-\\(xl\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(xl\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(xl\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(xl\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(xl\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(xl\\) {
    padding-inline: .625rem !important;
  }

  .p\\(xl\\) {
    padding: 1.25rem !important;
  }

  .pt\\(xl\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(xl\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(xl\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(xl\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(xl\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(xl\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(xl\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(xl\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(xl\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(xl\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(xl\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(xl\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(xl\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(xl\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(xl\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(xl\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(xl\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(xl\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(xl\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(xl\\) {
    padding-inline: 5rem !important;
  }
}

.u-gap0 {
  gap: 0 !important;
}

.u-gap-- {
  gap: .313rem !important;
}

.u-gap- {
  gap: .625rem !important;
}

.u-gap {
  gap: 1.25rem !important;
}

.u-gap\\+ {
  gap: 2.5rem !important;
}

.u-gap\\+\\+ {
  gap: 5rem !important;
}

@media screen and (width <= 46.9375em) {
  .u-gap0\\(s\\) {
    gap: 0 !important;
  }

  .u-gap--\\(s\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(s\\) {
    gap: .625rem !important;
  }

  .u-gap\\(s\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(s\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(s\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-gap0\\(m\\) {
    gap: 0 !important;
  }

  .u-gap--\\(m\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(m\\) {
    gap: .625rem !important;
  }

  .u-gap\\(m\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(m\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(m\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 47em), print {
  .u-gap0\\(\\!s\\) {
    gap: 0 !important;
  }

  .u-gap--\\(\\!s\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(\\!s\\) {
    gap: .625rem !important;
  }

  .u-gap\\(\\!s\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(\\!s\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(\\!s\\) {
    gap: 5rem !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-gap0\\(\\!l\\) {
    gap: 0 !important;
  }

  .u-gap--\\(\\!l\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(\\!l\\) {
    gap: .625rem !important;
  }

  .u-gap\\(\\!l\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(\\!l\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(\\!l\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 75em), print {
  .u-gap0\\(l\\) {
    gap: 0 !important;
  }

  .u-gap--\\(l\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(l\\) {
    gap: .625rem !important;
  }

  .u-gap\\(l\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(l\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(l\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-gap0\\(xl\\) {
    gap: 0 !important;
  }

  .u-gap--\\(xl\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(xl\\) {
    gap: .625rem !important;
  }

  .u-gap\\(xl\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(xl\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(xl\\) {
    gap: 5rem !important;
  }
}

.u-size-xl {
  font-size: var(--font-size-xl);
  line-height: var(--line-height-xl);
}

.u-size-l {
  font-size: var(--font-size-l);
  line-height: var(--line-height-l);
}

.u-size-m {
  font-size: var(--font-size-m);
  line-height: var(--line-height-m);
}

.u-size-s {
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
}

.u-size-xs {
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
}

.u-size-h1 {
  font-size: var(--font-size-h1);
  line-height: var(--line-height-h1);
  font-style: italic;
  font-weight: bold;
}

.u-size-h2 {
  font-size: var(--font-size-h2);
  line-height: var(--line-height-h2);
  font-style: italic;
  font-weight: bold;
}

.u-size-h3 {
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
  font-style: italic;
  font-weight: bold;
}

.u-size-h4 {
  font-size: var(--font-size-h4);
  line-height: var(--line-height-h4);
  font-weight: bold;
}

.u-size-h5 {
  font-size: var(--font-size-h5);
  line-height: var(--line-height-h5);
  font-weight: bold;
}

.u-size-h6 {
  font-size: var(--font-size-h6);
  line-height: var(--line-height-h6);
  font-weight: bold;
}

@media screen and (width <= 46.9375em) {
  .u-size-xl\\(s\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(s\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(s\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(s\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(s\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(s\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(s\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(s\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(s\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(s\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(s\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-size-xl\\(m\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(m\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(m\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(m\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(m\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(m\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(m\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(m\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(m\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(m\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(m\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

@media screen and (width >= 47em), print {
  .u-size-xl\\(\\!s\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(\\!s\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(\\!s\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(\\!s\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(\\!s\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(\\!s\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(\\!s\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(\\!s\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(\\!s\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(\\!s\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(\\!s\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

@media screen and (width <= 74.9375em) {
  .u-size-xl\\(\\!l\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(\\!l\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(\\!l\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(\\!l\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(\\!l\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(\\!l\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(\\!l\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(\\!l\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(\\!l\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(\\!l\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(\\!l\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

@media screen and (width >= 75em), print {
  .u-size-xl\\(l\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(l\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(l\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(l\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(l\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(l\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(l\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(l\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(l\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(l\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(l\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

@media screen and (width >= 90.0625em) {
  .u-size-xl\\(xl\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(xl\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(xl\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(xl\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(xl\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(xl\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(xl\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(xl\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(xl\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(xl\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(xl\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

.u-text-decoration--dashed-underline {
  text-underline-offset: .2rem;
  text-decoration-line: underline;
  text-decoration-style: dashed;
  text-decoration-thickness: from-font;
}

.u-text-decoration--none\\(hover\\):hover {
  text-decoration: none;
}

.c-package {
  background-color: var(--color-white);
  border-radius: var(--border-radius-m);
  margin-bottom: var(--spacing-);
  width: 100%;
  padding-top: 12px;
  display: block;
}

.c-package--top {
  align-items: top;
  width: 100%;
  display: flex;
}

.c-package--position {
  font-weight: 700;
  font-size: var(--font-size-h2);
  flex: 0 0 40px;
  padding-right: 10px;
  font-style: normal;
}

.c-package--summary {
  text-align: left;
  flex: auto;
  font-weight: 600;
}

.c-package--summary > * {
  margin: 0;
}

.c-package--header {
  align-items: center;
  width: 100%;
  display: flex;
}

@media screen and (width <= 46.9375em) {
  .c-package--header {
    flex-wrap: wrap;
  }
}

.c-package--logo {
  text-align: center;
  flex: 0 15%;
  padding-right: 10px;
}

.c-package--logo img {
  max-width: 80px;
  max-height: 50px;
}

.c-package--tags {
  text-align: left;
  flex-wrap: wrap;
  flex: 4 55%;
  display: flex;
}

.c-package--costs {
  text-align: right;
  margin-left: auto;
}

.c-package--costs-text {
  font-size: var(--font-size-s);
}

.c-package--costs-price {
  font-family: var(--spec-face);
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
  white-space: nowrap;
}

.c-package--meta {
  margin: 15px 0 10px;
  display: flex;
}

@media screen and (width <= 46.9375em) {
  .c-package--meta {
    flex-wrap: wrap;
  }
}

.c-package--meta-item {
  font-size: var(--font-size-m);
}

.c-package--meta-item:last-of-type {
  text-align: right;
  flex: 5 15%;
}

.c-package--savings-wrapper {
  border-top: 1px solid var(--color-grey--light);
  margin: 25px 0 5px;
  position: relative;
}

.c-package--savings {
  background-color: var(--color-white);
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
  color: var(--color-grey);
  padding-left: 15px;
  position: absolute;
  top: -.7rem;
  right: 0;
}
`;



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $cc5562de03e1a67c$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $cc5562de03e1a67c$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $cc5562de03e1a67c$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this.t = t, this._$AM = e, this.i = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $35c35420358b7a61$export$3bebd1f0e3943985 extends (0, $cc5562de03e1a67c$export$befdefbdce210f91) {
    constructor(i){
        if (super(i), this.it = (0, $bd6886d5707a45a8$export$45b790e32b2810ee), i.type !== (0, $cc5562de03e1a67c$export$9ba3b3f20a85bfa).CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
    }
    render(t) {
        if (t === (0, $bd6886d5707a45a8$export$45b790e32b2810ee) || null == t) return this._t = void 0, this.it = t;
        if (t === (0, $bd6886d5707a45a8$export$9c068ae9cc5db4e8)) return t;
        if ("string" != typeof t) throw Error(this.constructor.directiveName + "() called with a non-string value");
        if (t === this.it) return this._t;
        this.it = t;
        const i = [
            t
        ];
        return i.raw = i, this._t = {
            _$litType$: this.constructor.resultType,
            strings: i,
            values: []
        };
    }
}
$35c35420358b7a61$export$3bebd1f0e3943985.directiveName = "unsafeHTML", $35c35420358b7a61$export$3bebd1f0e3943985.resultType = 1;
const $35c35420358b7a61$export$b6e69390c23686fb = (0, $cc5562de03e1a67c$export$99b43ad1ed32e735)($35c35420358b7a61$export$3bebd1f0e3943985);




class $49d28191c471e76d$var$WJPackage extends (0, $baeea1393dcde116$export$3f2f9f5909897157) {
    static get properties() {
        return {
            packageElement: {
                type: Object,
                attribute: "data-package-element"
            },
            priceDisplay: {
                type: String,
                attribute: "data-price-display"
            },
            contractDetails: {
                type: Object,
                reflect: true
            }
        };
    }
    onDataFetchedTariff(e) {
        const packageData = e.detail.data;
        this.contractDetails = packageData.contractDetails;
    }
    getEnergyTypeFromUrl(url) {
        const match = url.match(/offers\/(.*?)\/info/);
        return match && match[1] ? match[1] : "";
    }
    getFormUrl(p) {
        const detailUrl = p.link.href;
        const energyTypeRegex = /offers\/(.*?)\/info/;
        const energyTypeMatch = detailUrl.match(energyTypeRegex);
        const queryRegex = /info\/(.*?)\/\d/;
        const queryMatch = detailUrl.match(queryRegex);
        let energyType = "";
        let query = "";
        if (energyTypeMatch && energyTypeMatch[1]) energyType = energyTypeMatch[1];
        if (queryMatch && queryMatch[1]) query = queryMatch[1];
        const tariffId = p.tariff.id;
        const params = Object.fromEntries(new URLSearchParams(window.location.search));
        const { location: location, postCode: postCode, city: city } = params;
        const formattedCity = city.replace("/", "-");
        let usage = params.usage || "0";
        let htUsage = params.highUsage || "0";
        let ntUsage = params.lowUsage || "0";
        let heatingType = params.heatingType || "";
        let meterType = params.meterType || "";
        const hiddenUsageInput = document.querySelector("#hiddenUsageInput")?.value;
        const hiddenHighUsageInput = document.querySelector("#hiddenHighUsageInput")?.value;
        const hiddenLowUsageInput = document.querySelector("#hiddenLowUsageInput")?.value;
        const hiddenMeterType = document.querySelector("#hiddenMeterType")?.value;
        if (hiddenMeterType && hiddenMeterType !== meterType) meterType = hiddenMeterType;
        if (hiddenUsageInput && hiddenUsageInput !== usage) usage = hiddenUsageInput;
        if (hiddenHighUsageInput && hiddenHighUsageInput !== htUsage) htUsage = hiddenHighUsageInput;
        if (hiddenLowUsageInput && hiddenLowUsageInput !== ntUsage) ntUsage = hiddenLowUsageInput;
        const queryParams = {
            location: location,
            postCode: postCode,
            city: formattedCity,
            energyType: energyType,
            tariffId: tariffId,
            query: query,
            usage: usage
        };
        queryParams.profile = (()=>{
            switch(heatingType){
                case "nightheat":
                    return "HZ0-h";
                case "heatpump":
                    return "HZ2-h";
                default:
                    return "H0";
            }
        })();
        if (htUsage !== "0") queryParams.htUsage = htUsage;
        if (ntUsage !== "0") queryParams.ntUsage = ntUsage;
        if (meterType) queryParams.meterType = meterType === "dual" ? "double" : "single";
        const queryString = new URLSearchParams(queryParams).toString();
        return `/stromrechner/antrag?${queryString}`;
    }
    euroDisplay(amount) {
        if (isNaN(amount) && amount.indexOf(",") > -1) amount = amount.replace(/\,/g, ".");
        return (0, $35c35420358b7a61$export$b6e69390c23686fb)(parseFloat(amount).toFixed(2).replace(".", ",") + "&nbsp;&euro;");
    }
    render() {
        let p = this.packageElement;
        p.energyType = this.getEnergyTypeFromUrl(p.link.href);
        p.rank;
        if (!this.packageElement) return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)``;
        const encodedURI = encodeURI(p.link.href);
        const detailPostUrl = `${window.ortus.api}package/detail`;
        const detailPostData = {
            packageDetailsUri: encodedURI
        };
        const reviewPercentage = p.provider.userRatings?.additonalCustomerRatings.averagePercent ? Math.ceil(p.provider.userRatings?.additonalCustomerRatings.averagePercent) : null;
        const reviewRating = parseFloat(reviewPercentage) / 10;
        const jsonUserRatings = JSON.stringify(p.provider.userRatings);
        return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`<div class="c-package">
      <div class="ph(!s) ph-(s)">${this.renderPackageHeader(p, this.priceDisplay)}</div>
      <bc-tabs class="c-package--tabs" exportparts="tab: tab, tab-selected: tab-selected" data-is-closable="true">
        <bc-tab data-tab-title="Preisdetails" tooltip="" class="c-package--tab">
          <wj-package-pricedetails cost=${JSON.stringify(p.cost)}></wj-package-pricedetails>
        </bc-tab>

        <bc-tab data-tab-title="Tarifdetails" data-is-async detailPostUrl=${detailPostUrl} detailPostData=${JSON.stringify(detailPostData)} @data-fetched=${this.onDataFetchedTariff} tooltip="Uitgebreidere informatie over de opbouw van de prijzen van dit pakket">
          <wj-package-tariff contractDetails=${JSON.stringify(this.contractDetails)}></wj-package-tariff>
        </bc-tab>
        ${reviewPercentage > 0 ? (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)` <bc-tab ?hidden=${reviewPercentage == 0} data-tab-title="${`Kundenbewertung`}  ${reviewRating}">
              <wj-supplier-reviews data-user-ratings=${jsonUserRatings}></wj-supplier-reviews>
            </bc-tab>` : (0, $bd6886d5707a45a8$export$45b790e32b2810ee)}
      </bc-tabs>
    </div>`;
    }
    renderPackageHeader(p) {
        return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)` <div class="c-package--header">
        <div class="c-package--position">${p.rank}</div>
        <div class="c-package--logo">
          <img src="${p.provider?.logoUrl}" />
        </div>

        <div class="c-package--summary">
          <h4 class="u-font-size-6(s) mb--">${p.tariff?.content?.text}</h4>
          <div class="c-package--tags">
            ${p.tariff.isEcoTariff == true ? (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`
                  <span class="c-package--green u-font-size-6 mr-">
                    <span>${p.energyType === "gas" ? "\xd6kogas" : "\xd6kostrom"}</span>
                    <bc-tooltip data-trigger-style="dashed">${p.energyType === "gas" ? "Bei mit \xd6kogas gekennzeichneten Tarifen handelt es sich um CO2-kompensiertes Erdgas. Dabei wird das Kohlendioxid (CO2), das bei Verbrennung des Erdgases entsteht, durch den Erwerb und die Entwertung von Klimaschutzzertifkaten aus internationalen Klimaschutzprojekten ausgeglichen" : "Mit \xf6ko gekennzeichneter Strom kommt zu 100% aus erneuerbaren Energien."} </bc-tooltip>
                    <span> ${this.renderLeaf()} </span>
                  </span>
                ` : (0, $bd6886d5707a45a8$export$45b790e32b2810ee)}
            ${p.remarks.filter((remark)=>remark.content.text.includes("bonus")).map((remark)=>(0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`
                  <div class="c-tag c-tag--green c-tag--border mb--">${(0, $35c35420358b7a61$export$b6e69390c23686fb)(remark.content.text.replace("zzgl.", "inkl."))}</div>
                  <bc-tooltip data-trigger-style="none">
                    <h6>${(0, $35c35420358b7a61$export$b6e69390c23686fb)(remark.content.tooltip.header)}</h6>
                    ${(0, $35c35420358b7a61$export$b6e69390c23686fb)(remark.content.tooltip.body)}
                  </bc-tooltip>
                `)}
          </div>
        </div>
        <div class="c-package--costs">
          <!-- Check - Get values dynamic -->
          <div class="c-package--costs-text">${this.priceDisplay === "month" ? "\xd8-Monatspreis im 1. Jahr" : "Im 1. Jahr"}</div>
          <div class="c-package--costs-price c-spec">${this.priceDisplay === "month" ? this.euroDisplay(p.cost?.totalCost?.amount / 12) : this.euroDisplay(p.cost?.totalCost?.amount)}</div>
        </div>
      </div>

      <div class="c-package--savings-wrapper">
        ${p.cost?.savings?.amount > 20 ? (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)` <span class="c-package--savings">Sie sparen ${this.euroDisplay(p.cost?.savings?.amount)}</span> ` : (0, $bd6886d5707a45a8$export$45b790e32b2810ee)}
        <bc-tooltip data-trigger-style="dashed"> ${(0, $35c35420358b7a61$export$b6e69390c23686fb)(p.cost.savings.content.tooltip.body)} </bc-tooltip>
      </div>

      <div class="c-package--meta">
        <div class="c-package--meta-item">
          <div class="c-package--tags">
            ${p.remarks.filter((remark)=>!$49d28191c471e76d$var$includesBannedTags(remark.content.text)).map((remark)=>(0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`<div class="c-tag c-tag--blue c-tag--border mb--">${(0, $35c35420358b7a61$export$b6e69390c23686fb)(remark.content.text)}</div>

                  <bc-tooltip data-trigger-style="none">
                    <h6>${(0, $35c35420358b7a61$export$b6e69390c23686fb)(remark.content.tooltip.header)}</h6>
                    ${(0, $35c35420358b7a61$export$b6e69390c23686fb)(remark.content.tooltip.body)}
                  </bc-tooltip>`)}
          </div>
        </div>
        <div class="c-package--meta-item">${p.link && p.link.rel == "offerInfo" ? (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)` <a class="c-button c-button--accent mt-- ph+" href="${this.getFormUrl(p)}">Anmelden</a>` : (0, $bd6886d5707a45a8$export$45b790e32b2810ee)}</div>
      </div>`;
    }
    renderLeaf() {
        return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)` <svg width="15" height="20" viewBox="0 0 15 20" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.18 0s-1.645 1.596-3.424 2.24c-13.179 4.767-7.621 14.056-7.44 14.087 0 0 .74-1.287 1.738-2.021 6.334-4.657 7.622-10.017 7.622-10.017s-1.422 6.45-7.057 10.463C2.374 15.638 1.53 17.82 1.174 20c0 0 .883-.356 1.262-.453.148-.966.457-1.89.98-2.716 7.877.938 10.457-5.409 10.794-7.622C15.005 3.982 12.18 0 12.18 0z" fill="#008500" class="u-svg-fill" />
    </svg>`;
    }
}
$49d28191c471e76d$var$WJPackage.styles = [
    (0, $6b1247e44a1879ac$export$d9c27373510793c5)
];
const $49d28191c471e76d$var$includesBannedTags = (text)=>{
    const bannedTags = [
        "erstlaufzeit",
        "onlinetarif",
        "g\xfcltig seit",
        "nicht enthalten",
        "bonus"
    ];
    const lowerText = text.toLowerCase();
    return bannedTags.some((tag)=>lowerText.includes(tag));
};
const $49d28191c471e76d$export$6c8cb28fd3747dfa = ()=>{
    customElements.define("wj-package", $49d28191c471e76d$var$WJPackage);
};





const $3a4e11a1b8275a7f$export$7b27f05b38c84a35 = (0, $2ebca2d23ae8704c$export$dbf350e5966cf602)`:root {
  --duration-fast: .3s;
  --duration-medium: .75s;
  --duration-slow: 1.2s;
  --swift-ease-out-timing-function: cubic-bezier(.25, .8, .25, 1);
  --swift-ease-out: all var(--duration-fast) var(--swift-ease-out-timing-function);
  --swift-ease-in-timing-function: cubic-bezier(.55, 0, .55, .2);
  --swift-ease-in: all var(--duration-fast) var(--swift-ease-in-timing-function);
  --swift-ease-in-out-timing-function: cubic-bezier(.35, 0, .25, 1);
  --swift-ease-in-out: all var(--duration-fast) var(--swift-ease-in-out-timing-function);
  --border-radius-none: 0;
  --border-radius-xs: 4px;
  --border-radius-s: 8px;
  --border-radius: 16px;
  --border-radius-m: 16px;
  --border-radius-l: 32px;
  --border-radius-xl: 999em;
  --color-white: #fff;
  --color-white--base: #fff;
  --color-grey: #757575;
  --color-grey--base: #757575;
  --color-grey--dark: #3d3d3d;
  --color-grey--light: #d4d4d4;
  --color-grey--x-light: #f7f7f7;
  --color-black: #000;
  --color-black--base: #000;
  --color-brand: #aa183f;
  --color-brand--base: #aa183f;
  --color-brand--accent: #1470d2;
  --color-brand--support: #00496b;
  --color-status--green: #008500;
  --color-status--orange: #ff9500;
  --color-status--yellow: #fc0;
  --color-status--red: red;
  --color-status--marked: #ffec99;
  --color-nav: #308271;
  --color-nav--base: #308271;
  --color-nav--hover: #297064;
  --color-gradient1--from: #4db380;
  --color-gradient1--to: #508a95;
  --color-gradient2--from: #62a38d;
  --color-gradient2--to: #5a908e;
  --color-gradient3--from: #e7efec;
  --color-gradient3--to: #e8eeec;
  --spacing-1: 0;
  --spacing0: 0;
  --spacing-2: .313rem;
  --spacing--: .313rem;
  --spacing-3: .625rem;
  --spacing-: .625rem;
  --spacing-4: 1.25rem;
  --spacing: 1.25rem;
  --spacing-5: 2.5rem;
  --spacing\\+: 2.5rem;
  --spacing-6: 5rem;
  --spacing\\+\\+: 5rem;
  --color-tag-green--dark: #008500;
  --color-tag-green--light: #eefcee;
  --color-tag-cyan--dark: #558891;
  --color-tag-cyan--light: #e9f0f2;
  --color-tag-purple--dark: #4e5eb1;
  --color-tag-purple--light: #e8ebfd;
  --color-tag-orange--dark: #ff9500;
  --color-tag-orange--light: #fffbf5;
  --color-tag-blue--dark: #00496b;
  --color-tag-blue--light: #deedfc;
  --color-tag-white--dark: #fff;
  --color-tag-white--light: #ffffff26;
  --brand-face: "Source Sans 3 VF", sans-serif;
  --spec-face: "Oxygen", sans-serif;
  --font-weight-semibold: 500;
  --font-weight-bold: bold;
  --font-size-button: 18px;
  --line-height-button: 20px;
  --font-size-xl: 1.4375rem;
  --line-height-xl: 30px;
  --font-size-l: 1.25rem;
  --line-height-l: 30px;
  --font-size-m: 1rem;
  --line-height-m: 1.2;
  --font-size-s: .875rem;
  --line-height-s: 20px;
  --font-size-xs: .75rem;
  --line-height-xs: 16px;
  --font-size-h1: 3rem;
  --line-height-h1: 50px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h1: 32px;
    --line-height-h1: 35px;
  }
}

:root {
  --font-size-h2: 2rem;
  --line-height-h2: 35px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h2: 28px;
    --line-height-h2: 28px;
  }
}

:root {
  --font-size-h3: 1.75rem;
  --line-height-h3: 28px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h3: 23px;
    --line-height-h3: 30px;
  }
}

:root {
  --font-size-h4: 1.4375rem;
  --line-height-h4: 30px;
  --font-size-h5: 1.25rem;
  --line-height-h5: 30px;
  --font-size-h6: .875rem;
  --line-height-h6: 20px;
}

[role="button"], [type="submit"], [type="reset"], [type="button"], button {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

[type="submit"], [type="reset"], [type="button"], button {
  color: inherit;
  font: inherit;
  line-height: inherit;
  -webkit-appearance: button;
  appearance: button;
  -webkit-user-select: none;
  user-select: none;
  background: none;
  border: 0;
  margin: 0;
  padding: 0;
  overflow: visible;
}

input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

button::-moz-focus-inner {
  border: 0;
  padding: 0;
}

[role="button"] {
  color: inherit;
  cursor: default;
  text-align: center;
  white-space: pre;
  -webkit-user-select: none;
  user-select: none;
  text-decoration: none;
  display: inline-block;
}

*, :before, :after {
  box-sizing: border-box;
}

html {
  -webkit-text-size-adjust: 100%;
  tab-size: 4;
  font-family: system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji;
  line-height: 1.15;
}

body {
  margin: 0;
}

b, strong {
  font-weight: bolder;
}

code, kbd, samp, pre {
  font-family: ui-monospace, SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace;
  font-size: 1em;
}

small {
  font-size: 80%;
}

sub, sup {
  vertical-align: baseline;
  font-size: 75%;
  line-height: 0;
  position: relative;
}

sub {
  bottom: -.25em;
}

sup {
  top: -.5em;
}

table {
  border-color: currentColor;
}

button, input, optgroup, select, textarea {
  outline: none;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
}

button, [type="button"], [type="reset"], [type="submit"] {
  -webkit-appearance: button;
}

legend {
  padding: 0;
}

progress {
  vertical-align: baseline;
}

::-webkit-inner-spin-button {
  height: auto;
}

::-webkit-outer-spin-button {
  height: auto;
}

[type="search"] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}

summary {
  display: list-item;
}

:root {
  line-height: 1.5;
}

h1, h2, h3, h4, h5, figure, p, ol, ul {
  margin: 0;
}

ol[role="list"], ul[role="list"] {
  padding-inline: 0;
  list-style: none;
}

h1, h2, h3, h4, h5 {
  font-size: inherit;
  font-weight: inherit;
}

img {
  max-inline-size: 100%;
  display: block;
}

button {
  text-align: inherit;
  cursor: pointer;
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

label {
  cursor: pointer;
  display: block;
}

p a, h1 a, h2 a, h3 a, h4 a, h5 a, h6 a {
  color: inherit;
}

input[type="text"], input[type="email"], input[type="password"], input[type="search"]:not(.vs__search), input[type="color"], input[type="date"], input[type="datetime-local"], input[type="month"], input[type="number"], input[type="tel"], input[type="time"], input[type="url"], input[type="week"], input[list], select, textarea {
  -webkit-appearance: none;
  appearance: none;
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
  background-color: var(--color-white);
  border-radius: var(--border-radius-m);
  border: 1px solid var(--color-grey--light);
  color: var(--color-grey--dark);
  width: 100%;
  padding: 14px 15px;
}

@media screen and (width <= 46.9375em) {
  input[type="text"], input[type="email"], input[type="password"], input[type="search"]:not(.vs__search), input[type="color"], input[type="date"], input[type="datetime-local"], input[type="month"], input[type="number"], input[type="tel"], input[type="time"], input[type="url"], input[type="week"], input[list], select, textarea {
    font-size: var(--font-size-m);
    line-height: var(--line-height-s);
  }
}

input[type="date"], input[type="datetime-local"] {
  min-height: 50px;
}

input[type="text"]:read-only, input[type="email"]:read-only, input[type="password"]:read-only, input[type="search"]:read-only, input[type="color"]:read-only, input[type="date"]:read-only, input[type="datetime-local"]:read-only, input[type="month"]:read-only, input[type="number"]:read-only, input[type="tel"]:read-only, input[type="time"]:read-only, input[type="url"]:read-only, input[type="week"]:read-only, input[list]:read-only {
  background-color: var(--color-grey--x-light);
  box-shadow: none !important;
}

input[name*="postcode"], input[name*="Postal"], input[name*="postal"] {
  text-transform: uppercase;
}

::placeholder {
  color: var(--color-grey);
}

html {
  background-color: var(--color-white);
  font-size: var(--font-size-m);
  line-height: var(--line-height-m);
  color: var(--color-grey--dark);
  -webkit-font-smoothing: antialiased;
  scrollbar-gutter: stable;
  overflow-y: scroll;
}

hr {
  border: 0;
  border-bottom: 1px solid var(--color-grey--light);
}

p {
  margin: 0 0 20px;
}

ol, ul {
  padding-left: 20px;
}

summary {
  cursor: pointer;
}

abbr[title] {
  text-decoration: none;
}

img {
  max-width: 100%;
}

@media screen and (width <= 46.9375em) {
  img[data-lazyload-src][style*="height"], img[data-lazyload-src][height], img[src][style*="height"], img[src][height] {
    max-width: 100% !important;
    height: auto !important;
  }
}

table {
  width: 100%;
}

table td {
  vertical-align: top;
  padding: 0;
}

body {
  font-family: var(--brand-face);
}

h1, h2, h3 {
  font-style: italic;
}

h1, h2, h3, h4, h5, h6 {
  font-weight: bold;
}

h1 {
  font-size: var(--font-size-h1);
  line-height: var(--line-height-h1);
}

h2 {
  font-size: var(--font-size-h2);
  line-height: var(--line-height-h2);
}

h3 {
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
}

h4 {
  font-size: var(--font-size-h4);
  line-height: var(--line-height-h4);
}

h5 {
  font-size: var(--font-size-h5);
  line-height: var(--line-height-h5);
}

h6 {
  font-size: var(--font-size-h6);
  line-height: var(--line-height-h6);
  margin: 0;
}

strong, b {
  font-weight: bold;
}

small {
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
}

button, a {
  text-decoration: none;
}

button:hover, a:hover, p a {
  text-decoration: underline;
}

p a:hover {
  text-decoration: none;
}

:has( + bc-tooltip:not([data-trigger-style])) {
  color: var(--color-status--red);
  position: relative;
}

:has( + bc-tooltip:not([data-trigger-style])):before {
  content: "Missing attribute 'data-trigger-style'";
  white-space: nowrap;
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
  color: var(--color-white);
  background-color: var(--color-status--orange);
  z-index: 40;
  border-radius: 5px;
  width: 200px;
  padding: 3px 10px;
  position: absolute;
  top: 20px;
}

:has( + bc-tooltip[data-trigger-style="dashed"]) {
  text-underline-offset: .2rem;
  text-decoration: underline from-font dashed;
}

:has( + bc-tooltip[data-trigger-style="info-icon"]):after, :has( + bc-tooltip[data-trigger-style="info-icon-border"]):after {
  content: "";
  background-image: url("https://cdn.wechseljetzt.de/assets/wj/img/icons/info.svg");
  background-position: center;
  background-repeat: no-repeat;
  width: 5px;
  height: 11px;
  margin-left: 5px;
  display: inline-block;
}

:has( + bc-tooltip[data-trigger-style="info-icon-border"]):after {
  content: "";
  border: 1px solid var(--color-grey);
  border-radius: var(--border-radius-xl);
  margin-bottom: -3px;
  padding: 9px 10px 10px;
}

.layout {
  flex-wrap: wrap;
  margin: 0 0 0 -20px;
  padding: 0;
  list-style: none;
  display: flex;
}

@media screen and (width >= 47em), print {
  .layout--nowrap {
    flex-wrap: nowrap;
  }
}

.layout--rev {
  flex-direction: row-reverse;
}

.layout--middle {
  align-items: center;
}

.layout--spaced {
  justify-content: space-between;
}

.layout--center {
  justify-content: center;
}

.layout__item {
  width: 100%;
  padding-left: 20px;
}

.layout--auto > .layout__item {
  flex-basis: content;
}

.layout--flush {
  margin-left: 0;
}

.layout--flush > .layout__item {
  padding-left: 0;
}

.layout--small {
  margin-left: -10px;
}

.layout--small > .layout__item {
  padding-left: 10px;
}

.u-size-xl {
  font-size: var(--font-size-xl);
  line-height: var(--line-height-xl);
}

.u-size-l {
  font-size: var(--font-size-l);
  line-height: var(--line-height-l);
}

.u-size-m {
  font-size: var(--font-size-m);
  line-height: var(--line-height-m);
}

.u-size-s {
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
}

.u-size-xs {
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
}

.u-size-h1 {
  font-size: var(--font-size-h1);
  line-height: var(--line-height-h1);
  font-style: italic;
  font-weight: bold;
}

.u-size-h2 {
  font-size: var(--font-size-h2);
  line-height: var(--line-height-h2);
  font-style: italic;
  font-weight: bold;
}

.u-size-h3 {
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
  font-style: italic;
  font-weight: bold;
}

.u-size-h4 {
  font-size: var(--font-size-h4);
  line-height: var(--line-height-h4);
  font-weight: bold;
}

.u-size-h5 {
  font-size: var(--font-size-h5);
  line-height: var(--line-height-h5);
  font-weight: bold;
}

.u-size-h6 {
  font-size: var(--font-size-h6);
  line-height: var(--line-height-h6);
  font-weight: bold;
}

@media screen and (width <= 46.9375em) {
  .u-size-xl\\(s\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(s\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(s\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(s\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(s\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(s\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(s\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(s\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(s\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(s\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(s\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-size-xl\\(m\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(m\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(m\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(m\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(m\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(m\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(m\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(m\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(m\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(m\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(m\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

@media screen and (width >= 47em), print {
  .u-size-xl\\(\\!s\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(\\!s\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(\\!s\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(\\!s\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(\\!s\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(\\!s\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(\\!s\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(\\!s\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(\\!s\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(\\!s\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(\\!s\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

@media screen and (width <= 74.9375em) {
  .u-size-xl\\(\\!l\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(\\!l\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(\\!l\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(\\!l\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(\\!l\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(\\!l\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(\\!l\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(\\!l\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(\\!l\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(\\!l\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(\\!l\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

@media screen and (width >= 75em), print {
  .u-size-xl\\(l\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(l\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(l\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(l\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(l\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(l\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(l\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(l\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(l\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(l\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(l\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

@media screen and (width >= 90.0625em) {
  .u-size-xl\\(xl\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(xl\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(xl\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(xl\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(xl\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(xl\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(xl\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(xl\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(xl\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(xl\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(xl\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

.u-text-decoration--dashed-underline {
  text-underline-offset: .2rem;
  text-decoration-line: underline;
  text-decoration-style: dashed;
  text-decoration-thickness: from-font;
}

.u-text-decoration--none\\(hover\\):hover {
  text-decoration: none;
}

.m0 {
  margin: 0 !important;
}

.mt0 {
  margin-top: 0 !important;
}

.mr0 {
  margin-right: 0 !important;
}

.mb0 {
  margin-bottom: 0 !important;
}

.ml0 {
  margin-left: 0 !important;
}

.mv0 {
  margin-block: 0 !important;
}

.mh0 {
  margin-inline: 0 !important;
}

.m-- {
  margin: .313rem !important;
}

.mt-- {
  margin-top: .313rem !important;
}

.mr-- {
  margin-right: .313rem !important;
}

.mb-- {
  margin-bottom: .313rem !important;
}

.ml-- {
  margin-left: .313rem !important;
}

.mv-- {
  margin-block: .313rem !important;
}

.mh-- {
  margin-inline: .313rem !important;
}

.m- {
  margin: .625rem !important;
}

.mt- {
  margin-top: .625rem !important;
}

.mr- {
  margin-right: .625rem !important;
}

.mb- {
  margin-bottom: .625rem !important;
}

.ml- {
  margin-left: .625rem !important;
}

.mv- {
  margin-block: .625rem !important;
}

.mh- {
  margin-inline: .625rem !important;
}

.m {
  margin: 1.25rem !important;
}

.mt {
  margin-top: 1.25rem !important;
}

.mr {
  margin-right: 1.25rem !important;
}

.mb {
  margin-bottom: 1.25rem !important;
}

.ml {
  margin-left: 1.25rem !important;
}

.mv {
  margin-block: 1.25rem !important;
}

.mh {
  margin-inline: 1.25rem !important;
}

.m\\+ {
  margin: 2.5rem !important;
}

.mt\\+ {
  margin-top: 2.5rem !important;
}

.mr\\+ {
  margin-right: 2.5rem !important;
}

.mb\\+ {
  margin-bottom: 2.5rem !important;
}

.ml\\+ {
  margin-left: 2.5rem !important;
}

.mv\\+ {
  margin-block: 2.5rem !important;
}

.mh\\+ {
  margin-inline: 2.5rem !important;
}

.m\\+\\+ {
  margin: 5rem !important;
}

.mt\\+\\+ {
  margin-top: 5rem !important;
}

.mr\\+\\+ {
  margin-right: 5rem !important;
}

.mb\\+\\+ {
  margin-bottom: 5rem !important;
}

.ml\\+\\+ {
  margin-left: 5rem !important;
}

.mv\\+\\+ {
  margin-block: 5rem !important;
}

.mh\\+\\+ {
  margin-inline: 5rem !important;
}

.p0 {
  padding: 0 !important;
}

.pt0 {
  padding-top: 0 !important;
}

.pr0 {
  padding-right: 0 !important;
}

.pb0 {
  padding-bottom: 0 !important;
}

.pl0 {
  padding-left: 0 !important;
}

.pv0 {
  padding-block: 0 !important;
}

.ph0 {
  padding-inline: 0 !important;
}

.p-- {
  padding: .313rem !important;
}

.pt-- {
  padding-top: .313rem !important;
}

.pr-- {
  padding-right: .313rem !important;
}

.pb-- {
  padding-bottom: .313rem !important;
}

.pl-- {
  padding-left: .313rem !important;
}

.pv-- {
  padding-block: .313rem !important;
}

.ph-- {
  padding-inline: .313rem !important;
}

.p- {
  padding: .625rem !important;
}

.pt- {
  padding-top: .625rem !important;
}

.pr- {
  padding-right: .625rem !important;
}

.pb- {
  padding-bottom: .625rem !important;
}

.pl- {
  padding-left: .625rem !important;
}

.pv- {
  padding-block: .625rem !important;
}

.ph- {
  padding-inline: .625rem !important;
}

.p {
  padding: 1.25rem !important;
}

.pt {
  padding-top: 1.25rem !important;
}

.pr {
  padding-right: 1.25rem !important;
}

.pb {
  padding-bottom: 1.25rem !important;
}

.pl {
  padding-left: 1.25rem !important;
}

.pv {
  padding-block: 1.25rem !important;
}

.ph {
  padding-inline: 1.25rem !important;
}

.p\\+ {
  padding: 2.5rem !important;
}

.pt\\+ {
  padding-top: 2.5rem !important;
}

.pr\\+ {
  padding-right: 2.5rem !important;
}

.pb\\+ {
  padding-bottom: 2.5rem !important;
}

.pl\\+ {
  padding-left: 2.5rem !important;
}

.pv\\+ {
  padding-block: 2.5rem !important;
}

.ph\\+ {
  padding-inline: 2.5rem !important;
}

.p\\+\\+ {
  padding: 5rem !important;
}

.pt\\+\\+ {
  padding-top: 5rem !important;
}

.pr\\+\\+ {
  padding-right: 5rem !important;
}

.pb\\+\\+ {
  padding-bottom: 5rem !important;
}

.pl\\+\\+ {
  padding-left: 5rem !important;
}

.pv\\+\\+ {
  padding-block: 5rem !important;
}

.ph\\+\\+ {
  padding-inline: 5rem !important;
}

@media screen and (width <= 46.9375em) {
  .m0\\(s\\) {
    margin: 0 !important;
  }

  .mt0\\(s\\) {
    margin-top: 0 !important;
  }

  .mr0\\(s\\) {
    margin-right: 0 !important;
  }

  .mb0\\(s\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(s\\) {
    margin-left: 0 !important;
  }

  .mv0\\(s\\) {
    margin-block: 0 !important;
  }

  .mh0\\(s\\) {
    margin-inline: 0 !important;
  }

  .m--\\(s\\) {
    margin: .313rem !important;
  }

  .mt--\\(s\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(s\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(s\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(s\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(s\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(s\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(s\\) {
    margin: .625rem !important;
  }

  .mt-\\(s\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(s\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(s\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(s\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(s\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(s\\) {
    margin-inline: .625rem !important;
  }

  .m\\(s\\) {
    margin: 1.25rem !important;
  }

  .mt\\(s\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(s\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(s\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(s\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(s\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(s\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(s\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(s\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(s\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(s\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(s\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(s\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(s\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(s\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(s\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(s\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(s\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(s\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(s\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(s\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(s\\) {
    padding: 0 !important;
  }

  .pt0\\(s\\) {
    padding-top: 0 !important;
  }

  .pr0\\(s\\) {
    padding-right: 0 !important;
  }

  .pb0\\(s\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(s\\) {
    padding-left: 0 !important;
  }

  .pv0\\(s\\) {
    padding-block: 0 !important;
  }

  .ph0\\(s\\) {
    padding-inline: 0 !important;
  }

  .p--\\(s\\) {
    padding: .313rem !important;
  }

  .pt--\\(s\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(s\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(s\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(s\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(s\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(s\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(s\\) {
    padding: .625rem !important;
  }

  .pt-\\(s\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(s\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(s\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(s\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(s\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(s\\) {
    padding-inline: .625rem !important;
  }

  .p\\(s\\) {
    padding: 1.25rem !important;
  }

  .pt\\(s\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(s\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(s\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(s\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(s\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(s\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(s\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(s\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(s\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(s\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(s\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(s\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(s\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(s\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(s\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(s\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(s\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(s\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(s\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(s\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .m0\\(m\\) {
    margin: 0 !important;
  }

  .mt0\\(m\\) {
    margin-top: 0 !important;
  }

  .mr0\\(m\\) {
    margin-right: 0 !important;
  }

  .mb0\\(m\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(m\\) {
    margin-left: 0 !important;
  }

  .mv0\\(m\\) {
    margin-block: 0 !important;
  }

  .mh0\\(m\\) {
    margin-inline: 0 !important;
  }

  .m--\\(m\\) {
    margin: .313rem !important;
  }

  .mt--\\(m\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(m\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(m\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(m\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(m\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(m\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(m\\) {
    margin: .625rem !important;
  }

  .mt-\\(m\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(m\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(m\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(m\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(m\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(m\\) {
    margin-inline: .625rem !important;
  }

  .m\\(m\\) {
    margin: 1.25rem !important;
  }

  .mt\\(m\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(m\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(m\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(m\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(m\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(m\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(m\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(m\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(m\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(m\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(m\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(m\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(m\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(m\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(m\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(m\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(m\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(m\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(m\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(m\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(m\\) {
    padding: 0 !important;
  }

  .pt0\\(m\\) {
    padding-top: 0 !important;
  }

  .pr0\\(m\\) {
    padding-right: 0 !important;
  }

  .pb0\\(m\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(m\\) {
    padding-left: 0 !important;
  }

  .pv0\\(m\\) {
    padding-block: 0 !important;
  }

  .ph0\\(m\\) {
    padding-inline: 0 !important;
  }

  .p--\\(m\\) {
    padding: .313rem !important;
  }

  .pt--\\(m\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(m\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(m\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(m\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(m\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(m\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(m\\) {
    padding: .625rem !important;
  }

  .pt-\\(m\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(m\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(m\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(m\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(m\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(m\\) {
    padding-inline: .625rem !important;
  }

  .p\\(m\\) {
    padding: 1.25rem !important;
  }

  .pt\\(m\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(m\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(m\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(m\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(m\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(m\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(m\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(m\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(m\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(m\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(m\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(m\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(m\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(m\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(m\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(m\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(m\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(m\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(m\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(m\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 47em), print {
  .m0\\(\\!s\\) {
    margin: 0 !important;
  }

  .mt0\\(\\!s\\) {
    margin-top: 0 !important;
  }

  .mr0\\(\\!s\\) {
    margin-right: 0 !important;
  }

  .mb0\\(\\!s\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(\\!s\\) {
    margin-left: 0 !important;
  }

  .mv0\\(\\!s\\) {
    margin-block: 0 !important;
  }

  .mh0\\(\\!s\\) {
    margin-inline: 0 !important;
  }

  .m--\\(\\!s\\) {
    margin: .313rem !important;
  }

  .mt--\\(\\!s\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(\\!s\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(\\!s\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(\\!s\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(\\!s\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(\\!s\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(\\!s\\) {
    margin: .625rem !important;
  }

  .mt-\\(\\!s\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(\\!s\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(\\!s\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(\\!s\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(\\!s\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(\\!s\\) {
    margin-inline: .625rem !important;
  }

  .m\\(\\!s\\) {
    margin: 1.25rem !important;
  }

  .mt\\(\\!s\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(\\!s\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(\\!s\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(\\!s\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(\\!s\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(\\!s\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(\\!s\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(\\!s\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(\\!s\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(\\!s\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(\\!s\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(\\!s\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(\\!s\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(\\!s\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(\\!s\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(\\!s\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(\\!s\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(\\!s\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(\\!s\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(\\!s\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(\\!s\\) {
    padding: 0 !important;
  }

  .pt0\\(\\!s\\) {
    padding-top: 0 !important;
  }

  .pr0\\(\\!s\\) {
    padding-right: 0 !important;
  }

  .pb0\\(\\!s\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(\\!s\\) {
    padding-left: 0 !important;
  }

  .pv0\\(\\!s\\) {
    padding-block: 0 !important;
  }

  .ph0\\(\\!s\\) {
    padding-inline: 0 !important;
  }

  .p--\\(\\!s\\) {
    padding: .313rem !important;
  }

  .pt--\\(\\!s\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(\\!s\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(\\!s\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(\\!s\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(\\!s\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(\\!s\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(\\!s\\) {
    padding: .625rem !important;
  }

  .pt-\\(\\!s\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(\\!s\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(\\!s\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(\\!s\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(\\!s\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(\\!s\\) {
    padding-inline: .625rem !important;
  }

  .p\\(\\!s\\) {
    padding: 1.25rem !important;
  }

  .pt\\(\\!s\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(\\!s\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(\\!s\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(\\!s\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(\\!s\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(\\!s\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(\\!s\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(\\!s\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(\\!s\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(\\!s\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(\\!s\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(\\!s\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(\\!s\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(\\!s\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(\\!s\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(\\!s\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(\\!s\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(\\!s\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(\\!s\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(\\!s\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width <= 74.9375em) {
  .m0\\(\\!l\\) {
    margin: 0 !important;
  }

  .mt0\\(\\!l\\) {
    margin-top: 0 !important;
  }

  .mr0\\(\\!l\\) {
    margin-right: 0 !important;
  }

  .mb0\\(\\!l\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(\\!l\\) {
    margin-left: 0 !important;
  }

  .mv0\\(\\!l\\) {
    margin-block: 0 !important;
  }

  .mh0\\(\\!l\\) {
    margin-inline: 0 !important;
  }

  .m--\\(\\!l\\) {
    margin: .313rem !important;
  }

  .mt--\\(\\!l\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(\\!l\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(\\!l\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(\\!l\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(\\!l\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(\\!l\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(\\!l\\) {
    margin: .625rem !important;
  }

  .mt-\\(\\!l\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(\\!l\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(\\!l\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(\\!l\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(\\!l\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(\\!l\\) {
    margin-inline: .625rem !important;
  }

  .m\\(\\!l\\) {
    margin: 1.25rem !important;
  }

  .mt\\(\\!l\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(\\!l\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(\\!l\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(\\!l\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(\\!l\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(\\!l\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(\\!l\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(\\!l\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(\\!l\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(\\!l\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(\\!l\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(\\!l\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(\\!l\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(\\!l\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(\\!l\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(\\!l\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(\\!l\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(\\!l\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(\\!l\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(\\!l\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(\\!l\\) {
    padding: 0 !important;
  }

  .pt0\\(\\!l\\) {
    padding-top: 0 !important;
  }

  .pr0\\(\\!l\\) {
    padding-right: 0 !important;
  }

  .pb0\\(\\!l\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(\\!l\\) {
    padding-left: 0 !important;
  }

  .pv0\\(\\!l\\) {
    padding-block: 0 !important;
  }

  .ph0\\(\\!l\\) {
    padding-inline: 0 !important;
  }

  .p--\\(\\!l\\) {
    padding: .313rem !important;
  }

  .pt--\\(\\!l\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(\\!l\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(\\!l\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(\\!l\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(\\!l\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(\\!l\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(\\!l\\) {
    padding: .625rem !important;
  }

  .pt-\\(\\!l\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(\\!l\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(\\!l\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(\\!l\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(\\!l\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(\\!l\\) {
    padding-inline: .625rem !important;
  }

  .p\\(\\!l\\) {
    padding: 1.25rem !important;
  }

  .pt\\(\\!l\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(\\!l\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(\\!l\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(\\!l\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(\\!l\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(\\!l\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(\\!l\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(\\!l\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(\\!l\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(\\!l\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(\\!l\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(\\!l\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(\\!l\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(\\!l\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(\\!l\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(\\!l\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(\\!l\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(\\!l\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(\\!l\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(\\!l\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 75em), print {
  .m0\\(l\\) {
    margin: 0 !important;
  }

  .mt0\\(l\\) {
    margin-top: 0 !important;
  }

  .mr0\\(l\\) {
    margin-right: 0 !important;
  }

  .mb0\\(l\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(l\\) {
    margin-left: 0 !important;
  }

  .mv0\\(l\\) {
    margin-block: 0 !important;
  }

  .mh0\\(l\\) {
    margin-inline: 0 !important;
  }

  .m--\\(l\\) {
    margin: .313rem !important;
  }

  .mt--\\(l\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(l\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(l\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(l\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(l\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(l\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(l\\) {
    margin: .625rem !important;
  }

  .mt-\\(l\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(l\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(l\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(l\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(l\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(l\\) {
    margin-inline: .625rem !important;
  }

  .m\\(l\\) {
    margin: 1.25rem !important;
  }

  .mt\\(l\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(l\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(l\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(l\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(l\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(l\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(l\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(l\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(l\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(l\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(l\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(l\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(l\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(l\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(l\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(l\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(l\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(l\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(l\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(l\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(l\\) {
    padding: 0 !important;
  }

  .pt0\\(l\\) {
    padding-top: 0 !important;
  }

  .pr0\\(l\\) {
    padding-right: 0 !important;
  }

  .pb0\\(l\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(l\\) {
    padding-left: 0 !important;
  }

  .pv0\\(l\\) {
    padding-block: 0 !important;
  }

  .ph0\\(l\\) {
    padding-inline: 0 !important;
  }

  .p--\\(l\\) {
    padding: .313rem !important;
  }

  .pt--\\(l\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(l\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(l\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(l\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(l\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(l\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(l\\) {
    padding: .625rem !important;
  }

  .pt-\\(l\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(l\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(l\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(l\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(l\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(l\\) {
    padding-inline: .625rem !important;
  }

  .p\\(l\\) {
    padding: 1.25rem !important;
  }

  .pt\\(l\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(l\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(l\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(l\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(l\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(l\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(l\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(l\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(l\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(l\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(l\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(l\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(l\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(l\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(l\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(l\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(l\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(l\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(l\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(l\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 90.0625em) {
  .m0\\(xl\\) {
    margin: 0 !important;
  }

  .mt0\\(xl\\) {
    margin-top: 0 !important;
  }

  .mr0\\(xl\\) {
    margin-right: 0 !important;
  }

  .mb0\\(xl\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(xl\\) {
    margin-left: 0 !important;
  }

  .mv0\\(xl\\) {
    margin-block: 0 !important;
  }

  .mh0\\(xl\\) {
    margin-inline: 0 !important;
  }

  .m--\\(xl\\) {
    margin: .313rem !important;
  }

  .mt--\\(xl\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(xl\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(xl\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(xl\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(xl\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(xl\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(xl\\) {
    margin: .625rem !important;
  }

  .mt-\\(xl\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(xl\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(xl\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(xl\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(xl\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(xl\\) {
    margin-inline: .625rem !important;
  }

  .m\\(xl\\) {
    margin: 1.25rem !important;
  }

  .mt\\(xl\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(xl\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(xl\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(xl\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(xl\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(xl\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(xl\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(xl\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(xl\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(xl\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(xl\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(xl\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(xl\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(xl\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(xl\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(xl\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(xl\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(xl\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(xl\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(xl\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(xl\\) {
    padding: 0 !important;
  }

  .pt0\\(xl\\) {
    padding-top: 0 !important;
  }

  .pr0\\(xl\\) {
    padding-right: 0 !important;
  }

  .pb0\\(xl\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(xl\\) {
    padding-left: 0 !important;
  }

  .pv0\\(xl\\) {
    padding-block: 0 !important;
  }

  .ph0\\(xl\\) {
    padding-inline: 0 !important;
  }

  .p--\\(xl\\) {
    padding: .313rem !important;
  }

  .pt--\\(xl\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(xl\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(xl\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(xl\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(xl\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(xl\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(xl\\) {
    padding: .625rem !important;
  }

  .pt-\\(xl\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(xl\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(xl\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(xl\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(xl\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(xl\\) {
    padding-inline: .625rem !important;
  }

  .p\\(xl\\) {
    padding: 1.25rem !important;
  }

  .pt\\(xl\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(xl\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(xl\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(xl\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(xl\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(xl\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(xl\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(xl\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(xl\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(xl\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(xl\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(xl\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(xl\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(xl\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(xl\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(xl\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(xl\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(xl\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(xl\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(xl\\) {
    padding-inline: 5rem !important;
  }
}

.u-gap0 {
  gap: 0 !important;
}

.u-gap-- {
  gap: .313rem !important;
}

.u-gap- {
  gap: .625rem !important;
}

.u-gap {
  gap: 1.25rem !important;
}

.u-gap\\+ {
  gap: 2.5rem !important;
}

.u-gap\\+\\+ {
  gap: 5rem !important;
}

@media screen and (width <= 46.9375em) {
  .u-gap0\\(s\\) {
    gap: 0 !important;
  }

  .u-gap--\\(s\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(s\\) {
    gap: .625rem !important;
  }

  .u-gap\\(s\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(s\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(s\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-gap0\\(m\\) {
    gap: 0 !important;
  }

  .u-gap--\\(m\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(m\\) {
    gap: .625rem !important;
  }

  .u-gap\\(m\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(m\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(m\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 47em), print {
  .u-gap0\\(\\!s\\) {
    gap: 0 !important;
  }

  .u-gap--\\(\\!s\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(\\!s\\) {
    gap: .625rem !important;
  }

  .u-gap\\(\\!s\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(\\!s\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(\\!s\\) {
    gap: 5rem !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-gap0\\(\\!l\\) {
    gap: 0 !important;
  }

  .u-gap--\\(\\!l\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(\\!l\\) {
    gap: .625rem !important;
  }

  .u-gap\\(\\!l\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(\\!l\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(\\!l\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 75em), print {
  .u-gap0\\(l\\) {
    gap: 0 !important;
  }

  .u-gap--\\(l\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(l\\) {
    gap: .625rem !important;
  }

  .u-gap\\(l\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(l\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(l\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-gap0\\(xl\\) {
    gap: 0 !important;
  }

  .u-gap--\\(xl\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(xl\\) {
    gap: .625rem !important;
  }

  .u-gap\\(xl\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(xl\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(xl\\) {
    gap: 5rem !important;
  }
}

.u-border {
  border: 1px solid var(--color-grey--light);
}

.u-border--left {
  border-left: 1px solid var(--color-grey--light);
}

.u-border--right {
  border-right: 1px solid var(--color-grey--light);
}

.u-border--top {
  border-top: 1px solid var(--color-grey--light);
}

.u-border--bottom {
  border-bottom: 1px solid var(--color-grey--light);
}

.u-text-color-white {
  color: var(--color-white--base);
}

.u-bg-color-white {
  background-color: var(--color-white--base);
}

.u-text-color-white--base {
  color: var(--color-white--base);
}

.u-bg-color-white--base {
  background-color: var(--color-white--base);
}

.u-text-color-grey {
  color: var(--color-grey--base);
}

.u-bg-color-grey {
  background-color: var(--color-grey--base);
}

.u-text-color-grey--base {
  color: var(--color-grey--base);
}

.u-bg-color-grey--base {
  background-color: var(--color-grey--base);
}

.u-text-color-grey--dark {
  color: var(--color-grey--dark);
}

.u-bg-color-grey--dark {
  background-color: var(--color-grey--dark);
}

.u-text-color-grey--light {
  color: var(--color-grey--light);
}

.u-bg-color-grey--light {
  background-color: var(--color-grey--light);
}

.u-text-color-grey--x-light {
  color: var(--color-grey--x-light);
}

.u-bg-color-grey--x-light {
  background-color: var(--color-grey--x-light);
}

.u-text-color-black {
  color: var(--color-black--base);
}

.u-bg-color-black {
  background-color: var(--color-black--base);
}

.u-text-color-black--base {
  color: var(--color-black--base);
}

.u-bg-color-black--base {
  background-color: var(--color-black--base);
}

.u-text-color-brand {
  color: var(--color-brand--base);
}

.u-bg-color-brand {
  background-color: var(--color-brand--base);
}

.u-text-color-brand--base {
  color: var(--color-brand--base);
}

.u-bg-color-brand--base {
  background-color: var(--color-brand--base);
}

.u-text-color-brand--accent {
  color: var(--color-brand--accent);
}

.u-bg-color-brand--accent {
  background-color: var(--color-brand--accent);
}

.u-text-color-brand--support {
  color: var(--color-brand--support);
}

.u-bg-color-brand--support {
  background-color: var(--color-brand--support);
}

.u-text-color-status--green {
  color: var(--color-status--green);
}

.u-bg-color-status--green {
  background-color: var(--color-status--green);
}

.u-text-color-status--orange {
  color: var(--color-status--orange);
}

.u-bg-color-status--orange {
  background-color: var(--color-status--orange);
}

.u-text-color-status--yellow {
  color: var(--color-status--yellow);
}

.u-bg-color-status--yellow {
  background-color: var(--color-status--yellow);
}

.u-text-color-status--red {
  color: var(--color-status--red);
}

.u-bg-color-status--red {
  background-color: var(--color-status--red);
}

.u-text-color-status--marked {
  color: var(--color-status--marked);
}

.u-bg-color-status--marked {
  background-color: var(--color-status--marked);
}

.u-text-color-nav {
  color: var(--color-nav--base);
}

.u-bg-color-nav {
  background-color: var(--color-nav--base);
}

.u-text-color-nav--base {
  color: var(--color-nav--base);
}

.u-bg-color-nav--base {
  background-color: var(--color-nav--base);
}

.u-text-color-nav--hover {
  color: var(--color-nav--hover);
}

.u-bg-color-nav--hover {
  background-color: var(--color-nav--hover);
}

.u-text-color-gradient1--from {
  color: var(--color-gradient1--from);
}

.u-bg-color-gradient1--from {
  background-color: var(--color-gradient1--from);
}

.u-text-color-gradient1--to {
  color: var(--color-gradient1--to);
}

.u-bg-color-gradient1--to {
  background-color: var(--color-gradient1--to);
}

.u-text-color-gradient2--from {
  color: var(--color-gradient2--from);
}

.u-bg-color-gradient2--from {
  background-color: var(--color-gradient2--from);
}

.u-text-color-gradient2--to {
  color: var(--color-gradient2--to);
}

.u-bg-color-gradient2--to {
  background-color: var(--color-gradient2--to);
}

.u-text-color-gradient3--from {
  color: var(--color-gradient3--from);
}

.u-bg-color-gradient3--from {
  background-color: var(--color-gradient3--from);
}

.u-text-color-gradient3--to {
  color: var(--color-gradient3--to);
}

.u-bg-color-gradient3--to {
  background-color: var(--color-gradient3--to);
}

.u-gradient1 {
  background: var(--color-gradient1--from);
  background: linear-gradient(to bottom, var(--color-gradient1--from) 0%, var(--color-gradient1--to) 100%);
}

.u-gradient1--inverse {
  background: var(--color-gradient1--to);
  background: linear-gradient(to bottom, var(--color-gradient1--to) 0%, var(--color-gradient1--from) 100%);
}

.u-gradient1--ltr {
  background: var(--color-gradient1--from);
  background: linear-gradient(to right, var(--color-gradient1--from) 0%, var(--color-gradient1--to) 100%);
}

.u-gradient1--rtl {
  background: var(--color-gradient1--to);
  background: linear-gradient(to right, var(--color-gradient1--to) 0%, var(--color-gradient1--from) 100%);
}

.u-gradient2 {
  background: var(--color-gradient2--from);
  background: linear-gradient(to bottom, var(--color-gradient2--from) 0%, var(--color-gradient2--to) 100%);
}

.u-gradient2--inverse {
  background: var(--color-gradient2--to);
  background: linear-gradient(to bottom, var(--color-gradient2--to) 0%, var(--color-gradient2--from) 100%);
}

.u-gradient2--ltr {
  background: var(--color-gradient2--from);
  background: linear-gradient(to right, var(--color-gradient2--from) 0%, var(--color-gradient2--to) 100%);
}

.u-gradient2--rtl {
  background: var(--color-gradient2--to);
  background: linear-gradient(to right, var(--color-gradient2--to) 0%, var(--color-gradient2--from) 100%);
}

.u-gradient3 {
  background: var(--color-gradient3--from);
  background: linear-gradient(to bottom, var(--color-gradient3--from) 0%, var(--color-gradient3--to) 100%);
}

.u-gradient3--inverse {
  background: var(--color-gradient3--to);
  background: linear-gradient(to bottom, var(--color-gradient3--to) 0%, var(--color-gradient3--from) 100%);
}

.u-gradient3--ltr {
  background: var(--color-gradient3--from);
  background: linear-gradient(to right, var(--color-gradient3--from) 0%, var(--color-gradient3--to) 100%);
}

.u-gradient3--rtl {
  background: var(--color-gradient3--to);
  background: linear-gradient(to right, var(--color-gradient3--to) 0%, var(--color-gradient3--from) 100%);
}

.u-1\\/1 {
  width: 100% !important;
}

.u-1\\/2 {
  flex: none !important;
  width: 50% !important;
}

.u-2\\/2 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/3 {
  flex: none !important;
  width: 33.3333% !important;
}

.u-2\\/3 {
  flex: none !important;
  width: 66.6667% !important;
}

.u-3\\/3 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/4 {
  flex: none !important;
  width: 25% !important;
}

.u-2\\/4 {
  flex: none !important;
  width: 50% !important;
}

.u-3\\/4 {
  flex: none !important;
  width: 75% !important;
}

.u-4\\/4 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/5 {
  flex: none !important;
  width: 20% !important;
}

.u-2\\/5 {
  flex: none !important;
  width: 40% !important;
}

.u-3\\/5 {
  flex: none !important;
  width: 60% !important;
}

.u-4\\/5 {
  flex: none !important;
  width: 80% !important;
}

.u-5\\/5 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/10 {
  flex: none !important;
  width: 10% !important;
}

.u-2\\/10 {
  flex: none !important;
  width: 20% !important;
}

.u-3\\/10 {
  flex: none !important;
  width: 30% !important;
}

.u-4\\/10 {
  flex: none !important;
  width: 40% !important;
}

.u-5\\/10 {
  flex: none !important;
  width: 50% !important;
}

.u-6\\/10 {
  flex: none !important;
  width: 60% !important;
}

.u-7\\/10 {
  flex: none !important;
  width: 70% !important;
}

.u-8\\/10 {
  flex: none !important;
  width: 80% !important;
}

.u-9\\/10 {
  flex: none !important;
  width: 90% !important;
}

.u-10\\/10 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/24 {
  flex: none !important;
  width: 4.16667% !important;
}

.u-2\\/24 {
  flex: none !important;
  width: 8.33333% !important;
}

.u-3\\/24 {
  flex: none !important;
  width: 12.5% !important;
}

.u-4\\/24 {
  flex: none !important;
  width: 16.6667% !important;
}

.u-5\\/24 {
  flex: none !important;
  width: 20.8333% !important;
}

.u-6\\/24 {
  flex: none !important;
  width: 25% !important;
}

.u-7\\/24 {
  flex: none !important;
  width: 29.1667% !important;
}

.u-8\\/24 {
  flex: none !important;
  width: 33.3333% !important;
}

.u-9\\/24 {
  flex: none !important;
  width: 37.5% !important;
}

.u-10\\/24 {
  flex: none !important;
  width: 41.6667% !important;
}

.u-11\\/24 {
  flex: none !important;
  width: 45.8333% !important;
}

.u-12\\/24 {
  flex: none !important;
  width: 50% !important;
}

.u-13\\/24 {
  flex: none !important;
  width: 54.1667% !important;
}

.u-14\\/24 {
  flex: none !important;
  width: 58.3333% !important;
}

.u-15\\/24 {
  flex: none !important;
  width: 62.5% !important;
}

.u-16\\/24 {
  flex: none !important;
  width: 66.6667% !important;
}

.u-17\\/24 {
  flex: none !important;
  width: 70.8333% !important;
}

.u-18\\/24 {
  flex: none !important;
  width: 75% !important;
}

.u-19\\/24 {
  flex: none !important;
  width: 79.1667% !important;
}

.u-20\\/24 {
  flex: none !important;
  width: 83.3333% !important;
}

.u-21\\/24 {
  flex: none !important;
  width: 87.5% !important;
}

.u-22\\/24 {
  flex: none !important;
  width: 91.6667% !important;
}

.u-23\\/24 {
  flex: none !important;
  width: 95.8333% !important;
}

.u-24\\/24 {
  flex: none !important;
  width: 100% !important;
}

@media screen and (width <= 46.9375em) {
  .u-1\\/1\\(s\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(s\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(s\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(s\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(s\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(s\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(s\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(s\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(s\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(s\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(s\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(s\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(s\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(s\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(s\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(s\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(s\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(s\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(s\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(s\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(s\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(s\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(s\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(s\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(s\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(s\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(s\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(s\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(s\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(s\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(s\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(s\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(s\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(s\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(s\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(s\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(s\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(s\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(s\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-1\\/1\\(m\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(m\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(m\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(m\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(m\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(m\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(m\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(m\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(m\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(m\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(m\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(m\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(m\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(m\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(m\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(m\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(m\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(m\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(m\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(m\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(m\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(m\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(m\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(m\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(m\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(m\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(m\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(m\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(m\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(m\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(m\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(m\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(m\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(m\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(m\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(m\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(m\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(m\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(m\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(m\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(m\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(m\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(m\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width >= 47em), print {
  .u-1\\/1\\(\\!s\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(\\!s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(\\!s\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(\\!s\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(\\!s\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(\\!s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(\\!s\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(\\!s\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(\\!s\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(\\!s\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(\\!s\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(\\!s\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(\\!s\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(\\!s\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(\\!s\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(\\!s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(\\!s\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(\\!s\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(\\!s\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(\\!s\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(\\!s\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(\\!s\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(\\!s\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(\\!s\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(\\!s\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(\\!s\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(\\!s\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(\\!s\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(\\!s\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(\\!s\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(\\!s\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(\\!s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(\\!s\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(\\!s\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(\\!s\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(\\!s\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(\\!s\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(\\!s\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(\\!s\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(\\!s\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(\\!s\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(\\!s\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(\\!s\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-1\\/1\\(\\!l\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(\\!l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(\\!l\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(\\!l\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(\\!l\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(\\!l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(\\!l\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(\\!l\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(\\!l\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(\\!l\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(\\!l\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(\\!l\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(\\!l\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(\\!l\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(\\!l\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(\\!l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(\\!l\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(\\!l\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(\\!l\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(\\!l\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(\\!l\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(\\!l\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(\\!l\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(\\!l\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(\\!l\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(\\!l\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(\\!l\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(\\!l\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(\\!l\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(\\!l\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(\\!l\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(\\!l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(\\!l\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(\\!l\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(\\!l\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(\\!l\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(\\!l\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(\\!l\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(\\!l\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(\\!l\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(\\!l\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(\\!l\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(\\!l\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width >= 75em), print {
  .u-1\\/1\\(l\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(l\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(l\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(l\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(l\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(l\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(l\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(l\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(l\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(l\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(l\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(l\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(l\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(l\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(l\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(l\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(l\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(l\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(l\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(l\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(l\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(l\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(l\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(l\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(l\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(l\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(l\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(l\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(l\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(l\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(l\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(l\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(l\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(l\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(l\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(l\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(l\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(l\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(l\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-1\\/1\\(xl\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(xl\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(xl\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(xl\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(xl\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(xl\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(xl\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(xl\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(xl\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(xl\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(xl\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(xl\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(xl\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(xl\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(xl\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(xl\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(xl\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(xl\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(xl\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(xl\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(xl\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(xl\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(xl\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(xl\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(xl\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(xl\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(xl\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(xl\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(xl\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(xl\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(xl\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(xl\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(xl\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(xl\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(xl\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(xl\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(xl\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(xl\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(xl\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(xl\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(xl\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(xl\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(xl\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }
}

.u-display--inline {
  display: inline !important;
}

.u-display--inline-block {
  display: inline-block !important;
}

.u-display--block {
  display: block !important;
}

.u-display--flex {
  display: flex !important;
}

.u-display--inline-flex {
  display: inline-flex !important;
}

.u-display--none {
  display: none !important;
}

@media screen and (width <= 46.9375em) {
  .u-display--inline\\(s\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(s\\) {
    display: inline-block !important;
  }

  .u-display--block\\(s\\) {
    display: block !important;
  }

  .u-display--flex\\(s\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(s\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(s\\) {
    display: none !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-display--inline\\(m\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(m\\) {
    display: inline-block !important;
  }

  .u-display--block\\(m\\) {
    display: block !important;
  }

  .u-display--flex\\(m\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(m\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(m\\) {
    display: none !important;
  }
}

@media screen and (width >= 47em), print {
  .u-display--inline\\(\\!s\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(\\!s\\) {
    display: inline-block !important;
  }

  .u-display--block\\(\\!s\\) {
    display: block !important;
  }

  .u-display--flex\\(\\!s\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(\\!s\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(\\!s\\) {
    display: none !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-display--inline\\(\\!l\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(\\!l\\) {
    display: inline-block !important;
  }

  .u-display--block\\(\\!l\\) {
    display: block !important;
  }

  .u-display--flex\\(\\!l\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(\\!l\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(\\!l\\) {
    display: none !important;
  }
}

@media screen and (width >= 75em), print {
  .u-display--inline\\(l\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(l\\) {
    display: inline-block !important;
  }

  .u-display--block\\(l\\) {
    display: block !important;
  }

  .u-display--flex\\(l\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(l\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(l\\) {
    display: none !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-display--inline\\(xl\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(xl\\) {
    display: inline-block !important;
  }

  .u-display--block\\(xl\\) {
    display: block !important;
  }

  .u-display--flex\\(xl\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(xl\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(xl\\) {
    display: none !important;
  }
}

.u-display--flow-root {
  display: flow-root !important;
}

.u-position--absolute {
  position: absolute !important;
}

.u-position--relative {
  position: relative !important;
}

.u-position--fixed {
  position: fixed !important;
}

.u-position--static {
  position: static !important;
}

.u-text-align--left {
  text-align: left !important;
}

.u-text-align--right {
  text-align: right !important;
}

.u-text-align--center {
  text-align: center !important;
}

@media screen and (width <= 46.9375em) {
  .u-text-align--left\\(s\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(s\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(s\\) {
    text-align: center !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-text-align--left\\(m\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(m\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(m\\) {
    text-align: center !important;
  }
}

@media screen and (width >= 47em), print {
  .u-text-align--left\\(\\!s\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(\\!s\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(\\!s\\) {
    text-align: center !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-text-align--left\\(\\!l\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(\\!l\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(\\!l\\) {
    text-align: center !important;
  }
}

@media screen and (width >= 75em), print {
  .u-text-align--left\\(l\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(l\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(l\\) {
    text-align: center !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-text-align--left\\(xl\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(xl\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(xl\\) {
    text-align: center !important;
  }
}

.u-font-weight--normal {
  font-weight: normal !important;
}

.u-font-weight--bold {
  font-weight: bold !important;
}

.u-font-style--normal {
  font-style: normal !important;
}

.u-font-style--italic {
  font-style: italic !important;
}

.u-text-decoration--underline {
  text-decoration: underline !important;
}

.u-text-decoration--line-through {
  text-decoration: line-through !important;
}

.u-text-decoration--none {
  text-decoration: none !important;
}

.u-border--none {
  border: none !important;
}

.u-border-color--inherit {
  border-color: inherit !important;
}

.u-line-height--normal {
  line-height: normal !important;
}

.u-white-space--nowrap {
  white-space: nowrap !important;
}

.u-white-space--normal {
  white-space: normal !important;
}

@media screen and (width <= 46.9375em) {
  .u-white-space--nowrap\\(s\\) {
    white-space: nowrap !important;
  }

  .u-white-space--normal\\(s\\) {
    white-space: normal !important;
  }
}

@media screen and (width >= 47em), print {
  .u-white-space--nowrap\\(\\!s\\) {
    white-space: nowrap !important;
  }

  .u-white-space--normal\\(\\!s\\) {
    white-space: normal !important;
  }
}

@media screen and (width >= 75em), print {
  .u-white-space--nowrap\\(l\\) {
    white-space: nowrap !important;
  }

  .u-white-space--normal\\(l\\) {
    white-space: normal !important;
  }
}

.u-opacity--0 {
  opacity: 0 !important;
}

.u-opacity--25 {
  opacity: .25 !important;
}

.u-opacity--50 {
  opacity: .5 !important;
}

.u-opacity--75 {
  opacity: .75 !important;
}

.u-opacity--90 {
  opacity: .9 !important;
}

.u-cursor--pointer {
  cursor: pointer !important;
}

.u-cursor--default {
  cursor: default !important;
}

.u-visibility--hidden {
  visibility: hidden !important;
}

.u-overflow--hidden {
  overflow: hidden !important;
}

.u-margin-left--auto {
  margin-left: auto !important;
}

@media screen and (width >= 47em), print {
  .u-margin-left--auto\\(\\!s\\) {
    margin-left: auto !important;
  }
}

.u-width--auto {
  width: auto !important;
}

.u-flex-wrap--nowrap {
  flex-wrap: nowrap !important;
}

.u-flex-wrap--wrap {
  flex-wrap: wrap !important;
}

@media screen and (width <= 46.9375em) {
  .u-flex-wrap--nowrap\\(s\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(s\\) {
    flex-wrap: wrap !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-flex-wrap--nowrap\\(m\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(m\\) {
    flex-wrap: wrap !important;
  }
}

@media screen and (width >= 47em), print {
  .u-flex-wrap--nowrap\\(\\!s\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(\\!s\\) {
    flex-wrap: wrap !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-flex-wrap--nowrap\\(\\!l\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(\\!l\\) {
    flex-wrap: wrap !important;
  }
}

@media screen and (width >= 75em), print {
  .u-flex-wrap--nowrap\\(l\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(l\\) {
    flex-wrap: wrap !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-flex-wrap--nowrap\\(xl\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(xl\\) {
    flex-wrap: wrap !important;
  }
}

.u-order---1 {
  order: -1 !important;
}

.u-order--1 {
  order: 1 !important;
}

@media screen and (width <= 46.9375em) {
  .u-order---1\\(s\\) {
    order: -1 !important;
  }

  .u-order--1\\(s\\) {
    order: 1 !important;
  }
}

@media screen and (width >= 47em), print {
  .u-order---1\\(\\!s\\) {
    order: -1 !important;
  }

  .u-order--1\\(\\!s\\) {
    order: 1 !important;
  }
}
`;


class $57570d85ec6a9fac$var$WJPackagePricedetails extends (0, $baeea1393dcde116$export$3f2f9f5909897157) {
    constructor(...args){
        super(...args);
        this.data = null;
        this.packageTemplate = null;
    }
    static get properties() {
        return {
            cost: {
                type: Object
            }
        };
    }
    renderProperty(element) {
        return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`<tr>
      <td>${element.caption.text}</td>
      <td>${element.content.text}</td>
    </tr>`;
    }
    euroDisplay(amount) {
        if (isNaN(amount) && amount.indexOf(",") > -1) amount = amount.replace(/\,/g, ".");
        return (0, $35c35420358b7a61$export$b6e69390c23686fb)(parseFloat(amount).toFixed(2).replace(".", ",") + "&nbsp;&euro;");
    }
    render() {
        let cost = this.cost;
        let usagePrice;
        if (cost.unitPriceOnPeak) usagePrice = (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`${cost.unitPriceOnPeak.content.text} (Hauptzeit) <br />
        ${cost.unitPriceOffPeak.content.text} (Nebenzeit)`;
        else if (cost.unitPrice) usagePrice = (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`${cost.unitPrice.content.text}`;
        let totalPriceWithoutBonus = (parseFloat(cost.usageCosts.amount.replace(/\,/g, ".")) + parseFloat(cost.fixedCosts.amount.replace(/\,/g, "."))).toFixed(2);
        let totalMonthlyPriceWithoutBonus = (totalPriceWithoutBonus / 12).toFixed(2);
        let bonusItems = cost.totalCost.totalCostItems.filter((item)=>item.caption.text.toLowerCase().indexOf("bonus") > -1);
        let bonusItemsHtml = bonusItems.map((item)=>{
            return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`
      <div class="layout__item u-7/24(!s) u-10/24(s) mb--">
        <span class="u-text-color-status--green">${item.caption.text}</span>
      </div>
      <div class="layout__item u-7/24(!s) u-10/24(s) u-text-color-status--green">${item.content.text}</div>
      <div class="layout__item u-10/24 u-display--none(s)"></div>`;
        });
        return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`<h5 class="mb-">Informationen zum Preis</h5>
      <div class="layout">
        <div class="layout__item u-7/24(!s) u-10/24(s) mb--">${cost.usageCosts.caption.text}</div>
        <div class="layout__item u-7/24">${cost.usageCosts.content.text}</div>
        <div class="layout__item u-10/24(!s) u-7/24(s)">${usagePrice}</div>
        <div class="layout__item u-7/24(!s) u-10/24(s) mb--">${cost.fixedCosts.caption.text}</div>
        <div class="layout__item u-7/24">${cost.fixedCosts.content.text}</div>
        <div class="layout__item u-10/24(!s) u-7/24(s)">entspricht ${cost.totalCost.totalCostItems[1].content.text}</div>
        <div class="layout__item u-7/24(!s) u-10/24(s) mb--">Gesamtpreis ohne Bonus</div>
        <div class="layout__item u-7/24">${this.euroDisplay(totalPriceWithoutBonus)}</div>
        <div class="layout__item u-10/24(!s) u-7/24(s)">${this.euroDisplay(totalMonthlyPriceWithoutBonus)} pro Monat</div>
        ${bonusItemsHtml}
        <div class="layout__item u-7/24(!s) u-10/24(s) mt u-font-weight--bold">
        <span>${cost.totalCost.caption.text}</span>
        <bc-tooltip data-trigger-style="dashed"> ${(0, $35c35420358b7a61$export$b6e69390c23686fb)(cost.totalCost.content.tooltip.body)} </bc-tooltip>
        </div>
        <div class="layout__item u-7/24(!s) u-14/24(s) u-font-weight--bold pt- mt- u-border--top">${cost.totalCost.content.text}</div>
        <div class="layout__item u-10/24"></div>
      </div>
      <div class="mt u-size-s">Die Preisangaben für Haushaltskunden enthalten alle notwendigen Gebühren und steuerlichen Abgaben. Die Preisangaben für Gewerbekunden sind exklusive Mehrwertsteuer. Beachten Sie, dass sich alle Berechnungen auf das erste Vertragsjahr beziehen. Die Boni sind in den geschätzten Abschlag noch nicht mit einberechnet. Der Sofortbonus wird innerhalb von 60 Tagen überwiesen. Der Neukundenbonus wird am Ende des ersten Vertragsjahres gutgeschrieben oder ausgezahlt.</div>`;
    }
}
$57570d85ec6a9fac$var$WJPackagePricedetails.styles = [
    (0, $3a4e11a1b8275a7f$export$7b27f05b38c84a35)
];
const $57570d85ec6a9fac$export$52903f8746ee997 = ()=>{
    window.customElements.define("wj-package-pricedetails", $57570d85ec6a9fac$var$WJPackagePricedetails);
};



class $25dde1ac1c25d527$var$WJPackageConditions extends (0, $baeea1393dcde116$export$3f2f9f5909897157) {
    constructor(...args){
        super(...args);
        this.data = null;
        this.packageTemplate = null;
    }
    static get properties() {
        return {
            conditions: {
                type: Object
            }
        };
    }
    render() {
        return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`<span>Conidition</span> `;
    }
}
const $25dde1ac1c25d527$export$99daf0be1c6fc316 = ()=>{
    window.customElements.define("wj-package-conditions", $25dde1ac1c25d527$var$WJPackageConditions);
};




const $be764c3dce225edf$export$9c03a21429c8dee0 = (0, $2ebca2d23ae8704c$export$dbf350e5966cf602)`:root {
  --duration-fast: .3s;
  --duration-medium: .75s;
  --duration-slow: 1.2s;
  --swift-ease-out-timing-function: cubic-bezier(.25, .8, .25, 1);
  --swift-ease-out: all var(--duration-fast) var(--swift-ease-out-timing-function);
  --swift-ease-in-timing-function: cubic-bezier(.55, 0, .55, .2);
  --swift-ease-in: all var(--duration-fast) var(--swift-ease-in-timing-function);
  --swift-ease-in-out-timing-function: cubic-bezier(.35, 0, .25, 1);
  --swift-ease-in-out: all var(--duration-fast) var(--swift-ease-in-out-timing-function);
  --border-radius-none: 0;
  --border-radius-xs: 4px;
  --border-radius-s: 8px;
  --border-radius: 16px;
  --border-radius-m: 16px;
  --border-radius-l: 32px;
  --border-radius-xl: 999em;
  --color-white: #fff;
  --color-white--base: #fff;
  --color-grey: #757575;
  --color-grey--base: #757575;
  --color-grey--dark: #3d3d3d;
  --color-grey--light: #d4d4d4;
  --color-grey--x-light: #f7f7f7;
  --color-black: #000;
  --color-black--base: #000;
  --color-brand: #aa183f;
  --color-brand--base: #aa183f;
  --color-brand--accent: #1470d2;
  --color-brand--support: #00496b;
  --color-status--green: #008500;
  --color-status--orange: #ff9500;
  --color-status--yellow: #fc0;
  --color-status--red: red;
  --color-status--marked: #ffec99;
  --color-nav: #308271;
  --color-nav--base: #308271;
  --color-nav--hover: #297064;
  --color-gradient1--from: #4db380;
  --color-gradient1--to: #508a95;
  --color-gradient2--from: #62a38d;
  --color-gradient2--to: #5a908e;
  --color-gradient3--from: #e7efec;
  --color-gradient3--to: #e8eeec;
  --spacing-1: 0;
  --spacing0: 0;
  --spacing-2: .313rem;
  --spacing--: .313rem;
  --spacing-3: .625rem;
  --spacing-: .625rem;
  --spacing-4: 1.25rem;
  --spacing: 1.25rem;
  --spacing-5: 2.5rem;
  --spacing\\+: 2.5rem;
  --spacing-6: 5rem;
  --spacing\\+\\+: 5rem;
  --color-tag-green--dark: #008500;
  --color-tag-green--light: #eefcee;
  --color-tag-cyan--dark: #558891;
  --color-tag-cyan--light: #e9f0f2;
  --color-tag-purple--dark: #4e5eb1;
  --color-tag-purple--light: #e8ebfd;
  --color-tag-orange--dark: #ff9500;
  --color-tag-orange--light: #fffbf5;
  --color-tag-blue--dark: #00496b;
  --color-tag-blue--light: #deedfc;
  --color-tag-white--dark: #fff;
  --color-tag-white--light: #ffffff26;
  --brand-face: "Source Sans 3 VF", sans-serif;
  --spec-face: "Oxygen", sans-serif;
  --font-weight-semibold: 500;
  --font-weight-bold: bold;
  --font-size-button: 18px;
  --line-height-button: 20px;
  --font-size-xl: 1.4375rem;
  --line-height-xl: 30px;
  --font-size-l: 1.25rem;
  --line-height-l: 30px;
  --font-size-m: 1rem;
  --line-height-m: 1.2;
  --font-size-s: .875rem;
  --line-height-s: 20px;
  --font-size-xs: .75rem;
  --line-height-xs: 16px;
  --font-size-h1: 3rem;
  --line-height-h1: 50px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h1: 32px;
    --line-height-h1: 35px;
  }
}

:root {
  --font-size-h2: 2rem;
  --line-height-h2: 35px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h2: 28px;
    --line-height-h2: 28px;
  }
}

:root {
  --font-size-h3: 1.75rem;
  --line-height-h3: 28px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h3: 23px;
    --line-height-h3: 30px;
  }
}

:root {
  --font-size-h4: 1.4375rem;
  --line-height-h4: 30px;
  --font-size-h5: 1.25rem;
  --line-height-h5: 30px;
  --font-size-h6: .875rem;
  --line-height-h6: 20px;
}

[role="button"], [type="submit"], [type="reset"], [type="button"], button {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

[type="submit"], [type="reset"], [type="button"], button {
  color: inherit;
  font: inherit;
  line-height: inherit;
  -webkit-appearance: button;
  appearance: button;
  -webkit-user-select: none;
  user-select: none;
  background: none;
  border: 0;
  margin: 0;
  padding: 0;
  overflow: visible;
}

input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

button::-moz-focus-inner {
  border: 0;
  padding: 0;
}

[role="button"] {
  color: inherit;
  cursor: default;
  text-align: center;
  white-space: pre;
  -webkit-user-select: none;
  user-select: none;
  text-decoration: none;
  display: inline-block;
}

*, :before, :after {
  box-sizing: border-box;
}

html {
  -webkit-text-size-adjust: 100%;
  tab-size: 4;
  font-family: system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji;
  line-height: 1.15;
}

body {
  margin: 0;
}

b, strong {
  font-weight: bolder;
}

code, kbd, samp, pre {
  font-family: ui-monospace, SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace;
  font-size: 1em;
}

small {
  font-size: 80%;
}

sub, sup {
  vertical-align: baseline;
  font-size: 75%;
  line-height: 0;
  position: relative;
}

sub {
  bottom: -.25em;
}

sup {
  top: -.5em;
}

table {
  border-color: currentColor;
}

button, input, optgroup, select, textarea {
  outline: none;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
}

button, [type="button"], [type="reset"], [type="submit"] {
  -webkit-appearance: button;
}

legend {
  padding: 0;
}

progress {
  vertical-align: baseline;
}

::-webkit-inner-spin-button {
  height: auto;
}

::-webkit-outer-spin-button {
  height: auto;
}

[type="search"] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}

summary {
  display: list-item;
}

:root {
  line-height: 1.5;
}

h1, h2, h3, h4, h5, figure, p, ol, ul {
  margin: 0;
}

ol[role="list"], ul[role="list"] {
  padding-inline: 0;
  list-style: none;
}

h1, h2, h3, h4, h5 {
  font-size: inherit;
  font-weight: inherit;
}

img {
  max-inline-size: 100%;
  display: block;
}

button {
  text-align: inherit;
  cursor: pointer;
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

label {
  cursor: pointer;
  display: block;
}

p a, h1 a, h2 a, h3 a, h4 a, h5 a, h6 a {
  color: inherit;
}

input[type="text"], input[type="email"], input[type="password"], input[type="search"]:not(.vs__search), input[type="color"], input[type="date"], input[type="datetime-local"], input[type="month"], input[type="number"], input[type="tel"], input[type="time"], input[type="url"], input[type="week"], input[list], select, textarea {
  -webkit-appearance: none;
  appearance: none;
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
  background-color: var(--color-white);
  border-radius: var(--border-radius-m);
  border: 1px solid var(--color-grey--light);
  color: var(--color-grey--dark);
  width: 100%;
  padding: 14px 15px;
}

@media screen and (width <= 46.9375em) {
  input[type="text"], input[type="email"], input[type="password"], input[type="search"]:not(.vs__search), input[type="color"], input[type="date"], input[type="datetime-local"], input[type="month"], input[type="number"], input[type="tel"], input[type="time"], input[type="url"], input[type="week"], input[list], select, textarea {
    font-size: var(--font-size-m);
    line-height: var(--line-height-s);
  }
}

input[type="date"], input[type="datetime-local"] {
  min-height: 50px;
}

input[type="text"]:read-only, input[type="email"]:read-only, input[type="password"]:read-only, input[type="search"]:read-only, input[type="color"]:read-only, input[type="date"]:read-only, input[type="datetime-local"]:read-only, input[type="month"]:read-only, input[type="number"]:read-only, input[type="tel"]:read-only, input[type="time"]:read-only, input[type="url"]:read-only, input[type="week"]:read-only, input[list]:read-only {
  background-color: var(--color-grey--x-light);
  box-shadow: none !important;
}

input[name*="postcode"], input[name*="Postal"], input[name*="postal"] {
  text-transform: uppercase;
}

::placeholder {
  color: var(--color-grey);
}

html {
  background-color: var(--color-white);
  font-size: var(--font-size-m);
  line-height: var(--line-height-m);
  color: var(--color-grey--dark);
  -webkit-font-smoothing: antialiased;
  scrollbar-gutter: stable;
  overflow-y: scroll;
}

hr {
  border: 0;
  border-bottom: 1px solid var(--color-grey--light);
}

p {
  margin: 0 0 20px;
}

ol, ul {
  padding-left: 20px;
}

summary {
  cursor: pointer;
}

abbr[title] {
  text-decoration: none;
}

img {
  max-width: 100%;
}

@media screen and (width <= 46.9375em) {
  img[data-lazyload-src][style*="height"], img[data-lazyload-src][height], img[src][style*="height"], img[src][height] {
    max-width: 100% !important;
    height: auto !important;
  }
}

table {
  width: 100%;
}

table td {
  vertical-align: top;
  padding: 0;
}

body {
  font-family: var(--brand-face);
}

h1, h2, h3 {
  font-style: italic;
}

h1, h2, h3, h4, h5, h6 {
  font-weight: bold;
}

h1 {
  font-size: var(--font-size-h1);
  line-height: var(--line-height-h1);
}

h2 {
  font-size: var(--font-size-h2);
  line-height: var(--line-height-h2);
}

h3 {
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
}

h4 {
  font-size: var(--font-size-h4);
  line-height: var(--line-height-h4);
}

h5 {
  font-size: var(--font-size-h5);
  line-height: var(--line-height-h5);
}

h6 {
  font-size: var(--font-size-h6);
  line-height: var(--line-height-h6);
  margin: 0;
}

strong, b {
  font-weight: bold;
}

small {
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
}

button, a {
  text-decoration: none;
}

button:hover, a:hover, p a {
  text-decoration: underline;
}

p a:hover {
  text-decoration: none;
}

:has( + bc-tooltip:not([data-trigger-style])) {
  color: var(--color-status--red);
  position: relative;
}

:has( + bc-tooltip:not([data-trigger-style])):before {
  content: "Missing attribute 'data-trigger-style'";
  white-space: nowrap;
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
  color: var(--color-white);
  background-color: var(--color-status--orange);
  z-index: 40;
  border-radius: 5px;
  width: 200px;
  padding: 3px 10px;
  position: absolute;
  top: 20px;
}

:has( + bc-tooltip[data-trigger-style="dashed"]) {
  text-underline-offset: .2rem;
  text-decoration: underline from-font dashed;
}

:has( + bc-tooltip[data-trigger-style="info-icon"]):after, :has( + bc-tooltip[data-trigger-style="info-icon-border"]):after {
  content: "";
  background-image: url("https://cdn.wechseljetzt.de/assets/wj/img/icons/info.svg");
  background-position: center;
  background-repeat: no-repeat;
  width: 5px;
  height: 11px;
  margin-left: 5px;
  display: inline-block;
}

:has( + bc-tooltip[data-trigger-style="info-icon-border"]):after {
  content: "";
  border: 1px solid var(--color-grey);
  border-radius: var(--border-radius-xl);
  margin-bottom: -3px;
  padding: 9px 10px 10px;
}

.layout {
  flex-wrap: wrap;
  margin: 0 0 0 -20px;
  padding: 0;
  list-style: none;
  display: flex;
}

@media screen and (width >= 47em), print {
  .layout--nowrap {
    flex-wrap: nowrap;
  }
}

.layout--rev {
  flex-direction: row-reverse;
}

.layout--middle {
  align-items: center;
}

.layout--spaced {
  justify-content: space-between;
}

.layout--center {
  justify-content: center;
}

.layout__item {
  width: 100%;
  padding-left: 20px;
}

.layout--auto > .layout__item {
  flex-basis: content;
}

.layout--flush {
  margin-left: 0;
}

.layout--flush > .layout__item {
  padding-left: 0;
}

.layout--small {
  margin-left: -10px;
}

.layout--small > .layout__item {
  padding-left: 10px;
}

.m0 {
  margin: 0 !important;
}

.mt0 {
  margin-top: 0 !important;
}

.mr0 {
  margin-right: 0 !important;
}

.mb0 {
  margin-bottom: 0 !important;
}

.ml0 {
  margin-left: 0 !important;
}

.mv0 {
  margin-block: 0 !important;
}

.mh0 {
  margin-inline: 0 !important;
}

.m-- {
  margin: .313rem !important;
}

.mt-- {
  margin-top: .313rem !important;
}

.mr-- {
  margin-right: .313rem !important;
}

.mb-- {
  margin-bottom: .313rem !important;
}

.ml-- {
  margin-left: .313rem !important;
}

.mv-- {
  margin-block: .313rem !important;
}

.mh-- {
  margin-inline: .313rem !important;
}

.m- {
  margin: .625rem !important;
}

.mt- {
  margin-top: .625rem !important;
}

.mr- {
  margin-right: .625rem !important;
}

.mb- {
  margin-bottom: .625rem !important;
}

.ml- {
  margin-left: .625rem !important;
}

.mv- {
  margin-block: .625rem !important;
}

.mh- {
  margin-inline: .625rem !important;
}

.m {
  margin: 1.25rem !important;
}

.mt {
  margin-top: 1.25rem !important;
}

.mr {
  margin-right: 1.25rem !important;
}

.mb {
  margin-bottom: 1.25rem !important;
}

.ml {
  margin-left: 1.25rem !important;
}

.mv {
  margin-block: 1.25rem !important;
}

.mh {
  margin-inline: 1.25rem !important;
}

.m\\+ {
  margin: 2.5rem !important;
}

.mt\\+ {
  margin-top: 2.5rem !important;
}

.mr\\+ {
  margin-right: 2.5rem !important;
}

.mb\\+ {
  margin-bottom: 2.5rem !important;
}

.ml\\+ {
  margin-left: 2.5rem !important;
}

.mv\\+ {
  margin-block: 2.5rem !important;
}

.mh\\+ {
  margin-inline: 2.5rem !important;
}

.m\\+\\+ {
  margin: 5rem !important;
}

.mt\\+\\+ {
  margin-top: 5rem !important;
}

.mr\\+\\+ {
  margin-right: 5rem !important;
}

.mb\\+\\+ {
  margin-bottom: 5rem !important;
}

.ml\\+\\+ {
  margin-left: 5rem !important;
}

.mv\\+\\+ {
  margin-block: 5rem !important;
}

.mh\\+\\+ {
  margin-inline: 5rem !important;
}

.p0 {
  padding: 0 !important;
}

.pt0 {
  padding-top: 0 !important;
}

.pr0 {
  padding-right: 0 !important;
}

.pb0 {
  padding-bottom: 0 !important;
}

.pl0 {
  padding-left: 0 !important;
}

.pv0 {
  padding-block: 0 !important;
}

.ph0 {
  padding-inline: 0 !important;
}

.p-- {
  padding: .313rem !important;
}

.pt-- {
  padding-top: .313rem !important;
}

.pr-- {
  padding-right: .313rem !important;
}

.pb-- {
  padding-bottom: .313rem !important;
}

.pl-- {
  padding-left: .313rem !important;
}

.pv-- {
  padding-block: .313rem !important;
}

.ph-- {
  padding-inline: .313rem !important;
}

.p- {
  padding: .625rem !important;
}

.pt- {
  padding-top: .625rem !important;
}

.pr- {
  padding-right: .625rem !important;
}

.pb- {
  padding-bottom: .625rem !important;
}

.pl- {
  padding-left: .625rem !important;
}

.pv- {
  padding-block: .625rem !important;
}

.ph- {
  padding-inline: .625rem !important;
}

.p {
  padding: 1.25rem !important;
}

.pt {
  padding-top: 1.25rem !important;
}

.pr {
  padding-right: 1.25rem !important;
}

.pb {
  padding-bottom: 1.25rem !important;
}

.pl {
  padding-left: 1.25rem !important;
}

.pv {
  padding-block: 1.25rem !important;
}

.ph {
  padding-inline: 1.25rem !important;
}

.p\\+ {
  padding: 2.5rem !important;
}

.pt\\+ {
  padding-top: 2.5rem !important;
}

.pr\\+ {
  padding-right: 2.5rem !important;
}

.pb\\+ {
  padding-bottom: 2.5rem !important;
}

.pl\\+ {
  padding-left: 2.5rem !important;
}

.pv\\+ {
  padding-block: 2.5rem !important;
}

.ph\\+ {
  padding-inline: 2.5rem !important;
}

.p\\+\\+ {
  padding: 5rem !important;
}

.pt\\+\\+ {
  padding-top: 5rem !important;
}

.pr\\+\\+ {
  padding-right: 5rem !important;
}

.pb\\+\\+ {
  padding-bottom: 5rem !important;
}

.pl\\+\\+ {
  padding-left: 5rem !important;
}

.pv\\+\\+ {
  padding-block: 5rem !important;
}

.ph\\+\\+ {
  padding-inline: 5rem !important;
}

@media screen and (width <= 46.9375em) {
  .m0\\(s\\) {
    margin: 0 !important;
  }

  .mt0\\(s\\) {
    margin-top: 0 !important;
  }

  .mr0\\(s\\) {
    margin-right: 0 !important;
  }

  .mb0\\(s\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(s\\) {
    margin-left: 0 !important;
  }

  .mv0\\(s\\) {
    margin-block: 0 !important;
  }

  .mh0\\(s\\) {
    margin-inline: 0 !important;
  }

  .m--\\(s\\) {
    margin: .313rem !important;
  }

  .mt--\\(s\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(s\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(s\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(s\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(s\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(s\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(s\\) {
    margin: .625rem !important;
  }

  .mt-\\(s\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(s\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(s\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(s\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(s\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(s\\) {
    margin-inline: .625rem !important;
  }

  .m\\(s\\) {
    margin: 1.25rem !important;
  }

  .mt\\(s\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(s\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(s\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(s\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(s\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(s\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(s\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(s\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(s\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(s\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(s\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(s\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(s\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(s\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(s\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(s\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(s\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(s\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(s\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(s\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(s\\) {
    padding: 0 !important;
  }

  .pt0\\(s\\) {
    padding-top: 0 !important;
  }

  .pr0\\(s\\) {
    padding-right: 0 !important;
  }

  .pb0\\(s\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(s\\) {
    padding-left: 0 !important;
  }

  .pv0\\(s\\) {
    padding-block: 0 !important;
  }

  .ph0\\(s\\) {
    padding-inline: 0 !important;
  }

  .p--\\(s\\) {
    padding: .313rem !important;
  }

  .pt--\\(s\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(s\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(s\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(s\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(s\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(s\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(s\\) {
    padding: .625rem !important;
  }

  .pt-\\(s\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(s\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(s\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(s\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(s\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(s\\) {
    padding-inline: .625rem !important;
  }

  .p\\(s\\) {
    padding: 1.25rem !important;
  }

  .pt\\(s\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(s\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(s\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(s\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(s\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(s\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(s\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(s\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(s\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(s\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(s\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(s\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(s\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(s\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(s\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(s\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(s\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(s\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(s\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(s\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .m0\\(m\\) {
    margin: 0 !important;
  }

  .mt0\\(m\\) {
    margin-top: 0 !important;
  }

  .mr0\\(m\\) {
    margin-right: 0 !important;
  }

  .mb0\\(m\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(m\\) {
    margin-left: 0 !important;
  }

  .mv0\\(m\\) {
    margin-block: 0 !important;
  }

  .mh0\\(m\\) {
    margin-inline: 0 !important;
  }

  .m--\\(m\\) {
    margin: .313rem !important;
  }

  .mt--\\(m\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(m\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(m\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(m\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(m\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(m\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(m\\) {
    margin: .625rem !important;
  }

  .mt-\\(m\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(m\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(m\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(m\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(m\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(m\\) {
    margin-inline: .625rem !important;
  }

  .m\\(m\\) {
    margin: 1.25rem !important;
  }

  .mt\\(m\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(m\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(m\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(m\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(m\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(m\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(m\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(m\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(m\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(m\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(m\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(m\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(m\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(m\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(m\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(m\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(m\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(m\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(m\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(m\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(m\\) {
    padding: 0 !important;
  }

  .pt0\\(m\\) {
    padding-top: 0 !important;
  }

  .pr0\\(m\\) {
    padding-right: 0 !important;
  }

  .pb0\\(m\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(m\\) {
    padding-left: 0 !important;
  }

  .pv0\\(m\\) {
    padding-block: 0 !important;
  }

  .ph0\\(m\\) {
    padding-inline: 0 !important;
  }

  .p--\\(m\\) {
    padding: .313rem !important;
  }

  .pt--\\(m\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(m\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(m\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(m\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(m\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(m\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(m\\) {
    padding: .625rem !important;
  }

  .pt-\\(m\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(m\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(m\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(m\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(m\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(m\\) {
    padding-inline: .625rem !important;
  }

  .p\\(m\\) {
    padding: 1.25rem !important;
  }

  .pt\\(m\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(m\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(m\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(m\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(m\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(m\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(m\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(m\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(m\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(m\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(m\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(m\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(m\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(m\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(m\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(m\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(m\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(m\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(m\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(m\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 47em), print {
  .m0\\(\\!s\\) {
    margin: 0 !important;
  }

  .mt0\\(\\!s\\) {
    margin-top: 0 !important;
  }

  .mr0\\(\\!s\\) {
    margin-right: 0 !important;
  }

  .mb0\\(\\!s\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(\\!s\\) {
    margin-left: 0 !important;
  }

  .mv0\\(\\!s\\) {
    margin-block: 0 !important;
  }

  .mh0\\(\\!s\\) {
    margin-inline: 0 !important;
  }

  .m--\\(\\!s\\) {
    margin: .313rem !important;
  }

  .mt--\\(\\!s\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(\\!s\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(\\!s\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(\\!s\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(\\!s\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(\\!s\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(\\!s\\) {
    margin: .625rem !important;
  }

  .mt-\\(\\!s\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(\\!s\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(\\!s\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(\\!s\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(\\!s\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(\\!s\\) {
    margin-inline: .625rem !important;
  }

  .m\\(\\!s\\) {
    margin: 1.25rem !important;
  }

  .mt\\(\\!s\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(\\!s\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(\\!s\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(\\!s\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(\\!s\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(\\!s\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(\\!s\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(\\!s\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(\\!s\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(\\!s\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(\\!s\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(\\!s\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(\\!s\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(\\!s\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(\\!s\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(\\!s\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(\\!s\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(\\!s\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(\\!s\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(\\!s\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(\\!s\\) {
    padding: 0 !important;
  }

  .pt0\\(\\!s\\) {
    padding-top: 0 !important;
  }

  .pr0\\(\\!s\\) {
    padding-right: 0 !important;
  }

  .pb0\\(\\!s\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(\\!s\\) {
    padding-left: 0 !important;
  }

  .pv0\\(\\!s\\) {
    padding-block: 0 !important;
  }

  .ph0\\(\\!s\\) {
    padding-inline: 0 !important;
  }

  .p--\\(\\!s\\) {
    padding: .313rem !important;
  }

  .pt--\\(\\!s\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(\\!s\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(\\!s\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(\\!s\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(\\!s\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(\\!s\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(\\!s\\) {
    padding: .625rem !important;
  }

  .pt-\\(\\!s\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(\\!s\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(\\!s\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(\\!s\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(\\!s\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(\\!s\\) {
    padding-inline: .625rem !important;
  }

  .p\\(\\!s\\) {
    padding: 1.25rem !important;
  }

  .pt\\(\\!s\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(\\!s\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(\\!s\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(\\!s\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(\\!s\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(\\!s\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(\\!s\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(\\!s\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(\\!s\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(\\!s\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(\\!s\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(\\!s\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(\\!s\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(\\!s\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(\\!s\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(\\!s\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(\\!s\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(\\!s\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(\\!s\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(\\!s\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width <= 74.9375em) {
  .m0\\(\\!l\\) {
    margin: 0 !important;
  }

  .mt0\\(\\!l\\) {
    margin-top: 0 !important;
  }

  .mr0\\(\\!l\\) {
    margin-right: 0 !important;
  }

  .mb0\\(\\!l\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(\\!l\\) {
    margin-left: 0 !important;
  }

  .mv0\\(\\!l\\) {
    margin-block: 0 !important;
  }

  .mh0\\(\\!l\\) {
    margin-inline: 0 !important;
  }

  .m--\\(\\!l\\) {
    margin: .313rem !important;
  }

  .mt--\\(\\!l\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(\\!l\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(\\!l\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(\\!l\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(\\!l\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(\\!l\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(\\!l\\) {
    margin: .625rem !important;
  }

  .mt-\\(\\!l\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(\\!l\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(\\!l\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(\\!l\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(\\!l\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(\\!l\\) {
    margin-inline: .625rem !important;
  }

  .m\\(\\!l\\) {
    margin: 1.25rem !important;
  }

  .mt\\(\\!l\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(\\!l\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(\\!l\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(\\!l\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(\\!l\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(\\!l\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(\\!l\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(\\!l\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(\\!l\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(\\!l\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(\\!l\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(\\!l\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(\\!l\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(\\!l\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(\\!l\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(\\!l\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(\\!l\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(\\!l\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(\\!l\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(\\!l\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(\\!l\\) {
    padding: 0 !important;
  }

  .pt0\\(\\!l\\) {
    padding-top: 0 !important;
  }

  .pr0\\(\\!l\\) {
    padding-right: 0 !important;
  }

  .pb0\\(\\!l\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(\\!l\\) {
    padding-left: 0 !important;
  }

  .pv0\\(\\!l\\) {
    padding-block: 0 !important;
  }

  .ph0\\(\\!l\\) {
    padding-inline: 0 !important;
  }

  .p--\\(\\!l\\) {
    padding: .313rem !important;
  }

  .pt--\\(\\!l\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(\\!l\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(\\!l\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(\\!l\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(\\!l\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(\\!l\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(\\!l\\) {
    padding: .625rem !important;
  }

  .pt-\\(\\!l\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(\\!l\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(\\!l\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(\\!l\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(\\!l\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(\\!l\\) {
    padding-inline: .625rem !important;
  }

  .p\\(\\!l\\) {
    padding: 1.25rem !important;
  }

  .pt\\(\\!l\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(\\!l\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(\\!l\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(\\!l\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(\\!l\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(\\!l\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(\\!l\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(\\!l\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(\\!l\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(\\!l\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(\\!l\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(\\!l\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(\\!l\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(\\!l\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(\\!l\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(\\!l\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(\\!l\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(\\!l\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(\\!l\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(\\!l\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 75em), print {
  .m0\\(l\\) {
    margin: 0 !important;
  }

  .mt0\\(l\\) {
    margin-top: 0 !important;
  }

  .mr0\\(l\\) {
    margin-right: 0 !important;
  }

  .mb0\\(l\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(l\\) {
    margin-left: 0 !important;
  }

  .mv0\\(l\\) {
    margin-block: 0 !important;
  }

  .mh0\\(l\\) {
    margin-inline: 0 !important;
  }

  .m--\\(l\\) {
    margin: .313rem !important;
  }

  .mt--\\(l\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(l\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(l\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(l\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(l\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(l\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(l\\) {
    margin: .625rem !important;
  }

  .mt-\\(l\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(l\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(l\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(l\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(l\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(l\\) {
    margin-inline: .625rem !important;
  }

  .m\\(l\\) {
    margin: 1.25rem !important;
  }

  .mt\\(l\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(l\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(l\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(l\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(l\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(l\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(l\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(l\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(l\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(l\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(l\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(l\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(l\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(l\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(l\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(l\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(l\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(l\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(l\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(l\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(l\\) {
    padding: 0 !important;
  }

  .pt0\\(l\\) {
    padding-top: 0 !important;
  }

  .pr0\\(l\\) {
    padding-right: 0 !important;
  }

  .pb0\\(l\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(l\\) {
    padding-left: 0 !important;
  }

  .pv0\\(l\\) {
    padding-block: 0 !important;
  }

  .ph0\\(l\\) {
    padding-inline: 0 !important;
  }

  .p--\\(l\\) {
    padding: .313rem !important;
  }

  .pt--\\(l\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(l\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(l\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(l\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(l\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(l\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(l\\) {
    padding: .625rem !important;
  }

  .pt-\\(l\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(l\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(l\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(l\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(l\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(l\\) {
    padding-inline: .625rem !important;
  }

  .p\\(l\\) {
    padding: 1.25rem !important;
  }

  .pt\\(l\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(l\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(l\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(l\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(l\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(l\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(l\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(l\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(l\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(l\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(l\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(l\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(l\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(l\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(l\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(l\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(l\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(l\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(l\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(l\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 90.0625em) {
  .m0\\(xl\\) {
    margin: 0 !important;
  }

  .mt0\\(xl\\) {
    margin-top: 0 !important;
  }

  .mr0\\(xl\\) {
    margin-right: 0 !important;
  }

  .mb0\\(xl\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(xl\\) {
    margin-left: 0 !important;
  }

  .mv0\\(xl\\) {
    margin-block: 0 !important;
  }

  .mh0\\(xl\\) {
    margin-inline: 0 !important;
  }

  .m--\\(xl\\) {
    margin: .313rem !important;
  }

  .mt--\\(xl\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(xl\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(xl\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(xl\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(xl\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(xl\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(xl\\) {
    margin: .625rem !important;
  }

  .mt-\\(xl\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(xl\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(xl\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(xl\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(xl\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(xl\\) {
    margin-inline: .625rem !important;
  }

  .m\\(xl\\) {
    margin: 1.25rem !important;
  }

  .mt\\(xl\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(xl\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(xl\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(xl\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(xl\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(xl\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(xl\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(xl\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(xl\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(xl\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(xl\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(xl\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(xl\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(xl\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(xl\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(xl\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(xl\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(xl\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(xl\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(xl\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(xl\\) {
    padding: 0 !important;
  }

  .pt0\\(xl\\) {
    padding-top: 0 !important;
  }

  .pr0\\(xl\\) {
    padding-right: 0 !important;
  }

  .pb0\\(xl\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(xl\\) {
    padding-left: 0 !important;
  }

  .pv0\\(xl\\) {
    padding-block: 0 !important;
  }

  .ph0\\(xl\\) {
    padding-inline: 0 !important;
  }

  .p--\\(xl\\) {
    padding: .313rem !important;
  }

  .pt--\\(xl\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(xl\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(xl\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(xl\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(xl\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(xl\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(xl\\) {
    padding: .625rem !important;
  }

  .pt-\\(xl\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(xl\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(xl\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(xl\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(xl\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(xl\\) {
    padding-inline: .625rem !important;
  }

  .p\\(xl\\) {
    padding: 1.25rem !important;
  }

  .pt\\(xl\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(xl\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(xl\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(xl\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(xl\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(xl\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(xl\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(xl\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(xl\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(xl\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(xl\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(xl\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(xl\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(xl\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(xl\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(xl\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(xl\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(xl\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(xl\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(xl\\) {
    padding-inline: 5rem !important;
  }
}

.u-gap0 {
  gap: 0 !important;
}

.u-gap-- {
  gap: .313rem !important;
}

.u-gap- {
  gap: .625rem !important;
}

.u-gap {
  gap: 1.25rem !important;
}

.u-gap\\+ {
  gap: 2.5rem !important;
}

.u-gap\\+\\+ {
  gap: 5rem !important;
}

@media screen and (width <= 46.9375em) {
  .u-gap0\\(s\\) {
    gap: 0 !important;
  }

  .u-gap--\\(s\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(s\\) {
    gap: .625rem !important;
  }

  .u-gap\\(s\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(s\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(s\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-gap0\\(m\\) {
    gap: 0 !important;
  }

  .u-gap--\\(m\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(m\\) {
    gap: .625rem !important;
  }

  .u-gap\\(m\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(m\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(m\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 47em), print {
  .u-gap0\\(\\!s\\) {
    gap: 0 !important;
  }

  .u-gap--\\(\\!s\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(\\!s\\) {
    gap: .625rem !important;
  }

  .u-gap\\(\\!s\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(\\!s\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(\\!s\\) {
    gap: 5rem !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-gap0\\(\\!l\\) {
    gap: 0 !important;
  }

  .u-gap--\\(\\!l\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(\\!l\\) {
    gap: .625rem !important;
  }

  .u-gap\\(\\!l\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(\\!l\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(\\!l\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 75em), print {
  .u-gap0\\(l\\) {
    gap: 0 !important;
  }

  .u-gap--\\(l\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(l\\) {
    gap: .625rem !important;
  }

  .u-gap\\(l\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(l\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(l\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-gap0\\(xl\\) {
    gap: 0 !important;
  }

  .u-gap--\\(xl\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(xl\\) {
    gap: .625rem !important;
  }

  .u-gap\\(xl\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(xl\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(xl\\) {
    gap: 5rem !important;
  }
}

.u-1\\/1 {
  width: 100% !important;
}

.u-1\\/2 {
  flex: none !important;
  width: 50% !important;
}

.u-2\\/2 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/3 {
  flex: none !important;
  width: 33.3333% !important;
}

.u-2\\/3 {
  flex: none !important;
  width: 66.6667% !important;
}

.u-3\\/3 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/4 {
  flex: none !important;
  width: 25% !important;
}

.u-2\\/4 {
  flex: none !important;
  width: 50% !important;
}

.u-3\\/4 {
  flex: none !important;
  width: 75% !important;
}

.u-4\\/4 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/5 {
  flex: none !important;
  width: 20% !important;
}

.u-2\\/5 {
  flex: none !important;
  width: 40% !important;
}

.u-3\\/5 {
  flex: none !important;
  width: 60% !important;
}

.u-4\\/5 {
  flex: none !important;
  width: 80% !important;
}

.u-5\\/5 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/10 {
  flex: none !important;
  width: 10% !important;
}

.u-2\\/10 {
  flex: none !important;
  width: 20% !important;
}

.u-3\\/10 {
  flex: none !important;
  width: 30% !important;
}

.u-4\\/10 {
  flex: none !important;
  width: 40% !important;
}

.u-5\\/10 {
  flex: none !important;
  width: 50% !important;
}

.u-6\\/10 {
  flex: none !important;
  width: 60% !important;
}

.u-7\\/10 {
  flex: none !important;
  width: 70% !important;
}

.u-8\\/10 {
  flex: none !important;
  width: 80% !important;
}

.u-9\\/10 {
  flex: none !important;
  width: 90% !important;
}

.u-10\\/10 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/24 {
  flex: none !important;
  width: 4.16667% !important;
}

.u-2\\/24 {
  flex: none !important;
  width: 8.33333% !important;
}

.u-3\\/24 {
  flex: none !important;
  width: 12.5% !important;
}

.u-4\\/24 {
  flex: none !important;
  width: 16.6667% !important;
}

.u-5\\/24 {
  flex: none !important;
  width: 20.8333% !important;
}

.u-6\\/24 {
  flex: none !important;
  width: 25% !important;
}

.u-7\\/24 {
  flex: none !important;
  width: 29.1667% !important;
}

.u-8\\/24 {
  flex: none !important;
  width: 33.3333% !important;
}

.u-9\\/24 {
  flex: none !important;
  width: 37.5% !important;
}

.u-10\\/24 {
  flex: none !important;
  width: 41.6667% !important;
}

.u-11\\/24 {
  flex: none !important;
  width: 45.8333% !important;
}

.u-12\\/24 {
  flex: none !important;
  width: 50% !important;
}

.u-13\\/24 {
  flex: none !important;
  width: 54.1667% !important;
}

.u-14\\/24 {
  flex: none !important;
  width: 58.3333% !important;
}

.u-15\\/24 {
  flex: none !important;
  width: 62.5% !important;
}

.u-16\\/24 {
  flex: none !important;
  width: 66.6667% !important;
}

.u-17\\/24 {
  flex: none !important;
  width: 70.8333% !important;
}

.u-18\\/24 {
  flex: none !important;
  width: 75% !important;
}

.u-19\\/24 {
  flex: none !important;
  width: 79.1667% !important;
}

.u-20\\/24 {
  flex: none !important;
  width: 83.3333% !important;
}

.u-21\\/24 {
  flex: none !important;
  width: 87.5% !important;
}

.u-22\\/24 {
  flex: none !important;
  width: 91.6667% !important;
}

.u-23\\/24 {
  flex: none !important;
  width: 95.8333% !important;
}

.u-24\\/24 {
  flex: none !important;
  width: 100% !important;
}

@media screen and (width <= 46.9375em) {
  .u-1\\/1\\(s\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(s\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(s\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(s\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(s\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(s\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(s\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(s\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(s\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(s\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(s\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(s\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(s\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(s\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(s\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(s\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(s\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(s\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(s\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(s\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(s\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(s\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(s\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(s\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(s\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(s\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(s\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(s\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(s\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(s\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(s\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(s\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(s\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(s\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(s\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(s\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(s\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(s\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(s\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-1\\/1\\(m\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(m\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(m\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(m\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(m\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(m\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(m\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(m\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(m\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(m\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(m\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(m\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(m\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(m\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(m\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(m\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(m\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(m\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(m\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(m\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(m\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(m\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(m\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(m\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(m\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(m\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(m\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(m\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(m\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(m\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(m\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(m\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(m\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(m\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(m\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(m\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(m\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(m\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(m\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(m\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(m\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(m\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(m\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width >= 47em), print {
  .u-1\\/1\\(\\!s\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(\\!s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(\\!s\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(\\!s\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(\\!s\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(\\!s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(\\!s\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(\\!s\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(\\!s\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(\\!s\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(\\!s\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(\\!s\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(\\!s\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(\\!s\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(\\!s\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(\\!s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(\\!s\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(\\!s\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(\\!s\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(\\!s\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(\\!s\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(\\!s\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(\\!s\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(\\!s\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(\\!s\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(\\!s\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(\\!s\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(\\!s\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(\\!s\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(\\!s\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(\\!s\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(\\!s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(\\!s\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(\\!s\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(\\!s\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(\\!s\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(\\!s\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(\\!s\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(\\!s\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(\\!s\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(\\!s\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(\\!s\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(\\!s\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-1\\/1\\(\\!l\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(\\!l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(\\!l\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(\\!l\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(\\!l\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(\\!l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(\\!l\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(\\!l\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(\\!l\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(\\!l\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(\\!l\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(\\!l\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(\\!l\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(\\!l\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(\\!l\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(\\!l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(\\!l\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(\\!l\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(\\!l\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(\\!l\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(\\!l\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(\\!l\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(\\!l\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(\\!l\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(\\!l\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(\\!l\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(\\!l\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(\\!l\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(\\!l\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(\\!l\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(\\!l\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(\\!l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(\\!l\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(\\!l\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(\\!l\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(\\!l\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(\\!l\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(\\!l\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(\\!l\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(\\!l\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(\\!l\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(\\!l\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(\\!l\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width >= 75em), print {
  .u-1\\/1\\(l\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(l\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(l\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(l\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(l\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(l\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(l\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(l\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(l\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(l\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(l\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(l\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(l\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(l\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(l\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(l\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(l\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(l\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(l\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(l\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(l\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(l\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(l\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(l\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(l\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(l\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(l\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(l\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(l\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(l\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(l\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(l\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(l\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(l\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(l\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(l\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(l\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(l\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(l\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-1\\/1\\(xl\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(xl\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(xl\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(xl\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(xl\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(xl\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(xl\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(xl\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(xl\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(xl\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(xl\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(xl\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(xl\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(xl\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(xl\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(xl\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(xl\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(xl\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(xl\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(xl\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(xl\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(xl\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(xl\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(xl\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(xl\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(xl\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(xl\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(xl\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(xl\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(xl\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(xl\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(xl\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(xl\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(xl\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(xl\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(xl\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(xl\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(xl\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(xl\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(xl\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(xl\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(xl\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(xl\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }
}
`;


class $f0d4bc948f2bef33$var$WJPackageTariff extends (0, $baeea1393dcde116$export$3f2f9f5909897157) {
    constructor(...args){
        super(...args);
        this.data = null;
        this.packageTemplate = null;
    }
    static get properties() {
        return {
            contractDetails: {
                type: Object,
                reflect: true
            }
        };
    }
    render() {
        if (!this.contractDetails) return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)``;
        let contractDetails = this.contractDetails;
        return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)` 
<h5 class="mb-">Informationen zum Tarif</h5>
<div class="layout">
  <div class="layout__item u-2/3(s) u-1/3(!s)">
    <div class="mb--"><strong>${contractDetails.priceGuarantee?.caption.text}</strong></div>
  </div>
  <div class="layout__item u-1/3(s) u-2/3(!s)">
    <div class="mb--">${contractDetails.priceGuarantee?.content.text}</div>
  </div>
</div>
<div class="layout">
  <div class="layout__item u-2/3(s) u-1/3(!s)">
    <div class="mb--"><strong>${contractDetails.cancellationPeriod?.caption.text}</strong></div>
  </div>
  <div class="layout__item u-1/3(s) u-2/3(!s)">
    <div class="mb--">${contractDetails.cancellationPeriod?.content.text}</div>
  </div>
</div>
<div class="layout">
  <div class="layout__item u-2/3(s) u-1/3(!s)">
    <div class="mb--"><strong>${contractDetails.contractDuration?.caption.text}</strong></div>
  </div>
  <div class="layout__item u-1/3(s) u-2/3(!s)">
    <div class="mb--">${contractDetails.contractDuration?.content.text}</div>
  </div>
</div>
<div class="layout">
  <div class="layout__item u-2/3(s) u-1/3(!s)">
    <div class="mb--"><strong>${contractDetails.contractProlongation?.caption.text}</strong></div>
  </div>
  <div class="layout__item u-1/3(s) u-2/3(!s)">
    <div class="mb--">${contractDetails.contractProlongation?.content.text}</div>
  </div>
</div>
<div class="layout">
  <div class="layout__item u-2/3(s) u-1/3(!s)">
    <div class="mb--"><strong>${contractDetails.deposit?.caption.text}</strong></div>
  </div>
  <div class="layout__item u-1/3(s) u-2/3(!s)">
    <div class="mb--">${contractDetails.deposit?.content.text}</div>
  </div>
</div>
<div class="layout">
  <div class="layout__item u-2/3(s) u-1/3(!s)">
    <div class="mb--"><strong>${contractDetails.paymentFrequency?.caption.text}</strong></div>
  </div>
  <div class="layout__item u-1/3(s) u-2/3(!s)">
    <div class="mb--">${contractDetails.paymentFrequency?.content.text}</div>
  </div>
</div>`;
    }
}
$f0d4bc948f2bef33$var$WJPackageTariff.styles = [
    (0, $be764c3dce225edf$export$9c03a21429c8dee0)
];
const $f0d4bc948f2bef33$export$e4154d8a482e2d3a = ()=>{
    window.customElements.define("wj-package-tariff", $f0d4bc948f2bef33$var$WJPackageTariff);
};




const $5eb9359b5e26429a$export$e164c590bcba2aaf = (0, $2ebca2d23ae8704c$export$dbf350e5966cf602)`:root {
  --duration-fast: .3s;
  --duration-medium: .75s;
  --duration-slow: 1.2s;
  --swift-ease-out-timing-function: cubic-bezier(.25, .8, .25, 1);
  --swift-ease-out: all var(--duration-fast) var(--swift-ease-out-timing-function);
  --swift-ease-in-timing-function: cubic-bezier(.55, 0, .55, .2);
  --swift-ease-in: all var(--duration-fast) var(--swift-ease-in-timing-function);
  --swift-ease-in-out-timing-function: cubic-bezier(.35, 0, .25, 1);
  --swift-ease-in-out: all var(--duration-fast) var(--swift-ease-in-out-timing-function);
  --border-radius-none: 0;
  --border-radius-xs: 4px;
  --border-radius-s: 8px;
  --border-radius: 16px;
  --border-radius-m: 16px;
  --border-radius-l: 32px;
  --border-radius-xl: 999em;
  --color-white: #fff;
  --color-white--base: #fff;
  --color-grey: #757575;
  --color-grey--base: #757575;
  --color-grey--dark: #3d3d3d;
  --color-grey--light: #d4d4d4;
  --color-grey--x-light: #f7f7f7;
  --color-black: #000;
  --color-black--base: #000;
  --color-brand: #aa183f;
  --color-brand--base: #aa183f;
  --color-brand--accent: #1470d2;
  --color-brand--support: #00496b;
  --color-status--green: #008500;
  --color-status--orange: #ff9500;
  --color-status--yellow: #fc0;
  --color-status--red: red;
  --color-status--marked: #ffec99;
  --color-nav: #308271;
  --color-nav--base: #308271;
  --color-nav--hover: #297064;
  --color-gradient1--from: #4db380;
  --color-gradient1--to: #508a95;
  --color-gradient2--from: #62a38d;
  --color-gradient2--to: #5a908e;
  --color-gradient3--from: #e7efec;
  --color-gradient3--to: #e8eeec;
  --spacing-1: 0;
  --spacing0: 0;
  --spacing-2: .313rem;
  --spacing--: .313rem;
  --spacing-3: .625rem;
  --spacing-: .625rem;
  --spacing-4: 1.25rem;
  --spacing: 1.25rem;
  --spacing-5: 2.5rem;
  --spacing\\+: 2.5rem;
  --spacing-6: 5rem;
  --spacing\\+\\+: 5rem;
  --color-tag-green--dark: #008500;
  --color-tag-green--light: #eefcee;
  --color-tag-cyan--dark: #558891;
  --color-tag-cyan--light: #e9f0f2;
  --color-tag-purple--dark: #4e5eb1;
  --color-tag-purple--light: #e8ebfd;
  --color-tag-orange--dark: #ff9500;
  --color-tag-orange--light: #fffbf5;
  --color-tag-blue--dark: #00496b;
  --color-tag-blue--light: #deedfc;
  --color-tag-white--dark: #fff;
  --color-tag-white--light: #ffffff26;
  --brand-face: "Source Sans 3 VF", sans-serif;
  --spec-face: "Oxygen", sans-serif;
  --font-weight-semibold: 500;
  --font-weight-bold: bold;
  --font-size-button: 18px;
  --line-height-button: 20px;
  --font-size-xl: 1.4375rem;
  --line-height-xl: 30px;
  --font-size-l: 1.25rem;
  --line-height-l: 30px;
  --font-size-m: 1rem;
  --line-height-m: 1.2;
  --font-size-s: .875rem;
  --line-height-s: 20px;
  --font-size-xs: .75rem;
  --line-height-xs: 16px;
  --font-size-h1: 3rem;
  --line-height-h1: 50px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h1: 32px;
    --line-height-h1: 35px;
  }
}

:root {
  --font-size-h2: 2rem;
  --line-height-h2: 35px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h2: 28px;
    --line-height-h2: 28px;
  }
}

:root {
  --font-size-h3: 1.75rem;
  --line-height-h3: 28px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h3: 23px;
    --line-height-h3: 30px;
  }
}

:root {
  --font-size-h4: 1.4375rem;
  --line-height-h4: 30px;
  --font-size-h5: 1.25rem;
  --line-height-h5: 30px;
  --font-size-h6: .875rem;
  --line-height-h6: 20px;
}

[role="button"], [type="submit"], [type="reset"], [type="button"], button {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

[type="submit"], [type="reset"], [type="button"], button {
  color: inherit;
  font: inherit;
  line-height: inherit;
  -webkit-appearance: button;
  appearance: button;
  -webkit-user-select: none;
  user-select: none;
  background: none;
  border: 0;
  margin: 0;
  padding: 0;
  overflow: visible;
}

input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

button::-moz-focus-inner {
  border: 0;
  padding: 0;
}

[role="button"] {
  color: inherit;
  cursor: default;
  text-align: center;
  white-space: pre;
  -webkit-user-select: none;
  user-select: none;
  text-decoration: none;
  display: inline-block;
}

*, :before, :after {
  box-sizing: border-box;
}

html {
  -webkit-text-size-adjust: 100%;
  tab-size: 4;
  font-family: system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji;
  line-height: 1.15;
}

body {
  margin: 0;
}

b, strong {
  font-weight: bolder;
}

code, kbd, samp, pre {
  font-family: ui-monospace, SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace;
  font-size: 1em;
}

small {
  font-size: 80%;
}

sub, sup {
  vertical-align: baseline;
  font-size: 75%;
  line-height: 0;
  position: relative;
}

sub {
  bottom: -.25em;
}

sup {
  top: -.5em;
}

table {
  border-color: currentColor;
}

button, input, optgroup, select, textarea {
  outline: none;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
}

button, [type="button"], [type="reset"], [type="submit"] {
  -webkit-appearance: button;
}

legend {
  padding: 0;
}

progress {
  vertical-align: baseline;
}

::-webkit-inner-spin-button {
  height: auto;
}

::-webkit-outer-spin-button {
  height: auto;
}

[type="search"] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}

summary {
  display: list-item;
}

:root {
  line-height: 1.5;
}

h1, h2, h3, h4, h5, figure, p, ol, ul {
  margin: 0;
}

ol[role="list"], ul[role="list"] {
  padding-inline: 0;
  list-style: none;
}

h1, h2, h3, h4, h5 {
  font-size: inherit;
  font-weight: inherit;
}

img {
  max-inline-size: 100%;
  display: block;
}

button {
  text-align: inherit;
  cursor: pointer;
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

label {
  cursor: pointer;
  display: block;
}

p a, h1 a, h2 a, h3 a, h4 a, h5 a, h6 a {
  color: inherit;
}

input[type="text"], input[type="email"], input[type="password"], input[type="search"]:not(.vs__search), input[type="color"], input[type="date"], input[type="datetime-local"], input[type="month"], input[type="number"], input[type="tel"], input[type="time"], input[type="url"], input[type="week"], input[list], select, textarea {
  -webkit-appearance: none;
  appearance: none;
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
  background-color: var(--color-white);
  border-radius: var(--border-radius-m);
  border: 1px solid var(--color-grey--light);
  color: var(--color-grey--dark);
  width: 100%;
  padding: 14px 15px;
}

@media screen and (width <= 46.9375em) {
  input[type="text"], input[type="email"], input[type="password"], input[type="search"]:not(.vs__search), input[type="color"], input[type="date"], input[type="datetime-local"], input[type="month"], input[type="number"], input[type="tel"], input[type="time"], input[type="url"], input[type="week"], input[list], select, textarea {
    font-size: var(--font-size-m);
    line-height: var(--line-height-s);
  }
}

input[type="date"], input[type="datetime-local"] {
  min-height: 50px;
}

input[type="text"]:read-only, input[type="email"]:read-only, input[type="password"]:read-only, input[type="search"]:read-only, input[type="color"]:read-only, input[type="date"]:read-only, input[type="datetime-local"]:read-only, input[type="month"]:read-only, input[type="number"]:read-only, input[type="tel"]:read-only, input[type="time"]:read-only, input[type="url"]:read-only, input[type="week"]:read-only, input[list]:read-only {
  background-color: var(--color-grey--x-light);
  box-shadow: none !important;
}

input[name*="postcode"], input[name*="Postal"], input[name*="postal"] {
  text-transform: uppercase;
}

::placeholder {
  color: var(--color-grey);
}

html {
  background-color: var(--color-white);
  font-size: var(--font-size-m);
  line-height: var(--line-height-m);
  color: var(--color-grey--dark);
  -webkit-font-smoothing: antialiased;
  scrollbar-gutter: stable;
  overflow-y: scroll;
}

hr {
  border: 0;
  border-bottom: 1px solid var(--color-grey--light);
}

p {
  margin: 0 0 20px;
}

ol, ul {
  padding-left: 20px;
}

summary {
  cursor: pointer;
}

abbr[title] {
  text-decoration: none;
}

img {
  max-width: 100%;
}

@media screen and (width <= 46.9375em) {
  img[data-lazyload-src][style*="height"], img[data-lazyload-src][height], img[src][style*="height"], img[src][height] {
    max-width: 100% !important;
    height: auto !important;
  }
}

table {
  width: 100%;
}

table td {
  vertical-align: top;
  padding: 0;
}

body {
  font-family: var(--brand-face);
}

h1, h2, h3 {
  font-style: italic;
}

h1, h2, h3, h4, h5, h6 {
  font-weight: bold;
}

h1 {
  font-size: var(--font-size-h1);
  line-height: var(--line-height-h1);
}

h2 {
  font-size: var(--font-size-h2);
  line-height: var(--line-height-h2);
}

h3 {
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
}

h4 {
  font-size: var(--font-size-h4);
  line-height: var(--line-height-h4);
}

h5 {
  font-size: var(--font-size-h5);
  line-height: var(--line-height-h5);
}

h6 {
  font-size: var(--font-size-h6);
  line-height: var(--line-height-h6);
  margin: 0;
}

strong, b {
  font-weight: bold;
}

small {
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
}

button, a {
  text-decoration: none;
}

button:hover, a:hover, p a {
  text-decoration: underline;
}

p a:hover {
  text-decoration: none;
}

:has( + bc-tooltip:not([data-trigger-style])) {
  color: var(--color-status--red);
  position: relative;
}

:has( + bc-tooltip:not([data-trigger-style])):before {
  content: "Missing attribute 'data-trigger-style'";
  white-space: nowrap;
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
  color: var(--color-white);
  background-color: var(--color-status--orange);
  z-index: 40;
  border-radius: 5px;
  width: 200px;
  padding: 3px 10px;
  position: absolute;
  top: 20px;
}

:has( + bc-tooltip[data-trigger-style="dashed"]) {
  text-underline-offset: .2rem;
  text-decoration: underline from-font dashed;
}

:has( + bc-tooltip[data-trigger-style="info-icon"]):after, :has( + bc-tooltip[data-trigger-style="info-icon-border"]):after {
  content: "";
  background-image: url("https://cdn.wechseljetzt.de/assets/wj/img/icons/info.svg");
  background-position: center;
  background-repeat: no-repeat;
  width: 5px;
  height: 11px;
  margin-left: 5px;
  display: inline-block;
}

:has( + bc-tooltip[data-trigger-style="info-icon-border"]):after {
  content: "";
  border: 1px solid var(--color-grey);
  border-radius: var(--border-radius-xl);
  margin-bottom: -3px;
  padding: 9px 10px 10px;
}

.layout {
  flex-wrap: wrap;
  margin: 0 0 0 -20px;
  padding: 0;
  list-style: none;
  display: flex;
}

@media screen and (width >= 47em), print {
  .layout--nowrap {
    flex-wrap: nowrap;
  }
}

.layout--rev {
  flex-direction: row-reverse;
}

.layout--middle {
  align-items: center;
}

.layout--spaced {
  justify-content: space-between;
}

.layout--center {
  justify-content: center;
}

.layout__item {
  width: 100%;
  padding-left: 20px;
}

.layout--auto > .layout__item {
  flex-basis: content;
}

.layout--flush {
  margin-left: 0;
}

.layout--flush > .layout__item {
  padding-left: 0;
}

.layout--small {
  margin-left: -10px;
}

.layout--small > .layout__item {
  padding-left: 10px;
}

.c-spec {
  font-size: var(--font-size-h5);
  line-height: var(--line-height-h3);
  font-family: var(--spec-face);
  font-style: normal;
}

@media screen and (width <= 46.9375em) {
  .c-spec {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }
}

.c-spec--amount {
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
}

@media screen and (width <= 46.9375em) {
  .c-spec--amount {
    font-size: var(--font-size-m);
    line-height: var(--line-height-s);
  }
}

.c-spec__decimals {
  vertical-align: super;
  margin-left: 2px;
  font-size: .6em;
  line-height: 1;
  position: relative;
  top: .1em;
}

.c-spec--rating {
  font-size: var(--font-size-h1);
  line-height: var(--line-height-h1);
}

@media screen and (width <= 46.9375em) {
  .c-spec--rating {
    font-size: var(--font-size-m);
    line-height: var(--line-height-l);
  }
}

.c-spec--rating-tab {
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
  line-height: 1;
}

.c-spec--rating-tab .c-spec__decimals {
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
  margin-left: 1px;
  top: .3em;
}

.m0 {
  margin: 0 !important;
}

.mt0 {
  margin-top: 0 !important;
}

.mr0 {
  margin-right: 0 !important;
}

.mb0 {
  margin-bottom: 0 !important;
}

.ml0 {
  margin-left: 0 !important;
}

.mv0 {
  margin-block: 0 !important;
}

.mh0 {
  margin-inline: 0 !important;
}

.m-- {
  margin: .313rem !important;
}

.mt-- {
  margin-top: .313rem !important;
}

.mr-- {
  margin-right: .313rem !important;
}

.mb-- {
  margin-bottom: .313rem !important;
}

.ml-- {
  margin-left: .313rem !important;
}

.mv-- {
  margin-block: .313rem !important;
}

.mh-- {
  margin-inline: .313rem !important;
}

.m- {
  margin: .625rem !important;
}

.mt- {
  margin-top: .625rem !important;
}

.mr- {
  margin-right: .625rem !important;
}

.mb- {
  margin-bottom: .625rem !important;
}

.ml- {
  margin-left: .625rem !important;
}

.mv- {
  margin-block: .625rem !important;
}

.mh- {
  margin-inline: .625rem !important;
}

.m {
  margin: 1.25rem !important;
}

.mt {
  margin-top: 1.25rem !important;
}

.mr {
  margin-right: 1.25rem !important;
}

.mb {
  margin-bottom: 1.25rem !important;
}

.ml {
  margin-left: 1.25rem !important;
}

.mv {
  margin-block: 1.25rem !important;
}

.mh {
  margin-inline: 1.25rem !important;
}

.m\\+ {
  margin: 2.5rem !important;
}

.mt\\+ {
  margin-top: 2.5rem !important;
}

.mr\\+ {
  margin-right: 2.5rem !important;
}

.mb\\+ {
  margin-bottom: 2.5rem !important;
}

.ml\\+ {
  margin-left: 2.5rem !important;
}

.mv\\+ {
  margin-block: 2.5rem !important;
}

.mh\\+ {
  margin-inline: 2.5rem !important;
}

.m\\+\\+ {
  margin: 5rem !important;
}

.mt\\+\\+ {
  margin-top: 5rem !important;
}

.mr\\+\\+ {
  margin-right: 5rem !important;
}

.mb\\+\\+ {
  margin-bottom: 5rem !important;
}

.ml\\+\\+ {
  margin-left: 5rem !important;
}

.mv\\+\\+ {
  margin-block: 5rem !important;
}

.mh\\+\\+ {
  margin-inline: 5rem !important;
}

.p0 {
  padding: 0 !important;
}

.pt0 {
  padding-top: 0 !important;
}

.pr0 {
  padding-right: 0 !important;
}

.pb0 {
  padding-bottom: 0 !important;
}

.pl0 {
  padding-left: 0 !important;
}

.pv0 {
  padding-block: 0 !important;
}

.ph0 {
  padding-inline: 0 !important;
}

.p-- {
  padding: .313rem !important;
}

.pt-- {
  padding-top: .313rem !important;
}

.pr-- {
  padding-right: .313rem !important;
}

.pb-- {
  padding-bottom: .313rem !important;
}

.pl-- {
  padding-left: .313rem !important;
}

.pv-- {
  padding-block: .313rem !important;
}

.ph-- {
  padding-inline: .313rem !important;
}

.p- {
  padding: .625rem !important;
}

.pt- {
  padding-top: .625rem !important;
}

.pr- {
  padding-right: .625rem !important;
}

.pb- {
  padding-bottom: .625rem !important;
}

.pl- {
  padding-left: .625rem !important;
}

.pv- {
  padding-block: .625rem !important;
}

.ph- {
  padding-inline: .625rem !important;
}

.p {
  padding: 1.25rem !important;
}

.pt {
  padding-top: 1.25rem !important;
}

.pr {
  padding-right: 1.25rem !important;
}

.pb {
  padding-bottom: 1.25rem !important;
}

.pl {
  padding-left: 1.25rem !important;
}

.pv {
  padding-block: 1.25rem !important;
}

.ph {
  padding-inline: 1.25rem !important;
}

.p\\+ {
  padding: 2.5rem !important;
}

.pt\\+ {
  padding-top: 2.5rem !important;
}

.pr\\+ {
  padding-right: 2.5rem !important;
}

.pb\\+ {
  padding-bottom: 2.5rem !important;
}

.pl\\+ {
  padding-left: 2.5rem !important;
}

.pv\\+ {
  padding-block: 2.5rem !important;
}

.ph\\+ {
  padding-inline: 2.5rem !important;
}

.p\\+\\+ {
  padding: 5rem !important;
}

.pt\\+\\+ {
  padding-top: 5rem !important;
}

.pr\\+\\+ {
  padding-right: 5rem !important;
}

.pb\\+\\+ {
  padding-bottom: 5rem !important;
}

.pl\\+\\+ {
  padding-left: 5rem !important;
}

.pv\\+\\+ {
  padding-block: 5rem !important;
}

.ph\\+\\+ {
  padding-inline: 5rem !important;
}

@media screen and (width <= 46.9375em) {
  .m0\\(s\\) {
    margin: 0 !important;
  }

  .mt0\\(s\\) {
    margin-top: 0 !important;
  }

  .mr0\\(s\\) {
    margin-right: 0 !important;
  }

  .mb0\\(s\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(s\\) {
    margin-left: 0 !important;
  }

  .mv0\\(s\\) {
    margin-block: 0 !important;
  }

  .mh0\\(s\\) {
    margin-inline: 0 !important;
  }

  .m--\\(s\\) {
    margin: .313rem !important;
  }

  .mt--\\(s\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(s\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(s\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(s\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(s\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(s\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(s\\) {
    margin: .625rem !important;
  }

  .mt-\\(s\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(s\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(s\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(s\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(s\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(s\\) {
    margin-inline: .625rem !important;
  }

  .m\\(s\\) {
    margin: 1.25rem !important;
  }

  .mt\\(s\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(s\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(s\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(s\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(s\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(s\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(s\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(s\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(s\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(s\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(s\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(s\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(s\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(s\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(s\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(s\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(s\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(s\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(s\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(s\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(s\\) {
    padding: 0 !important;
  }

  .pt0\\(s\\) {
    padding-top: 0 !important;
  }

  .pr0\\(s\\) {
    padding-right: 0 !important;
  }

  .pb0\\(s\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(s\\) {
    padding-left: 0 !important;
  }

  .pv0\\(s\\) {
    padding-block: 0 !important;
  }

  .ph0\\(s\\) {
    padding-inline: 0 !important;
  }

  .p--\\(s\\) {
    padding: .313rem !important;
  }

  .pt--\\(s\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(s\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(s\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(s\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(s\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(s\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(s\\) {
    padding: .625rem !important;
  }

  .pt-\\(s\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(s\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(s\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(s\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(s\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(s\\) {
    padding-inline: .625rem !important;
  }

  .p\\(s\\) {
    padding: 1.25rem !important;
  }

  .pt\\(s\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(s\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(s\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(s\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(s\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(s\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(s\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(s\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(s\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(s\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(s\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(s\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(s\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(s\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(s\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(s\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(s\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(s\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(s\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(s\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .m0\\(m\\) {
    margin: 0 !important;
  }

  .mt0\\(m\\) {
    margin-top: 0 !important;
  }

  .mr0\\(m\\) {
    margin-right: 0 !important;
  }

  .mb0\\(m\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(m\\) {
    margin-left: 0 !important;
  }

  .mv0\\(m\\) {
    margin-block: 0 !important;
  }

  .mh0\\(m\\) {
    margin-inline: 0 !important;
  }

  .m--\\(m\\) {
    margin: .313rem !important;
  }

  .mt--\\(m\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(m\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(m\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(m\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(m\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(m\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(m\\) {
    margin: .625rem !important;
  }

  .mt-\\(m\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(m\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(m\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(m\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(m\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(m\\) {
    margin-inline: .625rem !important;
  }

  .m\\(m\\) {
    margin: 1.25rem !important;
  }

  .mt\\(m\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(m\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(m\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(m\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(m\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(m\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(m\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(m\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(m\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(m\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(m\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(m\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(m\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(m\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(m\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(m\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(m\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(m\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(m\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(m\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(m\\) {
    padding: 0 !important;
  }

  .pt0\\(m\\) {
    padding-top: 0 !important;
  }

  .pr0\\(m\\) {
    padding-right: 0 !important;
  }

  .pb0\\(m\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(m\\) {
    padding-left: 0 !important;
  }

  .pv0\\(m\\) {
    padding-block: 0 !important;
  }

  .ph0\\(m\\) {
    padding-inline: 0 !important;
  }

  .p--\\(m\\) {
    padding: .313rem !important;
  }

  .pt--\\(m\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(m\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(m\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(m\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(m\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(m\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(m\\) {
    padding: .625rem !important;
  }

  .pt-\\(m\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(m\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(m\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(m\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(m\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(m\\) {
    padding-inline: .625rem !important;
  }

  .p\\(m\\) {
    padding: 1.25rem !important;
  }

  .pt\\(m\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(m\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(m\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(m\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(m\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(m\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(m\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(m\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(m\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(m\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(m\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(m\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(m\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(m\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(m\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(m\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(m\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(m\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(m\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(m\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 47em), print {
  .m0\\(\\!s\\) {
    margin: 0 !important;
  }

  .mt0\\(\\!s\\) {
    margin-top: 0 !important;
  }

  .mr0\\(\\!s\\) {
    margin-right: 0 !important;
  }

  .mb0\\(\\!s\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(\\!s\\) {
    margin-left: 0 !important;
  }

  .mv0\\(\\!s\\) {
    margin-block: 0 !important;
  }

  .mh0\\(\\!s\\) {
    margin-inline: 0 !important;
  }

  .m--\\(\\!s\\) {
    margin: .313rem !important;
  }

  .mt--\\(\\!s\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(\\!s\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(\\!s\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(\\!s\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(\\!s\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(\\!s\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(\\!s\\) {
    margin: .625rem !important;
  }

  .mt-\\(\\!s\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(\\!s\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(\\!s\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(\\!s\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(\\!s\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(\\!s\\) {
    margin-inline: .625rem !important;
  }

  .m\\(\\!s\\) {
    margin: 1.25rem !important;
  }

  .mt\\(\\!s\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(\\!s\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(\\!s\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(\\!s\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(\\!s\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(\\!s\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(\\!s\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(\\!s\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(\\!s\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(\\!s\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(\\!s\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(\\!s\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(\\!s\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(\\!s\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(\\!s\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(\\!s\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(\\!s\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(\\!s\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(\\!s\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(\\!s\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(\\!s\\) {
    padding: 0 !important;
  }

  .pt0\\(\\!s\\) {
    padding-top: 0 !important;
  }

  .pr0\\(\\!s\\) {
    padding-right: 0 !important;
  }

  .pb0\\(\\!s\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(\\!s\\) {
    padding-left: 0 !important;
  }

  .pv0\\(\\!s\\) {
    padding-block: 0 !important;
  }

  .ph0\\(\\!s\\) {
    padding-inline: 0 !important;
  }

  .p--\\(\\!s\\) {
    padding: .313rem !important;
  }

  .pt--\\(\\!s\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(\\!s\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(\\!s\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(\\!s\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(\\!s\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(\\!s\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(\\!s\\) {
    padding: .625rem !important;
  }

  .pt-\\(\\!s\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(\\!s\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(\\!s\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(\\!s\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(\\!s\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(\\!s\\) {
    padding-inline: .625rem !important;
  }

  .p\\(\\!s\\) {
    padding: 1.25rem !important;
  }

  .pt\\(\\!s\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(\\!s\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(\\!s\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(\\!s\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(\\!s\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(\\!s\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(\\!s\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(\\!s\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(\\!s\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(\\!s\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(\\!s\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(\\!s\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(\\!s\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(\\!s\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(\\!s\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(\\!s\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(\\!s\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(\\!s\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(\\!s\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(\\!s\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width <= 74.9375em) {
  .m0\\(\\!l\\) {
    margin: 0 !important;
  }

  .mt0\\(\\!l\\) {
    margin-top: 0 !important;
  }

  .mr0\\(\\!l\\) {
    margin-right: 0 !important;
  }

  .mb0\\(\\!l\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(\\!l\\) {
    margin-left: 0 !important;
  }

  .mv0\\(\\!l\\) {
    margin-block: 0 !important;
  }

  .mh0\\(\\!l\\) {
    margin-inline: 0 !important;
  }

  .m--\\(\\!l\\) {
    margin: .313rem !important;
  }

  .mt--\\(\\!l\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(\\!l\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(\\!l\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(\\!l\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(\\!l\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(\\!l\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(\\!l\\) {
    margin: .625rem !important;
  }

  .mt-\\(\\!l\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(\\!l\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(\\!l\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(\\!l\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(\\!l\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(\\!l\\) {
    margin-inline: .625rem !important;
  }

  .m\\(\\!l\\) {
    margin: 1.25rem !important;
  }

  .mt\\(\\!l\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(\\!l\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(\\!l\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(\\!l\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(\\!l\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(\\!l\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(\\!l\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(\\!l\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(\\!l\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(\\!l\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(\\!l\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(\\!l\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(\\!l\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(\\!l\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(\\!l\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(\\!l\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(\\!l\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(\\!l\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(\\!l\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(\\!l\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(\\!l\\) {
    padding: 0 !important;
  }

  .pt0\\(\\!l\\) {
    padding-top: 0 !important;
  }

  .pr0\\(\\!l\\) {
    padding-right: 0 !important;
  }

  .pb0\\(\\!l\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(\\!l\\) {
    padding-left: 0 !important;
  }

  .pv0\\(\\!l\\) {
    padding-block: 0 !important;
  }

  .ph0\\(\\!l\\) {
    padding-inline: 0 !important;
  }

  .p--\\(\\!l\\) {
    padding: .313rem !important;
  }

  .pt--\\(\\!l\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(\\!l\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(\\!l\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(\\!l\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(\\!l\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(\\!l\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(\\!l\\) {
    padding: .625rem !important;
  }

  .pt-\\(\\!l\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(\\!l\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(\\!l\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(\\!l\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(\\!l\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(\\!l\\) {
    padding-inline: .625rem !important;
  }

  .p\\(\\!l\\) {
    padding: 1.25rem !important;
  }

  .pt\\(\\!l\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(\\!l\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(\\!l\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(\\!l\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(\\!l\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(\\!l\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(\\!l\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(\\!l\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(\\!l\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(\\!l\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(\\!l\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(\\!l\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(\\!l\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(\\!l\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(\\!l\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(\\!l\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(\\!l\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(\\!l\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(\\!l\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(\\!l\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 75em), print {
  .m0\\(l\\) {
    margin: 0 !important;
  }

  .mt0\\(l\\) {
    margin-top: 0 !important;
  }

  .mr0\\(l\\) {
    margin-right: 0 !important;
  }

  .mb0\\(l\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(l\\) {
    margin-left: 0 !important;
  }

  .mv0\\(l\\) {
    margin-block: 0 !important;
  }

  .mh0\\(l\\) {
    margin-inline: 0 !important;
  }

  .m--\\(l\\) {
    margin: .313rem !important;
  }

  .mt--\\(l\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(l\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(l\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(l\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(l\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(l\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(l\\) {
    margin: .625rem !important;
  }

  .mt-\\(l\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(l\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(l\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(l\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(l\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(l\\) {
    margin-inline: .625rem !important;
  }

  .m\\(l\\) {
    margin: 1.25rem !important;
  }

  .mt\\(l\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(l\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(l\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(l\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(l\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(l\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(l\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(l\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(l\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(l\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(l\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(l\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(l\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(l\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(l\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(l\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(l\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(l\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(l\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(l\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(l\\) {
    padding: 0 !important;
  }

  .pt0\\(l\\) {
    padding-top: 0 !important;
  }

  .pr0\\(l\\) {
    padding-right: 0 !important;
  }

  .pb0\\(l\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(l\\) {
    padding-left: 0 !important;
  }

  .pv0\\(l\\) {
    padding-block: 0 !important;
  }

  .ph0\\(l\\) {
    padding-inline: 0 !important;
  }

  .p--\\(l\\) {
    padding: .313rem !important;
  }

  .pt--\\(l\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(l\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(l\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(l\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(l\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(l\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(l\\) {
    padding: .625rem !important;
  }

  .pt-\\(l\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(l\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(l\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(l\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(l\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(l\\) {
    padding-inline: .625rem !important;
  }

  .p\\(l\\) {
    padding: 1.25rem !important;
  }

  .pt\\(l\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(l\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(l\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(l\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(l\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(l\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(l\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(l\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(l\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(l\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(l\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(l\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(l\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(l\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(l\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(l\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(l\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(l\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(l\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(l\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 90.0625em) {
  .m0\\(xl\\) {
    margin: 0 !important;
  }

  .mt0\\(xl\\) {
    margin-top: 0 !important;
  }

  .mr0\\(xl\\) {
    margin-right: 0 !important;
  }

  .mb0\\(xl\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(xl\\) {
    margin-left: 0 !important;
  }

  .mv0\\(xl\\) {
    margin-block: 0 !important;
  }

  .mh0\\(xl\\) {
    margin-inline: 0 !important;
  }

  .m--\\(xl\\) {
    margin: .313rem !important;
  }

  .mt--\\(xl\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(xl\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(xl\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(xl\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(xl\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(xl\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(xl\\) {
    margin: .625rem !important;
  }

  .mt-\\(xl\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(xl\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(xl\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(xl\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(xl\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(xl\\) {
    margin-inline: .625rem !important;
  }

  .m\\(xl\\) {
    margin: 1.25rem !important;
  }

  .mt\\(xl\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(xl\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(xl\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(xl\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(xl\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(xl\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(xl\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(xl\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(xl\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(xl\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(xl\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(xl\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(xl\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(xl\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(xl\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(xl\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(xl\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(xl\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(xl\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(xl\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(xl\\) {
    padding: 0 !important;
  }

  .pt0\\(xl\\) {
    padding-top: 0 !important;
  }

  .pr0\\(xl\\) {
    padding-right: 0 !important;
  }

  .pb0\\(xl\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(xl\\) {
    padding-left: 0 !important;
  }

  .pv0\\(xl\\) {
    padding-block: 0 !important;
  }

  .ph0\\(xl\\) {
    padding-inline: 0 !important;
  }

  .p--\\(xl\\) {
    padding: .313rem !important;
  }

  .pt--\\(xl\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(xl\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(xl\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(xl\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(xl\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(xl\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(xl\\) {
    padding: .625rem !important;
  }

  .pt-\\(xl\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(xl\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(xl\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(xl\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(xl\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(xl\\) {
    padding-inline: .625rem !important;
  }

  .p\\(xl\\) {
    padding: 1.25rem !important;
  }

  .pt\\(xl\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(xl\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(xl\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(xl\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(xl\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(xl\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(xl\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(xl\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(xl\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(xl\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(xl\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(xl\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(xl\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(xl\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(xl\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(xl\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(xl\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(xl\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(xl\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(xl\\) {
    padding-inline: 5rem !important;
  }
}

.u-gap0 {
  gap: 0 !important;
}

.u-gap-- {
  gap: .313rem !important;
}

.u-gap- {
  gap: .625rem !important;
}

.u-gap {
  gap: 1.25rem !important;
}

.u-gap\\+ {
  gap: 2.5rem !important;
}

.u-gap\\+\\+ {
  gap: 5rem !important;
}

@media screen and (width <= 46.9375em) {
  .u-gap0\\(s\\) {
    gap: 0 !important;
  }

  .u-gap--\\(s\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(s\\) {
    gap: .625rem !important;
  }

  .u-gap\\(s\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(s\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(s\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-gap0\\(m\\) {
    gap: 0 !important;
  }

  .u-gap--\\(m\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(m\\) {
    gap: .625rem !important;
  }

  .u-gap\\(m\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(m\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(m\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 47em), print {
  .u-gap0\\(\\!s\\) {
    gap: 0 !important;
  }

  .u-gap--\\(\\!s\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(\\!s\\) {
    gap: .625rem !important;
  }

  .u-gap\\(\\!s\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(\\!s\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(\\!s\\) {
    gap: 5rem !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-gap0\\(\\!l\\) {
    gap: 0 !important;
  }

  .u-gap--\\(\\!l\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(\\!l\\) {
    gap: .625rem !important;
  }

  .u-gap\\(\\!l\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(\\!l\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(\\!l\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 75em), print {
  .u-gap0\\(l\\) {
    gap: 0 !important;
  }

  .u-gap--\\(l\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(l\\) {
    gap: .625rem !important;
  }

  .u-gap\\(l\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(l\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(l\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-gap0\\(xl\\) {
    gap: 0 !important;
  }

  .u-gap--\\(xl\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(xl\\) {
    gap: .625rem !important;
  }

  .u-gap\\(xl\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(xl\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(xl\\) {
    gap: 5rem !important;
  }
}

.u-1\\/1 {
  width: 100% !important;
}

.u-1\\/2 {
  flex: none !important;
  width: 50% !important;
}

.u-2\\/2 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/3 {
  flex: none !important;
  width: 33.3333% !important;
}

.u-2\\/3 {
  flex: none !important;
  width: 66.6667% !important;
}

.u-3\\/3 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/4 {
  flex: none !important;
  width: 25% !important;
}

.u-2\\/4 {
  flex: none !important;
  width: 50% !important;
}

.u-3\\/4 {
  flex: none !important;
  width: 75% !important;
}

.u-4\\/4 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/5 {
  flex: none !important;
  width: 20% !important;
}

.u-2\\/5 {
  flex: none !important;
  width: 40% !important;
}

.u-3\\/5 {
  flex: none !important;
  width: 60% !important;
}

.u-4\\/5 {
  flex: none !important;
  width: 80% !important;
}

.u-5\\/5 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/10 {
  flex: none !important;
  width: 10% !important;
}

.u-2\\/10 {
  flex: none !important;
  width: 20% !important;
}

.u-3\\/10 {
  flex: none !important;
  width: 30% !important;
}

.u-4\\/10 {
  flex: none !important;
  width: 40% !important;
}

.u-5\\/10 {
  flex: none !important;
  width: 50% !important;
}

.u-6\\/10 {
  flex: none !important;
  width: 60% !important;
}

.u-7\\/10 {
  flex: none !important;
  width: 70% !important;
}

.u-8\\/10 {
  flex: none !important;
  width: 80% !important;
}

.u-9\\/10 {
  flex: none !important;
  width: 90% !important;
}

.u-10\\/10 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/24 {
  flex: none !important;
  width: 4.16667% !important;
}

.u-2\\/24 {
  flex: none !important;
  width: 8.33333% !important;
}

.u-3\\/24 {
  flex: none !important;
  width: 12.5% !important;
}

.u-4\\/24 {
  flex: none !important;
  width: 16.6667% !important;
}

.u-5\\/24 {
  flex: none !important;
  width: 20.8333% !important;
}

.u-6\\/24 {
  flex: none !important;
  width: 25% !important;
}

.u-7\\/24 {
  flex: none !important;
  width: 29.1667% !important;
}

.u-8\\/24 {
  flex: none !important;
  width: 33.3333% !important;
}

.u-9\\/24 {
  flex: none !important;
  width: 37.5% !important;
}

.u-10\\/24 {
  flex: none !important;
  width: 41.6667% !important;
}

.u-11\\/24 {
  flex: none !important;
  width: 45.8333% !important;
}

.u-12\\/24 {
  flex: none !important;
  width: 50% !important;
}

.u-13\\/24 {
  flex: none !important;
  width: 54.1667% !important;
}

.u-14\\/24 {
  flex: none !important;
  width: 58.3333% !important;
}

.u-15\\/24 {
  flex: none !important;
  width: 62.5% !important;
}

.u-16\\/24 {
  flex: none !important;
  width: 66.6667% !important;
}

.u-17\\/24 {
  flex: none !important;
  width: 70.8333% !important;
}

.u-18\\/24 {
  flex: none !important;
  width: 75% !important;
}

.u-19\\/24 {
  flex: none !important;
  width: 79.1667% !important;
}

.u-20\\/24 {
  flex: none !important;
  width: 83.3333% !important;
}

.u-21\\/24 {
  flex: none !important;
  width: 87.5% !important;
}

.u-22\\/24 {
  flex: none !important;
  width: 91.6667% !important;
}

.u-23\\/24 {
  flex: none !important;
  width: 95.8333% !important;
}

.u-24\\/24 {
  flex: none !important;
  width: 100% !important;
}

@media screen and (width <= 46.9375em) {
  .u-1\\/1\\(s\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(s\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(s\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(s\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(s\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(s\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(s\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(s\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(s\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(s\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(s\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(s\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(s\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(s\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(s\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(s\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(s\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(s\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(s\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(s\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(s\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(s\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(s\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(s\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(s\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(s\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(s\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(s\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(s\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(s\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(s\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(s\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(s\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(s\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(s\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(s\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(s\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(s\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(s\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-1\\/1\\(m\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(m\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(m\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(m\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(m\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(m\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(m\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(m\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(m\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(m\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(m\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(m\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(m\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(m\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(m\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(m\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(m\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(m\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(m\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(m\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(m\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(m\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(m\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(m\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(m\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(m\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(m\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(m\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(m\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(m\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(m\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(m\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(m\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(m\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(m\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(m\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(m\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(m\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(m\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(m\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(m\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(m\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(m\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width >= 47em), print {
  .u-1\\/1\\(\\!s\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(\\!s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(\\!s\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(\\!s\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(\\!s\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(\\!s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(\\!s\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(\\!s\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(\\!s\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(\\!s\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(\\!s\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(\\!s\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(\\!s\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(\\!s\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(\\!s\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(\\!s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(\\!s\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(\\!s\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(\\!s\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(\\!s\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(\\!s\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(\\!s\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(\\!s\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(\\!s\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(\\!s\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(\\!s\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(\\!s\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(\\!s\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(\\!s\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(\\!s\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(\\!s\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(\\!s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(\\!s\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(\\!s\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(\\!s\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(\\!s\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(\\!s\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(\\!s\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(\\!s\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(\\!s\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(\\!s\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(\\!s\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(\\!s\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-1\\/1\\(\\!l\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(\\!l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(\\!l\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(\\!l\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(\\!l\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(\\!l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(\\!l\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(\\!l\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(\\!l\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(\\!l\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(\\!l\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(\\!l\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(\\!l\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(\\!l\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(\\!l\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(\\!l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(\\!l\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(\\!l\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(\\!l\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(\\!l\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(\\!l\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(\\!l\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(\\!l\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(\\!l\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(\\!l\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(\\!l\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(\\!l\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(\\!l\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(\\!l\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(\\!l\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(\\!l\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(\\!l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(\\!l\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(\\!l\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(\\!l\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(\\!l\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(\\!l\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(\\!l\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(\\!l\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(\\!l\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(\\!l\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(\\!l\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(\\!l\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width >= 75em), print {
  .u-1\\/1\\(l\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(l\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(l\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(l\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(l\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(l\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(l\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(l\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(l\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(l\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(l\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(l\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(l\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(l\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(l\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(l\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(l\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(l\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(l\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(l\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(l\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(l\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(l\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(l\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(l\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(l\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(l\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(l\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(l\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(l\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(l\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(l\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(l\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(l\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(l\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(l\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(l\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(l\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(l\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-1\\/1\\(xl\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(xl\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(xl\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(xl\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(xl\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(xl\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(xl\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(xl\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(xl\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(xl\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(xl\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(xl\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(xl\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(xl\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(xl\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(xl\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(xl\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(xl\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(xl\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(xl\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(xl\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(xl\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(xl\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(xl\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(xl\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(xl\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(xl\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(xl\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(xl\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(xl\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(xl\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(xl\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(xl\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(xl\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(xl\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(xl\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(xl\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(xl\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(xl\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(xl\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(xl\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(xl\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(xl\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }
}

.u-display--inline {
  display: inline !important;
}

.u-display--inline-block {
  display: inline-block !important;
}

.u-display--block {
  display: block !important;
}

.u-display--flex {
  display: flex !important;
}

.u-display--inline-flex {
  display: inline-flex !important;
}

.u-display--none {
  display: none !important;
}

@media screen and (width <= 46.9375em) {
  .u-display--inline\\(s\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(s\\) {
    display: inline-block !important;
  }

  .u-display--block\\(s\\) {
    display: block !important;
  }

  .u-display--flex\\(s\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(s\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(s\\) {
    display: none !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-display--inline\\(m\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(m\\) {
    display: inline-block !important;
  }

  .u-display--block\\(m\\) {
    display: block !important;
  }

  .u-display--flex\\(m\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(m\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(m\\) {
    display: none !important;
  }
}

@media screen and (width >= 47em), print {
  .u-display--inline\\(\\!s\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(\\!s\\) {
    display: inline-block !important;
  }

  .u-display--block\\(\\!s\\) {
    display: block !important;
  }

  .u-display--flex\\(\\!s\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(\\!s\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(\\!s\\) {
    display: none !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-display--inline\\(\\!l\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(\\!l\\) {
    display: inline-block !important;
  }

  .u-display--block\\(\\!l\\) {
    display: block !important;
  }

  .u-display--flex\\(\\!l\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(\\!l\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(\\!l\\) {
    display: none !important;
  }
}

@media screen and (width >= 75em), print {
  .u-display--inline\\(l\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(l\\) {
    display: inline-block !important;
  }

  .u-display--block\\(l\\) {
    display: block !important;
  }

  .u-display--flex\\(l\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(l\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(l\\) {
    display: none !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-display--inline\\(xl\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(xl\\) {
    display: inline-block !important;
  }

  .u-display--block\\(xl\\) {
    display: block !important;
  }

  .u-display--flex\\(xl\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(xl\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(xl\\) {
    display: none !important;
  }
}

.u-display--flow-root {
  display: flow-root !important;
}

.u-position--absolute {
  position: absolute !important;
}

.u-position--relative {
  position: relative !important;
}

.u-position--fixed {
  position: fixed !important;
}

.u-position--static {
  position: static !important;
}

.u-text-align--left {
  text-align: left !important;
}

.u-text-align--right {
  text-align: right !important;
}

.u-text-align--center {
  text-align: center !important;
}

@media screen and (width <= 46.9375em) {
  .u-text-align--left\\(s\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(s\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(s\\) {
    text-align: center !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-text-align--left\\(m\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(m\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(m\\) {
    text-align: center !important;
  }
}

@media screen and (width >= 47em), print {
  .u-text-align--left\\(\\!s\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(\\!s\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(\\!s\\) {
    text-align: center !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-text-align--left\\(\\!l\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(\\!l\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(\\!l\\) {
    text-align: center !important;
  }
}

@media screen and (width >= 75em), print {
  .u-text-align--left\\(l\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(l\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(l\\) {
    text-align: center !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-text-align--left\\(xl\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(xl\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(xl\\) {
    text-align: center !important;
  }
}

.u-font-weight--normal {
  font-weight: normal !important;
}

.u-font-weight--bold {
  font-weight: bold !important;
}

.u-font-style--normal {
  font-style: normal !important;
}

.u-font-style--italic {
  font-style: italic !important;
}

.u-text-decoration--underline {
  text-decoration: underline !important;
}

.u-text-decoration--line-through {
  text-decoration: line-through !important;
}

.u-text-decoration--none {
  text-decoration: none !important;
}

.u-border--none {
  border: none !important;
}

.u-border-color--inherit {
  border-color: inherit !important;
}

.u-line-height--normal {
  line-height: normal !important;
}

.u-white-space--nowrap {
  white-space: nowrap !important;
}

.u-white-space--normal {
  white-space: normal !important;
}

@media screen and (width <= 46.9375em) {
  .u-white-space--nowrap\\(s\\) {
    white-space: nowrap !important;
  }

  .u-white-space--normal\\(s\\) {
    white-space: normal !important;
  }
}

@media screen and (width >= 47em), print {
  .u-white-space--nowrap\\(\\!s\\) {
    white-space: nowrap !important;
  }

  .u-white-space--normal\\(\\!s\\) {
    white-space: normal !important;
  }
}

@media screen and (width >= 75em), print {
  .u-white-space--nowrap\\(l\\) {
    white-space: nowrap !important;
  }

  .u-white-space--normal\\(l\\) {
    white-space: normal !important;
  }
}

.u-opacity--0 {
  opacity: 0 !important;
}

.u-opacity--25 {
  opacity: .25 !important;
}

.u-opacity--50 {
  opacity: .5 !important;
}

.u-opacity--75 {
  opacity: .75 !important;
}

.u-opacity--90 {
  opacity: .9 !important;
}

.u-cursor--pointer {
  cursor: pointer !important;
}

.u-cursor--default {
  cursor: default !important;
}

.u-visibility--hidden {
  visibility: hidden !important;
}

.u-overflow--hidden {
  overflow: hidden !important;
}

.u-margin-left--auto {
  margin-left: auto !important;
}

@media screen and (width >= 47em), print {
  .u-margin-left--auto\\(\\!s\\) {
    margin-left: auto !important;
  }
}

.u-width--auto {
  width: auto !important;
}

.u-flex-wrap--nowrap {
  flex-wrap: nowrap !important;
}

.u-flex-wrap--wrap {
  flex-wrap: wrap !important;
}

@media screen and (width <= 46.9375em) {
  .u-flex-wrap--nowrap\\(s\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(s\\) {
    flex-wrap: wrap !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-flex-wrap--nowrap\\(m\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(m\\) {
    flex-wrap: wrap !important;
  }
}

@media screen and (width >= 47em), print {
  .u-flex-wrap--nowrap\\(\\!s\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(\\!s\\) {
    flex-wrap: wrap !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-flex-wrap--nowrap\\(\\!l\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(\\!l\\) {
    flex-wrap: wrap !important;
  }
}

@media screen and (width >= 75em), print {
  .u-flex-wrap--nowrap\\(l\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(l\\) {
    flex-wrap: wrap !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-flex-wrap--nowrap\\(xl\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(xl\\) {
    flex-wrap: wrap !important;
  }
}

.u-order---1 {
  order: -1 !important;
}

.u-order--1 {
  order: 1 !important;
}

@media screen and (width <= 46.9375em) {
  .u-order---1\\(s\\) {
    order: -1 !important;
  }

  .u-order--1\\(s\\) {
    order: 1 !important;
  }
}

@media screen and (width >= 47em), print {
  .u-order---1\\(\\!s\\) {
    order: -1 !important;
  }

  .u-order--1\\(\\!s\\) {
    order: 1 !important;
  }
}

.c-rating-wrapper {
  background-color: var(--color-grey--x-light);
  border-radius: var(--border-radius-s);
  flex-basis: 295px;
}

.c-rating-item--title {
  align-self: center;
}

.c-rating-item--value {
  padding: var(--spacing);
}

.c-rating-total {
  z-index: 1;
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
  text-align: center;
  color: var(--color-white);
  width: 3.8rem;
  height: 3.8rem;
  line-height: 3.8rem;
  display: inline-block;
  position: relative;
}

@media screen and (width <= 46.9375em) {
  .c-rating-total {
    width: 3.3rem;
    height: 3.3rem;
    line-height: 3.3rem;
  }
}

.c-rating-total:not(.c-rating-total--transparent):after {
  content: "";
  z-index: -1;
  border-radius: var(--border-radius-xl);
  background-color: var(--color-gradient2--from);
  position: absolute;
  inset: 15%;
}

.c-rating-total__svg {
  color: var(--color-gradient2--from);
  z-index: -1;
  display: block;
  position: absolute;
  inset: 0;
}

.c-rating-total__svg svg {
  width: 100%;
  height: 100%;
  display: block;
}

.c-rating-total--tab {
  width: 3.8rem;
  height: 3.8rem;
  line-height: 3.8rem;
}

.c-rating-circle {
  border-radius: var(--border-radius-xl);
  text-align: center;
  color: var(--color-brand--support);
  background-color: var(--color-white);
  border: 2px solid;
  width: 2.6rem;
  height: 2.6rem;
  line-height: 2.4rem;
  display: inline-block;
}
`;


class $bf34a732a5055808$var$WJSupplierReviews extends (0, $baeea1393dcde116$export$3f2f9f5909897157) {
    static get properties() {
        return {
            userRatings: {
                type: Object,
                attribute: "data-user-ratings"
            }
        };
    }
    render() {
        let ratings = this.userRatings;
        const reviewPercentage = ratings?.additonalCustomerRatings.averagePercent ? Math.ceil(ratings?.additonalCustomerRatings.averagePercent) : null;
        const reviewRating = (parseFloat(reviewPercentage) / 10).toString().split(".");
        if (!ratings) return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)``;
        const totalReviews = new Intl.NumberFormat("de-DE");
        const ratingsTitle = ratings.caption.text;
        const acr = ratings.additonalCustomerRatings;
        return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`
  <h5 class="mb-">${ratingsTitle}</h5>

<div class="layout layout--flush">
  <div class="layout__item c-rating-wrapper pv- ph">
    <div class="u-bg-color-grey--x-light u-border-radius-">

      <div class="layout layout--middle layout--flush u-flex-wrap--nowrap mb--">
        <div class="layout__item layout__item--flex-fill layout__item--flex-center u-font-weight--bold">Paketbewertung<span class="c-icon-info"></span></div>
        <div class="c-tooltip">
        </div>
        <div class="layout__item u-1/4 u-text-align--center pv-">
          <span class="c-rating-total c-spec c-spec--amount">
            ${reviewRating[0]}<span class="c-spec__decimals">.${reviewRating[1]}</span>
            <span class="c-rating-total__svg"><svg viewBox="0 0 61 61" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M28.195 58.036l-1.345.559a5.354 5.354 0 01-6.175-1.522l-.93-1.12a6 6 0 00-4.083-2.143l-1.45-.13a5.354 5.354 0 01-4.76-4.217l-.304-1.424a6 6 0 00-2.619-3.794l-1.224-.789A5.354 5.354 0 013.05 37.51l.393-1.401a6 6 0 00-.556-4.577l-.717-1.267a5.354 5.354 0 01.767-6.314l1-1.059a6 6 0 001.634-4.31l-.046-1.456a5.354 5.354 0 013.613-5.234l1.377-.473a6 6 0 003.451-3.057l.635-1.31a5.354 5.354 0 015.632-2.956l1.439.221a6 6 0 004.477-1.103l1.171-.865a5.354 5.354 0 016.36 0l1.171.865a6 6 0 004.477 1.103l1.44-.221a5.354 5.354 0 015.63 2.956l.636 1.31a6 6 0 003.45 3.057l1.378.473a5.354 5.354 0 013.613 5.234l-.046 1.455a6 6 0 001.635 4.311l1 1.059a5.354 5.354 0 01.766 6.314l-.717 1.267a6 6 0 00-.556 4.577l.393 1.401a5.354 5.354 0 01-2.255 5.947l-1.224.789a6 6 0 00-2.62 3.794l-.303 1.424a5.354 5.354 0 01-4.76 4.218l-1.45.13a6 6 0 00-4.083 2.142l-.93 1.12a5.354 5.354 0 01-6.175 1.522l-1.345-.56a6 6 0 00-4.61 0z"
                  fill="#61A38D" class="u-svg-fill"></path>
                <circle stroke="#F7F7F7" cx="30.5" cy="30.5" r="22" stroke-width="2"></circle>
              </svg></span>
          </span>
        </div>
      </div>
      <hr class="mb- mt0" />

      <div class="layout layout--middle layout--flush u-flex-wrap--nowrap mb--">
        <div class="layout__item layout__item--flex-fill layout__item--flex-center js-tooltip-trigger">
          ${acr.price.caption.text}<span class="c-icon-info"></span></div>
        <div class="c-tooltip"></div>
        <div class="layout__item u-1/4 u-text-align--center p-"><span
            class="c-rating-circle c-rating-circle--tab">${(acr.price.percent / 10).toFixed(1)}</span></div>
      </div>

      <div class="layout layout--middle layout--flush u-flex-wrap--nowrap mb--">
        <div class="layout__item layout__item--flex-fill layout__item--flex-center js-tooltip-trigger">
          ${acr.service.caption.text}<span class="c-icon-info"></span></div>
        <div class="c-tooltip"></div>
        <div class="layout__item u-1/4 u-text-align--center p-"><span
            class="c-rating-circle c-rating-circle--tab">${(acr.service.percent / 10).toFixed(1)}</span></div>
      </div>

      <div class="layout layout--middle layout--flush u-flex-wrap--nowrap">
        <div class="layout__item layout__item--flex-fill layout__item--flex-center js-tooltip-trigger">
          ${acr.switching.caption.text}<span class="c-icon-info"></span></div>
        <div class="c-tooltip"></div>
        <div class="layout__item u-1/4 u-text-align--center p-"><span
            class="c-rating-circle c-rating-circle--tab">${(acr.switching.percent / 10).toFixed(1)}</span></div>
      </div>

    </div>
  </div>
</div>
<div class="mt"><strong>${ratings.switchAgain.percent}%</strong> von <strong>${totalReviews.format(ratings.switchAgain.totalReviews)}</strong> Kunden würden wieder zu diesem Anbieter wechseln.</div>
    `;
    }
}
$bf34a732a5055808$var$WJSupplierReviews.styles = [
    (0, $5eb9359b5e26429a$export$e164c590bcba2aaf)
];
const $bf34a732a5055808$export$a021e1e27616a319 = ()=>{
    window.customElements.define("wj-supplier-reviews", $bf34a732a5055808$var$WJSupplierReviews);
};



class $c4c9c209874b881e$var$BCPackageSupplierDetails extends (0, $baeea1393dcde116$export$3f2f9f5909897157) {
    constructor(...args){
        super(...args);
        this.data = null;
        this.packageTemplate = null;
    }
    render() {
        return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`
      <h3>Leveranciersdata</h3>
      <p class="explanation"></p>
    `;
    }
}
const $c4c9c209874b881e$export$c37cb1cb204f7ad7 = ()=>{
    window.customElements.define("bc-package-supplierdetails", $c4c9c209874b881e$var$BCPackageSupplierDetails);
};


const $c58df8985e4b3426$export$ac6b017bf61c38a6 = ()=>{
    (0, $f0d4bc948f2bef33$export$e4154d8a482e2d3a)();
    (0, $bf34a732a5055808$export$a021e1e27616a319)();
    (0, $57570d85ec6a9fac$export$52903f8746ee997)();
    (0, $25dde1ac1c25d527$export$99daf0be1c6fc316)();
    (0, $c4c9c209874b881e$export$c37cb1cb204f7ad7)();
    (0, $49d28191c471e76d$export$6c8cb28fd3747dfa)();
};


(0, $c58df8985e4b3426$export$ac6b017bf61c38a6)();
document.addEventListener("DOMContentLoaded", async ()=>{
    (0, $9ad4a19502edd57e$export$394e73e0cf9f022a)();
});

})();
//# sourceMappingURL=comparison.js.map
